var Jo = Object.defineProperty, Qo = Object.defineProperties;
var er = Object.getOwnPropertyDescriptors;
var yo = Object.getOwnPropertySymbols;
var tr = Object.prototype.hasOwnProperty, nr = Object.prototype.propertyIsEnumerable;
var ko = (e, n, t) => n in e ? Jo(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, oe = (e, n) => {
  for (var t in n || (n = {}))
    tr.call(n, t) && ko(e, t, n[t]);
  if (yo)
    for (var t of yo(n))
      nr.call(n, t) && ko(e, t, n[t]);
  return e;
}, Mt = (e, n) => Qo(e, er(n));
var z = (e, n, t) => new Promise((s, a) => {
  var d = (w) => {
    try {
      f(t.next(w));
    } catch (v) {
      a(v);
    }
  }, c = (w) => {
    try {
      f(t.throw(w));
    } catch (v) {
      a(v);
    }
  }, f = (w) => w.done ? s(w.value) : Promise.resolve(w.value).then(d, c);
  f((t = t.apply(e, n)).next());
});
import { getMarkdown as xo, parseMarkdownToStructure as or, setDefaultMathOptions as rr } from "stream-markdown-parser";
import { defineComponent as F, createElementBlock as y, openBlock as m, withMemo as fn, createVNode as ct, unref as $, createElementVNode as h, Fragment as ue, renderList as Be, toDisplayString as se, ref as M, onMounted as io, watch as U, onBeforeUnmount as hn, normalizeClass as O, computed as N, nextTick as he, createBlock as ye, Teleport as Ho, Transition as zn, withCtx as en, withDirectives as Rn, normalizeStyle as ut, vShow as Nn, createApp as ar, h as Gn, inject as ir, provide as sr, createCommentVNode as fe, renderSlot as Tt, shallowRef as lr, readonly as cr, defineAsyncComponent as vn, resolveDynamicComponent as Fe, useAttrs as ur, mergeProps as Kt, isMemoSame as jo, onUnmounted as dr, toHandlers as bo, withModifiers as mr, markRaw as Mo, reactive as Xn } from "vue";
import { autoUpdate as Co, offset as fr, flip as hr, shift as vr, computePosition as pr } from "@floating-ui/dom";
const gr = ["cite"], wr = /* @__PURE__ */ F({
  __name: "BlockquoteNode",
  props: {
    node: {},
    indexKey: {},
    typewriter: { type: Boolean },
    customId: {}
  },
  emits: ["copy"],
  setup(e) {
    const n = e;
    return (t, s) => (m(), y("blockquote", {
      class: "blockquote",
      dir: "auto",
      cite: e.node.cite
    }, [
      fn([n.node.children], () => ct($(lt), {
        "index-key": `blockquote-${n.indexKey}`,
        nodes: n.node.children || [],
        "custom-id": n.customId,
        typewriter: n.typewriter,
        onCopy: s[0] || (s[0] = (a) => t.$emit("copy", a))
      }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"]), s, 1)
    ], 8, gr));
  }
}), Z = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [s, a] of n)
    t[s] = a;
  return t;
}, Mn = /* @__PURE__ */ Z(wr, [["__scopeId", "data-v-eeadc8a3"]]);
Mn.install = (e) => {
  e.component(Mn.__name, Mn);
};
const yr = { class: "checkbox-node" }, kr = ["checked"], xr = /* @__PURE__ */ F({
  __name: "CheckboxNode",
  props: {
    node: {}
  },
  setup(e) {
    return (n, t) => (m(), y("span", yr, [
      h("input", {
        type: "checkbox",
        checked: e.node.checked,
        disabled: "",
        class: "checkbox-input"
      }, null, 8, kr)
    ]));
  }
}), _t = /* @__PURE__ */ Z(xr, [["__scopeId", "data-v-8dc6c46f"]]);
_t.install = (e) => {
  e.component(_t.__name, _t);
};
const br = { class: "definition-list" }, Mr = { class: "definition-term" }, Cr = { class: "definition-desc" }, Tr = /* @__PURE__ */ F({
  __name: "DefinitionListNode",
  props: {
    node: {},
    indexKey: {},
    typewriter: { type: Boolean },
    customId: {}
  },
  emits: ["copy"],
  setup(e) {
    const n = e;
    return (t, s) => (m(), y("dl", br, [
      (m(!0), y(ue, null, Be(n.node.items, (a, d) => (m(), y(ue, { key: d }, [
        h("dt", Mr, [
          ct($(lt), {
            "index-key": `definition-term-${n.indexKey}-${d}`,
            nodes: a.term,
            "custom-id": n.customId,
            typewriter: n.typewriter,
            onCopy: s[0] || (s[0] = (c) => t.$emit("copy", c))
          }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"])
        ]),
        h("dd", Cr, [
          ct($(lt), {
            "index-key": `definition-desc-${n.indexKey}-${d}`,
            nodes: a.definition,
            "custom-id": n.customId,
            typewriter: n.typewriter,
            onCopy: s[1] || (s[1] = (c) => t.$emit("copy", c))
          }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"])
        ])
      ], 64))), 128))
    ]));
  }
}), Cn = /* @__PURE__ */ Z(Tr, [["__scopeId", "data-v-f88691d6"]]);
Cn.install = (e) => {
  e.component(Cn.__name, Cn);
};
const _r = { class: "emoji-node" }, Br = /* @__PURE__ */ F({
  __name: "EmojiNode",
  props: {
    node: {}
  },
  setup(e) {
    return (n, t) => (m(), y("span", _r, se(e.node.name), 1));
  }
}), je = /* @__PURE__ */ Z(Br, [["__scopeId", "data-v-de55dc97"]]);
je.install = (e) => {
  e.component(je.__name, je);
};
const Hn = "__global__", Gt = {};
function _l(e, n) {
  typeof e == "string" ? Gt[e] = n || {} : Gt[Hn] = e || {};
}
function Bt(e) {
  return e ? Gt[e] || Gt[Hn] || {} : Gt[Hn] || {};
}
function Bl(e) {
  if (e === Hn)
    throw new Error("removeCustomComponents: use clearGlobalCustomComponents() to clear the global mapping");
  delete Gt[e];
}
function Il() {
  delete Gt[Hn];
}
const Ir = ["id"], $r = ["title"], Sr = /* @__PURE__ */ F({
  __name: "FootnoteReferenceNode",
  props: {
    node: {}
  },
  setup(e) {
    const t = `#footnote-${e.node.id}`;
    function s() {
      if (typeof document == "undefined")
        return;
      const a = document.querySelector(t);
      a ? a.scrollIntoView({ behavior: "smooth" }) : console.warn(`Element with href: ${t} not found`);
    }
    return (a, d) => (m(), y("sup", {
      id: `fnref-${e.node.id}`,
      class: "footnote-reference",
      onClick: s
    }, [
      h("span", {
        href: t,
        title: `查看脚注 ${e.node.id}`,
        class: "footnote-link cursor-pointer"
      }, "[" + se(e.node.id) + "]", 9, $r)
    ], 8, Ir));
  }
}), De = /* @__PURE__ */ Z(Sr, [["__scopeId", "data-v-01af0fee"]]);
De.install = (e) => {
  e.component(De.__name, De);
};
const Er = /* @__PURE__ */ F({
  __name: "HtmlInlineNode",
  props: {
    node: {}
  },
  setup(e) {
    const n = e, t = M(null), s = typeof window != "undefined";
    function a() {
      if (!s || !t.value)
        return;
      const c = t.value;
      c.innerHTML = "";
      const f = document.createElement("template");
      f.innerHTML = n.node.content, c.appendChild(f.content.cloneNode(!0));
    }
    function d() {
      if (!t.value)
        return;
      const c = t.value;
      c.innerHTML = "", c.textContent = n.node.content;
    }
    return io(() => {
      n.node.loading && !n.node.autoClosed ? d() : a();
    }), U(
      () => [n.node.content, n.node.loading, n.node.autoClosed],
      () => {
        n.node.loading && !n.node.autoClosed ? d() : a();
      }
    ), hn(() => {
      t.value && (t.value.innerHTML = "");
    }), (c, f) => (m(), y("span", {
      ref_key: "containerRef",
      ref: t,
      class: O(["html-inline-node", { "html-inline-node--loading": n.node.loading }])
    }, null, 2));
  }
}), Ae = /* @__PURE__ */ Z(Er, [["__scopeId", "data-v-e632756e"]]);
Ae.install = (e) => {
  e.component(Ae.__name, Ae);
};
const Lr = { class: "inline text-[85%] px-1 py-0.5 rounded font-mono bg-secondary whitespace-normal break-words max-w-full before:content-[''] after:content-['']" }, ze = /* @__PURE__ */ F({
  __name: "InlineCodeNode",
  props: {
    node: {}
  },
  setup(e) {
    return (n, t) => (m(), y("code", Lr, se(e.node.code), 1));
  }
});
ze.install = (e) => {
  e.component(ze.__name, ze);
};
const Rr = ["id"], Nr = /* @__PURE__ */ F({
  __name: "Tooltip",
  props: {
    visible: { type: Boolean },
    anchorEl: {},
    content: {},
    placement: {},
    offset: {},
    originX: {},
    originY: {},
    id: {},
    isDark: { type: [Boolean, null] }
  },
  setup(e) {
    const n = e, t = N(() => {
      if (n.isDark !== void 0 && n.isDark !== null)
        return !!n.isDark;
      if (typeof document != "undefined")
        try {
          if (document.documentElement.classList.contains("dark") || window != null && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches)
            return !0;
        } catch (w) {
        }
      return !1;
    }), s = M(null), a = M({ transform: "translate3d(0px, 0px, 0px)", left: "0px", top: "0px" }), d = M(!1);
    let c = null;
    function f() {
      return z(this, null, function* () {
        var C, H;
        if (!n.anchorEl || !s.value)
          return;
        const w = [fr((C = n.offset) != null ? C : 8), hr(), vr({ padding: 8 })], { x: v, y: b } = yield pr(n.anchorEl, s.value, {
          placement: (H = n.placement) != null ? H : "top",
          middleware: w,
          strategy: "fixed"
        });
        a.value.transform = `translate3d(${Math.round(v)}px, ${Math.round(b)}px, 0)`, a.value.left = "0px", a.value.top = "0px";
      });
    }
    return U(
      () => n.visible,
      (w) => z(null, null, function* () {
        if (w)
          if (d.value = !1, yield he(), n.anchorEl && s.value)
            try {
              const v = n.anchorEl.getBoundingClientRect();
              yield f();
              const b = a.value.transform;
              if (n.originX != null && n.originY != null) {
                const C = Math.abs(Number(n.originX) - v.left), H = Math.abs(Number(n.originY) - v.top);
                Math.hypot(C, H) > 120 ? (a.value.transform = `translate3d(${Math.round(n.originX)}px, ${Math.round(n.originY)}px, 0)`, yield he(), d.value = !0, yield he(), a.value.transform = b) : d.value = !0;
              } else
                d.value = !0;
              c = Co(n.anchorEl, s.value, f);
            } catch (v) {
              yield f(), d.value = !0, c = Co(n.anchorEl, s.value, f);
            }
          else
            d.value = !0;
        else
          d.value = !1, c && (c(), c = null);
      })
    ), U([
      () => n.anchorEl,
      () => n.placement,
      () => n.content
    ], () => z(null, null, function* () {
      n.visible && n.anchorEl && s.value && (yield he(), yield f());
    })), hn(() => {
      c && c();
    }), (w, v) => (m(), ye(Ho, { to: "body" }, [
      ct(zn, {
        name: "tooltip",
        appear: ""
      }, {
        default: en(() => [
          Rn(h("div", {
            id: n.id,
            ref_key: "tooltip",
            ref: s,
            style: ut({ position: "fixed", left: a.value.left, top: a.value.top, transform: a.value.transform }),
            class: O(["z-[9999] inline-block text-base py-2 px-3 rounded-md shadow-md whitespace-nowrap pointer-events-none tooltip-element border", [t.value ? "bg-gray-900 text-white border-gray-700 border is-dark" : "bg-white text-gray-900 border-gray-200 border"]]),
            role: "tooltip"
          }, se(e.content), 15, Rr), [
            [Nn, e.visible && d.value]
          ])
        ]),
        _: 1
      })
    ]));
  }
}), Hr = /* @__PURE__ */ Z(Nr, [["__scopeId", "data-v-993f63aa"]]), so = M(!1), Do = M(""), Ao = M("top"), Tn = M(null), jn = M(null), lo = M(null), co = M(null), zo = M(null);
let Yn = null, Un = null;
function Po() {
  Yn && (clearTimeout(Yn), Yn = null), Un && (clearTimeout(Un), Un = null);
}
let To = !1;
function jr() {
  if (To || typeof document == "undefined")
    return;
  To = !0;
  const e = document.createElement("div");
  e.setAttribute("data-singleton-tooltip", "1"), document.body.appendChild(e), ar({
    setup() {
      return () => {
        var t;
        return Gn(Hr, {
          visible: so.value,
          "anchor-el": Tn.value,
          content: Do.value,
          placement: Ao.value,
          id: jn.value,
          originX: lo.value,
          originY: co.value,
          isDark: (t = zo.value) != null ? t : void 0
        });
      };
    }
  }).mount(e);
}
function Dn(e, n, t = "top", s = !1, a, d) {
  if (!e)
    return;
  jr(), Po();
  const c = () => {
    var f, w;
    jn.value = `tooltip-${Date.now()}-${Math.floor(Math.random() * 1e3)}`, Tn.value = e, Do.value = n, Ao.value = t, lo.value = (f = a == null ? void 0 : a.x) != null ? f : null, co.value = (w = a == null ? void 0 : a.y) != null ? w : null, zo.value = typeof d == "boolean" ? d : null, so.value = !0;
    try {
      e.setAttribute("aria-describedby", jn.value);
    } catch (v) {
    }
  };
  s ? c() : Yn = setTimeout(c, 80);
}
function uo(e = !1) {
  Po();
  const n = () => {
    if (Tn.value && jn.value)
      try {
        Tn.value.removeAttribute("aria-describedby");
      } catch (t) {
      }
    so.value = !1, Tn.value = null, jn.value = null, lo.value = null, co.value = null;
  };
  e ? n() : Un = setTimeout(n, 120);
}
function Dr(e) {
  return (e.split(".").pop() || e).replace(/[_-]/g, " ").replace(/([A-Z])/g, " $1").replace(/\s+/g, " ").replace(/\b\w/g, (t) => t.toUpperCase()).trim();
}
const Vo = {
  "common.copy": "Copy",
  "common.copySuccess": "Copied",
  "common.decrease": "Decrease",
  "common.reset": "Reset",
  "common.increase": "Increase",
  "common.expand": "Expand",
  "common.collapse": "Collapse",
  "common.preview": "Preview",
  "common.source": "Source",
  "common.export": "Export",
  "common.open": "Open",
  "common.zoomIn": "Zoom in",
  "common.zoomOut": "Zoom out",
  "common.resetZoom": "Reset zoom",
  "image.loadError": "Image failed to load",
  "image.loading": "Loading image..."
};
function $l(e) {
  Object.assign(Vo, e);
}
function mo() {
  try {
    const n = globalThis.$vueI18nUse || null;
    if (n && typeof n == "function")
      try {
        const t = n();
        if (t && typeof t.t == "function")
          return { t: t.t.bind(t) };
      } catch (t) {
      }
  } catch (n) {
  }
  const e = (n) => {
    var t;
    return (t = Vo[n]) != null ? t : Dr(n);
  };
  return z(null, null, function* () {
    try {
      const n = yield import("vue-i18n"), t = n.useI18n || n.default && n.default.useI18n;
      if (t && typeof t == "function")
        try {
          const s = t();
          if (s && typeof s.t == "function")
            try {
              globalThis.$vueI18nUse = () => s;
            } catch (a) {
            }
        } catch (s) {
        }
    } catch (n) {
    }
  }), { t: e };
}
const Oo = Symbol("ViewportPriority");
function Ar(e, n) {
  const t = typeof window != "undefined" && typeof document != "undefined", s = typeof n == "boolean" ? M(n) : n;
  let a = null, d = null;
  const c = /* @__PURE__ */ new WeakMap();
  function f(v) {
    var H, A, S;
    if (a || !t)
      return a;
    if (typeof IntersectionObserver == "undefined")
      return null;
    const b = (H = e == null ? void 0 : e(v != null ? v : null)) != null ? H : null, C = d || {};
    return a = new IntersectionObserver((ee) => {
      for (const j of ee) {
        const T = c.get(j.target);
        if (!T)
          continue;
        if (j.isIntersecting || j.intersectionRatio > 0) {
          if (!T.visible.value) {
            T.visible.value = !0;
            try {
              T.resolve();
            } catch (G) {
            }
          }
          a == null || a.unobserve(j.target), c.delete(j.target);
        }
      }
    }, {
      root: b,
      rootMargin: (A = C.rootMargin) != null ? A : "300px",
      // prefetch slightly before entering viewport
      threshold: (S = C.threshold) != null ? S : 0
    }), a;
  }
  const w = (v, b) => {
    const C = M(!1);
    let H = !1, A;
    const S = new Promise((T) => {
      A = () => {
        H || (H = !0, T());
      };
    }), ee = () => {
      try {
        a == null || a.unobserve(v);
      } catch (T) {
      }
      c.delete(v);
    };
    if (!t || !s.value)
      return C.value = !0, A(), { isVisible: C, whenVisible: S, destroy: ee };
    !d && b && (d = oe({}, b));
    const j = f(v);
    return j ? (c.set(v, { resolve: A, visible: C }), j.observe(v), { isVisible: C, whenVisible: S, destroy: ee }) : (C.value = !0, A(), { isVisible: C, whenVisible: S, destroy: ee });
  };
  return sr(Oo, w), w;
}
function fo() {
  const e = ir(Oo, void 0);
  if (e)
    return e;
  const n = /* @__PURE__ */ new WeakMap();
  let t = null;
  const s = () => t || (typeof window == "undefined" || typeof IntersectionObserver == "undefined" ? null : (t = new IntersectionObserver((d) => {
    for (const c of d) {
      const f = n.get(c.target);
      if (!f)
        continue;
      if (c.isIntersecting || c.intersectionRatio > 0) {
        if (!f.visible.value) {
          f.visible.value = !0;
          try {
            f.resolve();
          } catch (v) {
          }
        }
        t == null || t.unobserve(c.target), n.delete(c.target);
      }
    }
  }, { root: null, rootMargin: "300px", threshold: 0 }), t));
  return (d) => {
    const c = M(!1);
    let f = !1, w;
    const v = new Promise((H) => {
      w = () => {
        f || (f = !0, H());
      };
    }), b = () => {
      try {
        t == null || t.unobserve(d);
      } catch (H) {
      }
      n.delete(d);
    }, C = s();
    return C ? (n.set(d, { resolve: w, visible: c }), C.observe(d), { isVisible: c, whenVisible: v, destroy: b }) : (c.value = !0, w(), { isVisible: c, whenVisible: v, destroy: b });
  };
}
const zr = { class: "relative inline-block" }, Pr = ["src", "alt", "title", "loading", "tabindex", "aria-label"], Vr = { class: "text-sm whitespace-nowrap" }, Or = {
  key: 1,
  class: "text-sm text-gray-500"
}, Kr = {
  key: "error",
  class: "px-4 py-2 bg-gray-100 flex items-center justify-center rounded-lg gap-2 text-red-500"
}, Fr = { class: "text-sm whitespace-nowrap" }, Wr = {
  key: 0,
  class: "mt-2 text-sm text-gray-500 italic"
}, Xr = /* @__PURE__ */ F({
  __name: "ImageNode",
  props: {
    node: {},
    fallbackSrc: { default: "" },
    showCaption: { type: Boolean, default: !1 },
    lazy: { type: Boolean, default: !0 },
    svgMinHeight: { default: "12rem" },
    usePlaceholder: { type: Boolean, default: !0 }
  },
  emits: ["load", "error", "click"],
  setup(e, { emit: n }) {
    const t = e, s = n, a = M(!1), d = M(!1), c = M(!1), f = M(null), w = fo(), v = M(null), b = M(typeof window == "undefined");
    typeof window != "undefined" && U(
      () => f.value,
      (re) => {
        var ne;
        if ((ne = v.value) == null || ne.destroy(), v.value = null, !re) {
          b.value = !1;
          return;
        }
        const G = w(re, { rootMargin: "400px" });
        v.value = G, b.value = G.isVisible.value, G.whenVisible.then(() => {
          b.value = !0;
        });
      },
      { immediate: !0 }
    ), hn(() => {
      var re;
      (re = v.value) == null || re.destroy(), v.value = null;
    });
    const C = N(() => d.value && t.fallbackSrc ? t.fallbackSrc : t.node.src), H = N(() => !t.lazy || b.value), A = N(() => /\.svg(?:\?|$)/i.test(C.value));
    function S() {
      t.fallbackSrc && !c.value ? (c.value = !0, d.value = !0) : (d.value = !0, s("error", t.node.src));
    }
    function ee() {
      a.value = !0, d.value = !1, s("load", C.value);
    }
    function j(re) {
      re.preventDefault(), !(!a.value || d.value) && s("click", [re, C.value]);
    }
    const { t: T } = mo();
    return U(C, () => {
      a.value = !1, d.value = !1;
    }), (re, G) => (m(), y("figure", {
      ref_key: "figureRef",
      ref: f,
      class: "text-center my-8"
    }, [
      h("div", zr, [
        ct(zn, {
          name: "img-switch",
          mode: "out-in"
        }, {
          default: en(() => {
            var ne, de, D, We, ce;
            return [
              !e.node.loading && !d.value && H.value ? (m(), y("img", {
                key: "image",
                src: C.value,
                alt: String((de = (ne = t.node.alt) != null ? ne : t.node.title) != null ? de : ""),
                title: String((We = (D = t.node.title) != null ? D : t.node.alt) != null ? We : ""),
                class: O(["max-w-96 h-auto rounded-lg transition-opacity duration-200 ease-in-out", { "opacity-0": !a.value, "opacity-100": a.value, "cursor-pointer": a.value }]),
                style: ut(A.value ? { minHeight: t.svgMinHeight, width: "100%", height: "auto", objectFit: "contain" } : void 0),
                loading: t.lazy ? "lazy" : "eager",
                decoding: "async",
                tabindex: a.value ? 0 : -1,
                "aria-label": (ce = t.node.alt) != null ? ce : $(T)("image.preview"),
                onError: S,
                onLoad: ee,
                onClick: j
              }, null, 46, Pr)) : d.value ? !e.node.loading && !t.fallbackSrc ? (m(), y("div", Kr, [
                Tt(re.$slots, "error", {
                  node: t.node,
                  displaySrc: C.value,
                  imageLoaded: a.value,
                  hasError: d.value,
                  fallbackSrc: t.fallbackSrc,
                  lazy: t.lazy,
                  isSvg: A.value
                }, () => [
                  G[1] || (G[1] = h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24"
                  }, [
                    h("path", {
                      fill: "currentColor",
                      d: "M2 2h20v10h-2V4H4v9.586l5-5L14.414 14L13 15.414l-4-4l-5 5V20h8v2H2zm13.547 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0a3 3 0 0 1-6 0m3.625 6.757L19 17.586l2.828-2.829l1.415 1.415L20.414 19l2.829 2.828l-1.415 1.415L19 20.414l-2.828 2.829l-1.415-1.415L17.586 19l-2.829-2.828z"
                    })
                  ], -1)),
                  h("span", Fr, se($(T)("image.loadError")), 1)
                ], !0)
              ])) : fe("", !0) : (m(), y("div", {
                key: "placeholder",
                class: "placeholder-layer max-w-96 inline-flex items-center justify-center gap-2",
                style: ut(A.value ? { minHeight: t.svgMinHeight, width: "100%" } : { minHeight: "6rem" })
              }, [
                t.usePlaceholder ? Tt(re.$slots, "placeholder", {
                  key: 0,
                  node: t.node,
                  displaySrc: C.value,
                  imageLoaded: a.value,
                  hasError: d.value,
                  fallbackSrc: t.fallbackSrc,
                  lazy: t.lazy,
                  isSvg: A.value
                }, () => [
                  G[0] || (G[0] = h("div", {
                    class: "w-4 h-4 rounded-full border-2 border-solid border-current border-t-transparent animate-spin",
                    "aria-hidden": "true"
                  }, null, -1)),
                  h("span", Vr, se($(T)("image.loading")), 1)
                ], !0) : (m(), y("span", Or, se(e.node.raw), 1))
              ], 4))
            ];
          }),
          _: 3
        })
      ]),
      t.showCaption && t.node.alt ? (m(), y("figcaption", Wr, se(t.node.alt), 1)) : fe("", !0)
    ], 512));
  }
}), Pt = /* @__PURE__ */ Z(Xr, [["__scopeId", "data-v-7ca79b66"]]);
Pt.install = (e) => {
  e.component(Pt.__name, Pt);
};
let bn = null, qn = !1, ho = Ko;
function Ko() {
  return z(null, null, function* () {
    const e = yield import("katex");
    return yield import("katex/contrib/mhchem"), e;
  });
}
function Yr() {
  bn = null, qn = !1;
}
function Fo(e) {
  ho = e, Yr();
}
function Sl(e) {
  Fo(e != null ? e : Ko);
}
function El() {
  Fo(null);
}
function Wo() {
  return typeof ho == "function";
}
function vo() {
  return z(this, null, function* () {
    if (bn)
      return bn;
    if (qn)
      return null;
    const e = ho;
    if (!e)
      return qn = !0, null;
    try {
      const n = yield e();
      if (n)
        return bn = n, bn;
    } catch (n) {
    }
    return qn = !0, null;
  });
}
const no = lr(!1);
let _o = null;
function Xo() {
  return _o || (_o = vo().then((e) => {
    no.value = !!e;
  }).catch(() => {
    no.value = !1;
  })), cr(no);
}
const Ur = /* @__PURE__ */ F({
  __name: "TextNode",
  props: {
    node: {}
  },
  emits: ["copy"],
  setup(e) {
    const n = Xo();
    return (t, s) => (m(), y("span", {
      class: O([[$(n) && e.node.center ? "text-node-center" : ""], "whitespace-pre-wrap break-words text-node"])
    }, se(e.node.content), 3));
  }
}), Ie = /* @__PURE__ */ Z(Ur, [["__scopeId", "data-v-56f30838"]]);
Ie.install = (e) => {
  e.component(Ie.__name, Ie);
};
const It = vn(() => z(null, null, function* () {
  var n, t;
  if (typeof globalThis != "undefined" && typeof globalThis.process != "undefined" && ((t = (n = globalThis.process) == null ? void 0 : n.env) == null ? void 0 : t.NODE_ENV) === "test")
    return (s) => {
      var a, d;
      return Gn(Ie, Mt(oe({}, s), {
        node: Mt(oe({}, s.node), {
          content: (d = s.node.raw) != null ? d : `$${(a = s.node.content) != null ? a : ""}$`
        })
      }));
    };
  try {
    if (yield vo())
      return (yield import("./index-B90_xyRN.js")).default;
  } catch (s) {
    console.warn(
      '[markstream-vue] Optional peer dependencies for MathInlineNode are missing. Falling back to text rendering. To enable full math rendering features, please install "katex".',
      s
    );
  }
  return (s) => {
    var a, d;
    return Gn(Ie, Mt(oe({}, s), {
      node: Mt(oe({}, s.node), {
        content: (d = s.node.raw) != null ? d : `$${(a = s.node.content) != null ? a : ""}$`
      })
    }));
  };
})), qr = vn(() => z(null, null, function* () {
  try {
    if (yield vo())
      return (yield import("./index-Bg9riGZT.js")).default;
  } catch (e) {
    console.warn(
      '[markstream-vue] Optional peer dependencies for MathBlockNode are missing. Falling back to text rendering. To enable full math rendering features, please install "katex".',
      e
    );
  }
  return (e) => {
    var n, t;
    return Gn(Ie, Mt(oe({}, e), {
      node: Mt(oe({}, e.node), {
        content: (t = e.node.raw) != null ? t : `$$${(n = e.node.content) != null ? n : ""}$$`
      })
    }));
  };
})), Pe = /* @__PURE__ */ F({
  __name: "ReferenceNode",
  props: {
    node: {},
    messageId: {},
    threadId: {}
  },
  emits: ["click", "mouseEnter", "mouseLeave"],
  setup(e) {
    return (n, t) => (m(), y("span", {
      class: "reference-node cursor-pointer bg-accent text-xs rounded-md px-1.5 mx-0.5 hover:bg-secondary",
      role: "button",
      tabindex: "0",
      onClick: t[0] || (t[0] = (s) => n.$emit("click", s, e.node.id, e.messageId, e.threadId)),
      onMouseenter: t[1] || (t[1] = (s) => n.$emit("mouseEnter", s, e.node.id, e.messageId, e.threadId)),
      onMouseleave: t[2] || (t[2] = (s) => n.$emit("mouseLeave", s, e.node.id, e.messageId, e.threadId))
    }, se(e.node.id), 33));
  }
});
Pe.install = (e) => {
  e.component(Pe.__name, Pe);
};
const Zr = { class: "superscript-node" }, Gr = { key: 1 }, Jr = /* @__PURE__ */ F({
  __name: "SuperscriptNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      emphasis: tt,
      footnote_reference: De,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      emoji: je,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("sup", Zr, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), y(ue, {
        key: `${e.indexKey || "superscript"}-${f}`
      }, [
        s[c.type] ? (m(), ye(Fe(s[c.type]), {
          key: 0,
          node: c,
          "custom-id": n.customId,
          "index-key": `${e.indexKey || "superscript"}-${f}`
        }, null, 8, ["node", "custom-id", "index-key"])) : (m(), y("span", Gr, se(c.content || c.raw), 1))
      ], 64))), 128))
    ]));
  }
}), Ge = /* @__PURE__ */ Z(Jr, [["__scopeId", "data-v-6dc1e3ba"]]);
Ge.install = (e) => {
  e.component(Ge.__name, Ge);
};
const Qr = { class: "subscript-node" }, ea = { key: 1 }, ta = /* @__PURE__ */ F({
  __name: "SubscriptNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      emphasis: tt,
      footnote_reference: De,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      superscript: Ge,
      emoji: je,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("sub", Qr, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), y(ue, {
        key: `${e.indexKey || "subscript"}-${f}`
      }, [
        s[c.type] ? (m(), ye(Fe(s[c.type]), {
          key: 0,
          node: c,
          "custom-id": n.customId,
          "index-key": `${e.indexKey || "subscript"}-${f}`
        }, null, 8, ["node", "custom-id", "index-key"])) : (m(), y("span", ea, se(c.content || c.raw), 1))
      ], 64))), 128))
    ]));
  }
}), Je = /* @__PURE__ */ Z(ta, [["__scopeId", "data-v-69de9b81"]]);
Je.install = (e) => {
  e.component(Je.__name, Je);
};
const na = { class: "strong-node" }, oa = /* @__PURE__ */ F({
  __name: "StrongNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      emphasis: tt,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      footnote_reference: De,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("strong", na, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), ye(Fe(s[c.type]), {
        key: `${e.indexKey || "strong"}-${f}`,
        "index-key": `${e.indexKey || "strong"}-${f}`,
        node: c,
        "custom-id": n.customId
      }, null, 8, ["index-key", "node", "custom-id"]))), 128))
    ]));
  }
}), Ve = /* @__PURE__ */ Z(oa, [["__scopeId", "data-v-af3ce037"]]);
Ve.install = (e) => {
  e.component(Ve.__name, Ve);
};
const ra = { class: "strikethrough-node" }, aa = /* @__PURE__ */ F({
  __name: "StrikethroughNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      emphasis: tt,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      footnote_reference: De,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("del", ra, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), ye(Fe(s[c.type]), {
        key: `${e.indexKey || "strikethrough"}-${f}`,
        node: c,
        "custom-id": n.customId,
        "index-key": `${e.indexKey || "strikethrough"}-${f}`
      }, null, 8, ["node", "custom-id", "index-key"]))), 128))
    ]));
  }
}), Oe = /* @__PURE__ */ Z(aa, [["__scopeId", "data-v-904d5bd1"]]);
Oe.install = (e) => {
  e.component(Oe.__name, Oe);
};
const ia = ["href", "title", "aria-label", "aria-hidden"], sa = ["aria-hidden"], la = { class: "link-text-wrapper relative inline-flex" }, ca = { class: "leading-[normal] link-text" }, ua = { class: "leading-[normal] link-text" }, da = /* @__PURE__ */ F({
  __name: "LinkNode",
  props: {
    node: {},
    indexKey: {},
    customId: {},
    showTooltip: { type: Boolean, default: !0 },
    color: {},
    underlineHeight: {},
    underlineBottom: {},
    animationDuration: {},
    animationOpacity: {},
    animationTiming: {},
    animationIteration: {}
  },
  setup(e) {
    const n = e, t = N(() => {
      var v, b, C, H, A, S;
      const w = n.underlineBottom !== void 0 ? typeof n.underlineBottom == "number" ? `${n.underlineBottom}px` : String(n.underlineBottom) : "-3px";
      return {
        "--link-color": (v = n.color) != null ? v : "#0366d6",
        "--underline-height": `${(b = n.underlineHeight) != null ? b : 2}px`,
        "--underline-bottom": w,
        "--underline-opacity": String((C = n.animationOpacity) != null ? C : 0.9),
        "--underline-duration": `${(H = n.animationDuration) != null ? H : 0.8}s`,
        "--underline-timing": (A = n.animationTiming) != null ? A : "linear",
        "--underline-iteration": typeof n.animationIteration == "number" ? String(n.animationIteration) : (S = n.animationIteration) != null ? S : "infinite"
      };
    }), s = {
      text: Ie,
      strong: Ve,
      strikethrough: Oe,
      emphasis: tt,
      image: Pt,
      html_inline: Ae
    }, a = ur();
    function d(w) {
      var H, A, S;
      if (!n.showTooltip)
        return;
      const v = w, b = (v == null ? void 0 : v.clientX) != null && (v == null ? void 0 : v.clientY) != null ? { x: v.clientX, y: v.clientY } : void 0, C = ((H = n.node) == null ? void 0 : H.title) || ((A = n.node) == null ? void 0 : A.href) || ((S = n.node) == null ? void 0 : S.text) || "";
      Dn(w.currentTarget, C, "top", !1, b);
    }
    function c() {
      n.showTooltip && uo();
    }
    const f = N(() => {
      var w, v;
      return String((v = (w = n.node.title) != null ? w : n.node.href) != null ? v : "");
    });
    return (w, v) => e.node.loading ? (m(), y("span", Kt({
      key: 1,
      class: "link-loading inline-flex items-baseline gap-1.5",
      "aria-hidden": e.node.loading ? "false" : "true"
    }, $(a), { style: t.value }), [
      h("span", la, [
        h("span", ca, [
          h("span", ua, se(e.node.text), 1)
        ]),
        v[1] || (v[1] = h("span", {
          class: "underline-anim",
          "aria-hidden": "true"
        }, null, -1))
      ])
    ], 16, sa)) : (m(), y("a", Kt({
      key: 0,
      class: "link-node",
      href: e.node.href,
      title: e.showTooltip ? "" : f.value,
      "aria-label": `Link: ${f.value}`,
      "aria-hidden": e.node.loading ? "true" : "false",
      target: "_blank",
      rel: "noopener noreferrer"
    }, $(a), {
      style: t.value,
      onMouseenter: v[0] || (v[0] = (b) => d(b)),
      onMouseleave: c
    }), [
      (m(!0), y(ue, null, Be(e.node.children, (b, C) => (m(), ye(Fe(s[b.type]), {
        key: `${e.indexKey || "emphasis"}-${C}`,
        node: b,
        "custom-id": n.customId,
        "index-key": `${e.indexKey || "link-text"}-${C}`
      }, null, 8, ["node", "custom-id", "index-key"]))), 128))
    ], 16, ia));
  }
}), Ke = /* @__PURE__ */ Z(da, [["__scopeId", "data-v-0753b32c"]]);
Ke.install = (e) => {
  e.component(Ke.__name, Ke);
};
const ma = { class: "insert-node" }, fa = /* @__PURE__ */ F({
  __name: "InsertNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      emphasis: tt,
      strikethrough: Oe,
      highlight: et,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      footnote_reference: De,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("ins", ma, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), ye(Fe(s[c.type]), {
        key: `${e.indexKey || "insert"}-${f}`,
        node: c,
        "custom-id": n.customId,
        "index-key": `${e.indexKey || "insert"}-${f}`
      }, null, 8, ["node", "custom-id", "index-key"]))), 128))
    ]));
  }
}), Qe = /* @__PURE__ */ Z(fa, [["__scopeId", "data-v-ab1ec9bc"]]);
Qe.install = (e) => {
  e.component(Qe.__name, Qe);
};
const ha = { class: "highlight-node" }, va = /* @__PURE__ */ F({
  __name: "HighlightNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      emphasis: tt,
      strikethrough: Oe,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      footnote_reference: De,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("mark", ha, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), ye(Fe(s[c.type]), {
        key: `${e.indexKey || "highlight"}-${f}`,
        node: c,
        "custom-id": n.customId,
        "index-key": `${e.indexKey || "highlight"}-${f}`
      }, null, 8, ["node", "custom-id", "index-key"]))), 128))
    ]));
  }
}), et = /* @__PURE__ */ Z(va, [["__scopeId", "data-v-38e31bf6"]]);
et.install = (e) => {
  e.component(et.__name, et);
};
const pa = { class: "emphasis-node" }, ga = /* @__PURE__ */ F({
  __name: "EmphasisNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      html_inline: Ae,
      strong: Ve,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      footnote_reference: De,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => (m(), y("em", pa, [
      (m(!0), y(ue, null, Be(e.node.children, (c, f) => (m(), ye(Fe(s[c.type]), {
        key: `${e.indexKey || "emphasis"}-${f}`,
        node: c,
        "custom-id": n.customId,
        "index-key": `${e.indexKey || "emphasis"}-${f}`
      }, null, 8, ["node", "custom-id", "index-key"]))), 128))
    ]));
  }
}), tt = /* @__PURE__ */ Z(ga, [["__scopeId", "data-v-8264674d"]]);
tt.install = (e) => {
  e.component(tt.__name, tt);
};
const wa = ["href", "title"], ya = /* @__PURE__ */ F({
  __name: "FootnoteAnchorNode",
  props: {
    node: {}
  },
  setup(e) {
    const n = e;
    function t(s) {
      var c;
      if (s.preventDefault(), typeof document == "undefined")
        return;
      const a = `fnref-${String((c = n.node.id) != null ? c : "")}`, d = document.getElementById(a);
      d && d.scrollIntoView({ behavior: "smooth" });
    }
    return (s, a) => (m(), y("a", {
      class: "footnote-anchor text-sm text-[#0366d6] hover:underline cursor-pointer",
      href: `#fnref-${e.node.id}`,
      title: `返回引用 ${e.node.id}`,
      onClick: t
    }, " ↩︎ ", 8, wa));
  }
}), un = /* @__PURE__ */ Z(ya, [["__scopeId", "data-v-4756ce0d"]]);
un.install = (e) => {
  e.component(un.__name, un);
};
const ka = ["id"], xa = { class: "flex-1" }, _n = /* @__PURE__ */ F({
  __name: "FootnoteNode",
  props: {
    node: {},
    indexKey: {},
    typewriter: { type: Boolean },
    customId: {}
  },
  emits: ["copy"],
  setup(e) {
    const n = e;
    return (t, s) => (m(), y("div", {
      id: `fnref--${e.node.id}`,
      class: "flex mt-2 mb-2 text-sm leading-relaxed border-t border-[#eaecef] pt-2"
    }, [
      h("div", xa, [
        fn([n.node.children], () => ct($(lt), {
          "index-key": `footnote-${n.indexKey}`,
          nodes: n.node.children,
          "custom-id": n.customId,
          typewriter: n.typewriter,
          onCopy: s[0] || (s[0] = (a) => t.$emit("copy", a))
        }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"]), s, 1)
      ])
    ], 8, ka));
  }
});
_n.install = (e) => {
  e.component(_n.__name, _n);
};
const ba = { class: "hard-break" }, Ma = /* @__PURE__ */ F({
  __name: "HardBreakNode",
  props: {
    node: {}
  },
  setup(e) {
    return (n, t) => (m(), y("br", ba));
  }
}), Jt = /* @__PURE__ */ Z(Ma, [["__scopeId", "data-v-50c58f70"]]);
Jt.install = (e) => {
  e.component(Jt.__name, Jt);
};
const Ca = /* @__PURE__ */ F({
  __name: "HeadingNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      text: Ie,
      inline_code: ze,
      link: Ke,
      image: Pt,
      strong: Ve,
      emphasis: tt,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      checkbox: _t,
      checkbox_input: _t,
      footnote_reference: De,
      hardbreak: Jt,
      math_inline: It,
      reference: Pe
    }, t);
    return (a, d) => fn([e.node.children], () => (m(), ye(Fe(`h${e.node.level}`), {
      class: O(["heading-node", [`heading-${e.node.level}`]]),
      dir: "auto"
    }, {
      default: en(() => [
        (m(!0), y(ue, null, Be(e.node.children, (c, f, w, v) => {
          const b = [c];
          if (v && v.key === `${e.indexKey || "heading"}-${f}` && jo(v, b)) return v;
          const C = (m(), ye(Fe(s[c.type]), {
            key: `${e.indexKey || "heading"}-${f}`,
            "custom-id": n.customId,
            node: c,
            "index-key": `${e.indexKey || "heading"}-${f}`
          }, null, 8, ["custom-id", "node", "index-key"]));
          return C.memo = b, C;
        }, d, 0), 128))
      ]),
      _: 1
    }, 8, ["class"])), d, 2);
  }
}), oo = /* @__PURE__ */ Z(Ca, [["__scopeId", "data-v-e3e7e2ce"]]), po = oo;
po.install = (e) => {
  e.component(oo.__name, oo);
};
const Ta = /* @__PURE__ */ F({
  __name: "ListItemNode",
  props: {
    item: {},
    indexKey: {},
    value: {},
    customId: {},
    typewriter: { type: Boolean }
  },
  emits: ["copy"],
  setup(e) {
    const n = e, t = N(
      () => n.value == null ? {} : { value: n.value }
    );
    return (s, a) => (m(), y("li", Kt({
      class: "list-item pl-1.5 my-2",
      dir: "auto"
    }, t.value), [
      fn([n.item.children], () => ct($(lt), {
        "index-key": `list-item-${n.indexKey}`,
        nodes: n.item.children,
        "custom-id": n.customId,
        typewriter: n.typewriter,
        "batch-rendering": !1,
        onCopy: a[0] || (a[0] = (d) => s.$emit("copy", d))
      }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"]), a, 1)
    ], 16));
  }
}), Bn = /* @__PURE__ */ Z(Ta, [["__scopeId", "data-v-7a618746"]]);
Bn.install = (e) => {
  e.component(Bn.__name, Bn);
};
const _a = /* @__PURE__ */ F({
  __name: "ListNode",
  props: {
    node: {},
    customId: {},
    indexKey: {},
    typewriter: { type: Boolean }
  },
  emits: ["copy"],
  setup(e) {
    return (n, t) => (m(), ye(Fe(e.node.ordered ? "ol" : "ul"), {
      class: O(["list-node", { "list-decimal": e.node.ordered, "list-disc": !e.node.ordered }])
    }, {
      default: en(() => [
        (m(!0), y(ue, null, Be(e.node.items, (s, a, d, c) => {
          var v;
          const f = [s];
          if (c && c.key === `${e.indexKey || "list"}-${a}` && jo(c, f)) return c;
          const w = (m(), ye($(Bn), {
            key: `${e.indexKey || "list"}-${a}`,
            item: s,
            "custom-id": e.customId,
            "index-key": `${e.indexKey || "list"}-${a}`,
            typewriter: e.typewriter,
            value: e.node.ordered ? ((v = e.node.start) != null ? v : 1) + a : void 0,
            onCopy: t[0] || (t[0] = (b) => n.$emit("copy", b))
          }, null, 8, ["item", "custom-id", "index-key", "typewriter", "value"]));
          return w.memo = f, w;
        }, t, 1), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), In = /* @__PURE__ */ Z(_a, [["__scopeId", "data-v-79057d57"]]);
In.install = (e) => {
  e.component(In.__name, In);
};
const Ba = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%2016'%20width='16'%20height='16'%3e%3cpath%20fill='none'%20stroke='%23ca9ee6'%20stroke-linecap='round'%20stroke-linejoin='round'%20d='M1.5%202.5c0%206%202.25%205.75%204%207%20.83.67%201.17%202%201%204h3c-.17-2%20.17-3.33%201-4%201.75-1.25%204-1%204-7C12%202.5%2010%203%208%207%206%203%204%202.5%201.5%202.5'%20/%3e%3c/svg%3e";
function Ia(e) {
  try {
    if (typeof globalThis != "undefined" && typeof globalThis.requestAnimationFrame == "function")
      return globalThis.requestAnimationFrame(e);
  } catch (n) {
  }
  return globalThis.setTimeout(e, 0);
}
const go = () => import("mermaid");
let cn = null, wo = go;
function $a() {
  cn = null;
}
function Yo(e) {
  wo = e, $a();
}
function Ll(e) {
  Yo(e != null ? e : go);
}
function Rl() {
  Yo(null);
}
function Sa() {
  return typeof wo == "function";
}
function Ea(e) {
  if (!e)
    return e;
  const n = e && e.default ? e.default : e;
  if (n && (typeof n.render == "function" || typeof n.parse == "function" || typeof n.initialize == "function"))
    return n;
  if (n && n.mermaidAPI && (typeof n.mermaidAPI.render == "function" || typeof n.mermaidAPI.parse == "function")) {
    const t = n.mermaidAPI;
    return Mt(oe({}, n), {
      render: t.render.bind(t),
      parse: t.parse ? t.parse.bind(t) : void 0,
      initialize: (s) => typeof n.initialize == "function" ? n.initialize(s) : t.initialize ? t.initialize(s) : void 0
    });
  }
  return e.mermaid && typeof e.mermaid.render == "function" ? e.mermaid : n;
}
function La(e) {
  if (e)
    try {
      const n = e == null ? void 0 : e.initialize;
      e.initialize = (t) => {
        const s = oe({ suppressErrorRendering: !0 }, t || {});
        if (typeof n == "function")
          return n.call(e, s);
        if (e != null && e.mermaidAPI && typeof e.mermaidAPI.initialize == "function")
          return e.mermaidAPI.initialize(s);
      };
    } catch (n) {
    }
}
function Ra() {
  return z(this, null, function* () {
    if (cn)
      return cn;
    const e = wo;
    if (!e)
      return null;
    let n;
    try {
      n = yield e();
    } catch (t) {
      throw e === go ? new Error('Optional dependency "mermaid" is not installed. Please install it to enable mermaid diagrams.') : t;
    }
    return n ? (cn = Ea(n), La(cn), cn) : null;
  });
}
let _e = null, Vt = null;
const Me = /* @__PURE__ */ new Map(), Na = 5;
let Jn = Na, ro = !1;
function Nl(e) {
  ro = !!e;
}
function Hl(e) {
  Number.isFinite(e) && e > 0 && (Jn = Math.floor(e));
}
function jl() {
  return { inFlight: Me.size, max: Jn };
}
const Ha = "WORKER_BUSY", ja = "MERMAID_DISABLED";
function Dl(e) {
  _e = e, Vt = null;
  const n = e;
  _e.onmessage = (t) => {
    if (_e !== n)
      return;
    const { id: s, ok: a, result: d, error: c } = t.data, f = Me.get(s);
    f && (a === !1 || c ? f.reject(new Error(c || "Unknown error")) : f.resolve(d));
  }, _e.onerror = (t) => {
    var s, a;
    if (_e === n) {
      if (Me.size === 0) {
        (s = console.debug) == null || s.call(console, "[mermaidWorkerClient] Worker error (no pending):", (t == null ? void 0 : t.message) || t);
        return;
      }
      try {
        ro ? console.error("[mermaidWorkerClient] Worker error:", (t == null ? void 0 : t.message) || t) : (a = console.debug) == null || a.call(console, "[mermaidWorkerClient] Worker error:", (t == null ? void 0 : t.message) || t);
      } catch (d) {
      }
      for (const [d, c] of Me.entries())
        c.reject(new Error(`Worker error: ${t.message}`));
      Me.clear();
    }
  }, _e.onmessageerror = (t) => {
    var s, a;
    if (_e === n) {
      if (Me.size === 0) {
        (s = console.debug) == null || s.call(console, "[mermaidWorkerClient] Worker messageerror (no pending):", t);
        return;
      }
      try {
        ro ? console.error("[mermaidWorkerClient] Worker messageerror:", t) : (a = console.debug) == null || a.call(console, "[mermaidWorkerClient] Worker messageerror:", t);
      } catch (d) {
      }
      for (const [d, c] of Me.entries())
        c.reject(new Error("Worker messageerror"));
      Me.clear();
    }
  };
}
function Al() {
  var e;
  if (_e)
    try {
      for (const [n, t] of Me.entries())
        t.reject(new Error("Worker cleared"));
      Me.clear(), (e = _e.terminate) == null || e.call(_e);
    } catch (n) {
    }
  _e = null, Vt = null;
}
function Da() {
  return _e || (Vt = new Error("[mermaidWorkerClient] No worker instance set. Please inject a Worker via setMermaidWorker()."), Vt.name = "WorkerInitError", Vt.code = "WORKER_INIT_ERROR", null);
}
function Uo(e, n, t = 1400) {
  if (!Sa()) {
    const a = new Error("Mermaid rendering disabled");
    return a.name = "MermaidDisabled", a.code = ja, Promise.reject(a);
  }
  if (Vt)
    return Promise.reject(Vt);
  const s = Da();
  if (!s)
    return Promise.reject(Vt);
  if (Me.size >= Jn) {
    const a = new Error("Worker busy");
    return a.name = "WorkerBusy", a.code = Ha, a.inFlight = Me.size, a.max = Jn, Promise.reject(a);
  }
  return new Promise((a, d) => {
    const c = Math.random().toString(36).slice(2);
    let f = !1, w;
    const v = () => {
      f || (f = !0, w != null && globalThis.clearTimeout(w), Me.delete(c));
    }, b = {
      resolve: (C) => {
        v(), a(C);
      },
      reject: (C) => {
        v(), d(C);
      }
    };
    Me.set(c, b);
    try {
      s.postMessage({ id: c, action: e, payload: n });
    } catch (C) {
      Me.delete(c), d(C);
      return;
    }
    w = globalThis.setTimeout(() => {
      const C = new Error("Worker call timed out");
      C.name = "WorkerTimeout", C.code = "WORKER_TIMEOUT";
      const H = Me.get(c);
      H && H.reject(C);
    }, t);
  });
}
function Aa(e, n, t = 1400) {
  return z(this, null, function* () {
    try {
      return yield Uo("canParse", { code: e, theme: n }, t);
    } catch (s) {
      return Promise.reject(s);
    }
  });
}
function za(e, n, t = 1400) {
  return z(this, null, function* () {
    try {
      return yield Uo("findPrefix", { code: e, theme: n }, t);
    } catch (s) {
      return Promise.reject(s);
    }
  });
}
function Bo() {
  if (_e)
    try {
      for (const [e, n] of Me.entries())
        n.reject(new Error("Worker terminated"));
      Me.clear(), _e.terminate();
    } finally {
      _e = null;
    }
}
const Pa = { key: 0 }, Va = {
  key: 1,
  class: "flex items-center space-x-2 overflow-hidden"
}, Oa = ["src"], Ka = { key: 2 }, Fa = { class: "flex items-center space-x-1" }, Wa = { class: "flex items-center space-x-1" }, Xa = { key: 4 }, Ya = {
  key: 5,
  class: "flex items-center space-x-1"
}, Ua = ["aria-pressed"], qa = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  class: "w-3 h-3"
}, Za = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  class: "w-3 h-3"
}, Ga = ["disabled"], Ja = ["disabled"], Qa = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "0.75rem",
  height: "0.75rem",
  viewBox: "0 0 24 24"
}, ei = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "0.75rem",
  height: "0.75rem",
  viewBox: "0 0 24 24"
}, ti = {
  key: 1,
  class: "relative"
}, ni = {
  key: 0,
  class: "absolute top-2 right-2 z-10 rounded-lg"
}, oi = { class: "flex items-center gap-2 backdrop-blur rounded-lg" }, ri = { class: "absolute top-6 right-6 z-50 flex items-center gap-2" }, ai = 300, ii = 500, si = 3, li = /* @__PURE__ */ F({
  __name: "MermaidBlockNode",
  props: {
    node: {},
    maxHeight: { default: "500px" },
    loading: { type: Boolean, default: !0 },
    isDark: { type: Boolean },
    workerTimeoutMs: { default: 1400 },
    parseTimeoutMs: { default: 1800 },
    renderTimeoutMs: { default: 2500 },
    fullRenderTimeoutMs: { default: 4e3 },
    showHeader: { type: Boolean, default: !0 },
    showModeToggle: { type: Boolean, default: !0 },
    showCopyButton: { type: Boolean, default: !0 },
    showExportButton: { type: Boolean, default: !0 },
    showFullscreenButton: { type: Boolean, default: !0 },
    showCollapseButton: { type: Boolean, default: !0 },
    showZoomControls: { type: Boolean, default: !0 },
    enableWheelZoom: { type: Boolean, default: !1 },
    isStrict: { type: Boolean, default: !1 }
  },
  emits: ["copy", "export", "openModal", "toggleMode"],
  setup(e, { emit: n }) {
    var yn, kn;
    const t = e, s = n, a = {
      USE_PROFILES: { svg: !0 },
      FORBID_TAGS: ["script"],
      FORBID_ATTR: [/^on/i],
      ADD_TAGS: ["style"],
      ADD_ATTR: ["style"],
      SAFE_FOR_TEMPLATES: !0
    }, d = M(!1), c = N(() => t.isStrict ? "strict" : "loose"), f = N(() => ({
      startOnLoad: !1,
      securityLevel: c.value,
      dompurifyConfig: c.value === "strict" ? a : void 0,
      flowchart: c.value === "strict" ? { htmlLabels: !1 } : void 0
    }));
    function w(r) {
      return r.replace(/["']\s*javascript:/gi, "#").replace(/\bjavascript:/gi, "#").replace(/["']\s*vbscript:/gi, "#").replace(/\bvbscript:/gi, "#").replace(/\bdata:text\/html/gi, "#");
    }
    const v = [/javascript:/i, /expression\s*\(/i, /url\s*\(\s*javascript:/i, /@import/i], b = /^(?:https?:|mailto:|tel:|#|\/|data:image\/(?:png|gif|jpe?g|webp);)/i;
    function C(r) {
      if (!r)
        return "";
      const o = r.trim();
      return b.test(o) ? o : "";
    }
    function H(r) {
      const o = /* @__PURE__ */ new Set(["script"]), l = [r, ...Array.from(r.querySelectorAll("*"))];
      for (const k of l) {
        if (o.has(k.tagName.toLowerCase())) {
          k.remove();
          continue;
        }
        const R = Array.from(k.attributes);
        for (const E of R) {
          const V = E.name;
          if (/^on/i.test(V)) {
            k.removeAttribute(V);
            continue;
          }
          if (V === "style" && E.value) {
            const P = E.value;
            if (v.some((me) => me.test(P))) {
              k.removeAttribute(V);
              continue;
            }
          }
          if ((V === "href" || V === "xlink:href") && E.value) {
            const P = C(E.value);
            if (!P) {
              k.removeAttribute(V);
              continue;
            }
            P !== E.value && k.setAttribute(V, P);
          }
        }
      }
    }
    function A(r) {
      if (typeof window == "undefined" || typeof DOMParser == "undefined" || !r)
        return null;
      const o = w(r), k = new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
      if (!k || k.nodeName.toLowerCase() !== "svg")
        return null;
      const R = k;
      return H(R), R;
    }
    function S(r, o) {
      if (!r)
        return "";
      try {
        r.replaceChildren();
      } catch (k) {
        r.innerHTML = "";
      }
      const l = A(o);
      return l ? (r.appendChild(l), r.innerHTML) : "";
    }
    function ee(r) {
      if (r)
        try {
          r.replaceChildren();
        } catch (o) {
          r.innerHTML = "";
        }
    }
    function j(r, o) {
      if (!r)
        return "";
      if (c.value === "strict")
        return S(r, o);
      try {
        r.replaceChildren();
      } catch (l) {
        r.innerHTML = "";
      }
      if (o)
        try {
          r.insertAdjacentHTML("afterbegin", o);
        } catch (l) {
          r.innerHTML = o;
        }
      return r.innerHTML;
    }
    const { t: T } = mo();
    function re() {
      return z(this, null, function* () {
        try {
          const r = yield Ra();
          return d.value = !!r, r;
        } catch (r) {
          throw d.value = !1, r;
        }
      });
    }
    typeof window != "undefined" && z(null, null, function* () {
      var r;
      try {
        const o = yield re();
        if (!o)
          return;
        (r = o == null ? void 0 : o.initialize) == null || r.call(o, oe({}, f.value));
      } catch (o) {
        d.value = !1, console.warn("[markstream-vue] Failed to initialize mermaid renderer. Call enableMermaid() to configure a loader.", o);
      }
    });
    const G = M(!1), ne = M(!1), de = M(), D = M(), We = M(), ce = M(null), Ee = fo(), gt = M(null), W = M(typeof window == "undefined"), Ht = M(), ae = N(() => t.node.code.replace(/\]::([^:])/g, "]:::$1").replace(/:::subgraphNode$/gm, "::subgraphNode"));
    function Se(r, o = ae.value) {
      const l = o, R = `%%{init: {"theme": "${r === "dark" ? "dark" : "default"}"}}%%
`;
      return l.trim().startsWith("%%{") ? l : R + l;
    }
    const I = M(1), J = M(0), Y = M(0), Le = M(!1), Xe = M({ x: 0, y: 0 }), q = M(!1), ve = M(!1), ie = M(!1), $t = M(null), wt = M(0), St = M(!1);
    let ke = null, Ce = null, yt = 0;
    const jt = (yn = globalThis.requestIdleCallback) != null ? yn : ((r, o) => setTimeout(() => r({ didTimeout: !0 }), 16)), dt = Kn(() => {
      jt(() => {
        Ut();
      }, { timeout: 500 });
    }, ai);
    function nt() {
      Ce != null && (globalThis.clearTimeout(Ce), Ce = null);
    }
    function xe(r = 600) {
      if (typeof globalThis == "undefined")
        return;
      const o = Math.max(0, r);
      nt();
      const l = () => {
        if (Ce = null, t.loading || ie.value || !W.value) {
          const k = Math.min(1200, Math.max(300, o * 1.2));
          xe(k);
          return;
        }
        dt();
      };
      Ce = globalThis.setTimeout(l, o);
    }
    const Q = M("360px");
    let be = null;
    const le = M(!1), $e = M(!1), ot = M({}), kt = M(null), Re = M(""), Ft = M(0);
    let pe = null;
    const g = M(!1), x = M({
      zoom: 1,
      translateX: 0,
      translateY: 0,
      containerHeight: "360px"
    }), B = N(() => t.enableWheelZoom ? { wheel: Te } : {}), K = N(() => {
      var r, o, l, k;
      return {
        worker: (r = t.workerTimeoutMs) != null ? r : 1400,
        parse: (o = t.parseTimeoutMs) != null ? o : 1800,
        render: (l = t.renderTimeoutMs) != null ? l : 2500,
        fullRender: (k = t.fullRenderTimeoutMs) != null ? k : 4e3
      };
    }), Ye = (kn = globalThis.cancelIdleCallback) != null ? kn : ((r) => clearTimeout(r));
    let mt = null, rt = null, Dt = !1, ft = 800, Ue = null, tn = 0, Et = !0;
    typeof window != "undefined" && U(
      () => de.value,
      (r) => {
        var l;
        if ((l = gt.value) == null || l.destroy(), gt.value = null, !r) {
          W.value = !1;
          return;
        }
        const o = Ee(r, { rootMargin: "400px" });
        gt.value = o, W.value = o.isVisible.value, o.whenVisible.then(() => {
          W.value = !0;
        });
      },
      { immediate: !0 }
    ), hn(() => {
      var r;
      (r = gt.value) == null || r.destroy(), gt.value = null;
    });
    function ht(r, o) {
      const l = o == null ? void 0 : o.timeoutMs, k = o == null ? void 0 : o.signal;
      if (k != null && k.aborted)
        return Promise.reject(new DOMException("Aborted", "AbortError"));
      let R = null, E = !1, V = null;
      return new Promise((P, me) => {
        const we = () => {
          R != null && clearTimeout(R), V && k && k.removeEventListener("abort", V);
        };
        l && l > 0 && (R = globalThis.setTimeout(() => {
          E || (E = !0, we(), me(new Error("Operation timed out")));
        }, l)), k && (V = () => {
          E || (E = !0, we(), me(new DOMException("Aborted", "AbortError")));
        }, k.addEventListener("abort", V)), r().then((ln) => {
          E || (E = !0, we(), P(ln));
        }).catch((ln) => {
          E || (E = !0, we(), me(ln));
        });
      });
    }
    function Wt(r) {
      if (typeof document == "undefined" || !D.value)
        return;
      const o = document.createElement("div");
      o.className = "text-red-500 p-4", o.textContent = "Failed to render diagram: ";
      const l = document.createElement("span");
      l.textContent = r instanceof Error ? r.message : "Unknown error", o.appendChild(l), ee(D.value), D.value.appendChild(o), Q.value = "360px", g.value = !0, pt();
    }
    function Lt(r) {
      const o = typeof r == "string" ? r : typeof (r == null ? void 0 : r.message) == "string" ? r.message : "";
      return typeof o == "string" && /timed out/i.test(o);
    }
    function At(r) {
      const o = r;
      return !o || o.disabled;
    }
    function ge(r, o, l = "top") {
      if (At(r.currentTarget))
        return;
      const k = r, R = (k == null ? void 0 : k.clientX) != null && (k == null ? void 0 : k.clientY) != null ? { x: k.clientX, y: k.clientY } : void 0;
      Dn(r.currentTarget, o, l, !1, R, t.isDark);
    }
    function te() {
      uo();
    }
    function Pn(r) {
      if (At(r.currentTarget))
        return;
      const o = G.value ? T("common.copied") || "Copied" : T("common.copy") || "Copy", l = r, k = (l == null ? void 0 : l.clientX) != null && (l == null ? void 0 : l.clientY) != null ? { x: l.clientX, y: l.clientY } : void 0;
      Dn(r.currentTarget, o, "top", !1, k, t.isDark);
    }
    function Vn(r, o) {
      const k = `%%{init: {"theme": "${o === "dark" ? "dark" : "default"}"}}%%
`;
      return r.trimStart().startsWith("%%{") ? r : k + r;
    }
    function pn() {
      return Et && !q.value && !le.value && !g.value;
    }
    function gn(r) {
      const o = r.split(/\r?\n/);
      for (; o.length > 0; ) {
        const k = o[o.length - 1].trimEnd();
        if (k === "") {
          o.pop();
          continue;
        }
        if (/^[-=~>|<\s]+$/.test(k.trim()) || /(?:--|==|~~|->|<-|-\||-\)|-x|o-|\|-|\.-)\s*$/.test(k) || /[-|><]$/.test(k) || /(?:graph|flowchart|sequenceDiagram|classDiagram|stateDiagram|erDiagram|gantt)\s*$/i.test(k)) {
          o.pop();
          continue;
        }
        break;
      }
      return o.join(`
`);
    }
    function Qn(r, o, l) {
      return z(this, null, function* () {
        var P, me;
        const k = yield re();
        if (!k)
          return;
        const R = k, E = Vn(r, o);
        if (typeof R.parse == "function")
          return yield ht(() => R.parse(E), {
            timeoutMs: (P = l == null ? void 0 : l.timeoutMs) != null ? P : K.value.parse,
            signal: l == null ? void 0 : l.signal
          }), !0;
        const V = `mermaid-parse-${Math.random().toString(36).slice(2, 9)}`;
        return yield ht(() => k.render(V, E), {
          timeoutMs: (me = l == null ? void 0 : l.timeoutMs) != null ? me : K.value.render,
          signal: l == null ? void 0 : l.signal
        }), !0;
      });
    }
    function Xt(r, o, l) {
      return z(this, null, function* () {
        var k;
        try {
          return yield Aa(r, o, (k = l == null ? void 0 : l.timeoutMs) != null ? k : K.value.worker);
        } catch (R) {
          return yield Qn(r, o, l);
        }
      });
    }
    function eo(r, o, l) {
      return z(this, null, function* () {
        var R;
        try {
          if (yield Xt(r, o, l))
            return { fullOk: !0, prefixOk: !1 };
        } catch (E) {
          if ((E == null ? void 0 : E.name) === "AbortError")
            throw E;
        }
        let k = gn(r);
        if (k && k.trim() && k !== r)
          try {
            try {
              const V = yield za(r, o, (R = l == null ? void 0 : l.timeoutMs) != null ? R : K.value.worker);
              V && V.trim() && (k = V);
            } catch (V) {
            }
            if (yield Xt(k, o, l))
              return { fullOk: !1, prefixOk: !0, prefix: k };
          } catch (E) {
            if ((E == null ? void 0 : E.name) === "AbortError")
              throw E;
          }
        return { fullOk: !1, prefixOk: !1 };
      });
    }
    const nn = N(() => q.value || ie.value || ne.value);
    function on(r) {
      if (!de.value || !D.value)
        return;
      const o = D.value.querySelector("svg");
      if (!o)
        return;
      let l = 0, k = 0;
      const R = o.getAttribute("viewBox"), E = o.getAttribute("width"), V = o.getAttribute("height");
      if (R) {
        const P = R.split(" ");
        P.length === 4 && (l = Number.parseFloat(P[2]), k = Number.parseFloat(P[3]));
      }
      if ((!l || !k) && E && V && (l = Number.parseFloat(E), k = Number.parseFloat(V)), Number.isNaN(l) || Number.isNaN(k) || l <= 0 || k <= 0)
        try {
          const P = o.getBBox();
          P && P.width > 0 && P.height > 0 && (l = P.width, k = P.height);
        } catch (P) {
          console.error("Failed to get SVG BBox:", P);
          return;
        }
      if (l > 0 && k > 0) {
        const P = k / l;
        let we = (r != null ? r : de.value.clientWidth) * P;
        we > k && (we = k), Q.value = `${we}px`;
      }
    }
    const vt = M(!1), wn = N(() => ({
      transform: `translate(${J.value}px, ${Y.value}px) scale(${I.value})`
    }));
    function On(r) {
      r.key === "Escape" && vt.value && rn();
    }
    function to() {
      if (vt.value = !0, typeof document != "undefined")
        try {
          document.body.style.overflow = "hidden";
        } catch (r) {
        }
      if (typeof window != "undefined")
        try {
          window.addEventListener("keydown", On);
        } catch (r) {
        }
      he(() => {
        if (de.value && We.value) {
          const r = de.value.cloneNode(!0);
          r.classList.add("fullscreen");
          const o = r.querySelector(
            "[data-mermaid-wrapper]"
          );
          o && (ce.value = o, o.style.transform = wn.value.transform), ee(We.value), We.value.appendChild(r);
        }
      });
    }
    function rn() {
      if (vt.value = !1, We.value && ee(We.value), ce.value = null, typeof document != "undefined")
        try {
          document.body.style.overflow = "";
        } catch (r) {
        }
      if (typeof window != "undefined")
        try {
          window.removeEventListener("keydown", On);
        } catch (r) {
        }
    }
    function Kn(r, o) {
      let l = null;
      return (...k) => {
        l && clearTimeout(l), l = setTimeout(() => r(...k), o);
      };
    }
    function Fn() {
      if (!q.value || !d.value)
        return;
      const r = ae.value.length;
      r !== wt.value && (St.value = !0, wt.value = r, ke && clearTimeout(ke), ke = setTimeout(() => {
        St.value && q.value && ae.value.trim() && (St.value = !1, xt("preview"));
      }, ii));
    }
    U(
      wn,
      (r) => {
        vt.value && ce.value && (ce.value.style.transform = r.transform);
      },
      { immediate: !0 }
    );
    function i() {
      I.value < 3 && (I.value += 0.1);
    }
    function u() {
      I.value > 0.5 && (I.value -= 0.1);
    }
    function p() {
      I.value = 1, J.value = 0, Y.value = 0;
    }
    function L(r) {
      Le.value = !0, r instanceof MouseEvent ? Xe.value = {
        x: r.clientX - J.value,
        y: r.clientY - Y.value
      } : Xe.value = {
        x: r.touches[0].clientX - J.value,
        y: r.touches[0].clientY - Y.value
      };
    }
    function _(r) {
      if (!Le.value)
        return;
      let o, l;
      r instanceof MouseEvent ? (o = r.clientX, l = r.clientY) : (o = r.touches[0].clientX, l = r.touches[0].clientY), J.value = o - Xe.value.x, Y.value = l - Xe.value.y;
    }
    function X() {
      Le.value = !1;
    }
    function Te(r) {
      if (t.enableWheelZoom && (r.ctrlKey || r.metaKey)) {
        if (r.preventDefault(), !de.value)
          return;
        const o = de.value.getBoundingClientRect(), l = r.clientX - o.left, k = r.clientY - o.top, R = o.width / 2, E = o.height / 2, V = l - R, P = k - E, me = (V - J.value) / I.value, we = (P - Y.value) / I.value, Go = -r.deltaY * 0.01, Wn = Math.min(Math.max(I.value + Go, 0.5), 3);
        Wn !== I.value && (J.value = V - me * Wn, Y.value = P - we * Wn, I.value = Wn);
      }
    }
    function qe() {
      return z(this, null, function* () {
        try {
          typeof navigator != "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText == "function" && (yield navigator.clipboard.writeText(ae.value)), G.value = !0, s("copy", ae.value), setTimeout(() => {
            G.value = !1;
          }, 1e3);
        } catch (r) {
          console.error("Failed to copy:", r);
        }
      });
    }
    function at(r, o = null) {
      return z(this, null, function* () {
        try {
          const l = o != null ? o : new XMLSerializer().serializeToString(r), k = new Blob([l], { type: "image/svg+xml;charset=utf-8" }), R = URL.createObjectURL(k);
          if (typeof document != "undefined") {
            const E = document.createElement("a");
            E.href = R, E.download = `mermaid-diagram-${Date.now()}.svg`;
            try {
              document.body.appendChild(E), E.click(), document.body.removeChild(E);
            } catch (V) {
            }
            URL.revokeObjectURL(R);
          }
        } catch (l) {
          console.error("Failed to export SVG:", l);
        }
      });
    }
    function Ne() {
      var k;
      const r = (k = D.value) == null ? void 0 : k.querySelector("svg");
      if (!r) {
        console.error("SVG element not found");
        return;
      }
      const o = new XMLSerializer().serializeToString(r), l = {
        payload: { type: "export" },
        defaultPrevented: !1,
        preventDefault() {
          this.defaultPrevented = !0;
        },
        svgElement: r,
        svgString: o
      };
      s("export", l), l.defaultPrevented || at(r, o);
    }
    function it() {
      var k, R;
      const r = (R = (k = D.value) == null ? void 0 : k.querySelector("svg")) != null ? R : null, o = r ? new XMLSerializer().serializeToString(r) : null, l = {
        payload: { type: "open-modal" },
        defaultPrevented: !1,
        preventDefault() {
          this.defaultPrevented = !0;
        },
        svgElement: r,
        svgString: o
      };
      s("openModal", l), l.defaultPrevented || to();
    }
    function zt(r) {
      const o = {
        payload: { type: "toggle-mode", target: r },
        defaultPrevented: !1,
        preventDefault() {
          this.defaultPrevented = !0;
        }
      };
      s("toggleMode", r, o), o.defaultPrevented || xt(r);
    }
    function xt(r) {
      return z(this, null, function* () {
        const o = Ht.value;
        if (!o) {
          ve.value = !0, q.value = r === "source";
          return;
        }
        const l = o.getBoundingClientRect().height;
        o.style.height = `${l}px`, o.style.overflow = "hidden", ve.value = !0, q.value = r === "source", yield he();
        const k = o.scrollHeight;
        o.style.transition = "height 180ms ease", o.offsetHeight, o.style.height = `${k}px`;
        const R = () => {
          o.style.transition = "", o.style.height = "", o.style.overflow = "", o.removeEventListener("transitionend", E);
        };
        function E() {
          R();
        }
        o.addEventListener("transitionend", E), setTimeout(() => R(), 220);
      });
    }
    function Ze() {
      return z(this, null, function* () {
        if (ie.value)
          return $t.value;
        if (!D.value && (yield he(), !D.value)) {
          console.warn("Mermaid container not ready");
          return;
        }
        return ie.value = !0, $t.value = z(null, null, function* () {
          var r;
          D.value && (D.value.style.opacity = "0");
          try {
            const o = yield re();
            if (!o)
              return;
            const l = `mermaid-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
            !le.value && !$e.value && ((r = o.initialize) == null || r.call(o, Mt(oe({}, f.value), {
              dompurifyConfig: oe({}, a)
            })));
            const k = t.isDark ? "dark" : "light", R = Se(k), E = yield ht(
              () => o.render(
                l,
                R
              ),
              { timeoutMs: K.value.fullRender }
            ), V = E == null ? void 0 : E.svg;
            if (D.value) {
              const P = j(D.value, V);
              !le.value && !$e.value && (on(), le.value = !0, x.value = {
                zoom: I.value,
                translateX: J.value,
                translateY: Y.value,
                containerHeight: Q.value
              });
              const me = t.isDark ? "dark" : "light";
              P && (ot.value[me] = P), $e.value && ($e.value = !1), g.value = !1, yt = 0, nt();
            }
          } catch (o) {
            const l = Lt(o), k = yt + 1;
            if (l && k <= si) {
              yt = k;
              const R = Math.min(1200, 600 * k);
              xe(R);
            } else
              yt = 0, nt(), console.error("Failed to render mermaid diagram:", o), t.loading === !1 && Wt(o);
          } finally {
            yield he(), D.value && (D.value.style.opacity = "1"), ie.value = !1, $t.value = null;
          }
        }), $t.value;
      });
    }
    function Yt(r) {
      return z(this, null, function* () {
        if (pn() && !(!D.value && (yield he(), !D.value)) && !ie.value) {
          ie.value = !0;
          try {
            const o = yield re();
            if (!o)
              return;
            const l = `mermaid-partial-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`, k = t.isDark ? "dark" : "light", R = gn(r), E = R && R.trim() ? R : r, V = Vn(E, k);
            D.value && (D.value.style.opacity = "0");
            const P = yield ht(
              () => o.render(l, V),
              { timeoutMs: K.value.render }
            ), me = P == null ? void 0 : P.svg;
            D.value && me && (j(D.value, me), on());
          } catch (o) {
          } finally {
            yield he(), D.value && (D.value.style.opacity = "1"), ie.value = !1;
          }
        }
      });
    }
    function Ut() {
      return z(this, null, function* () {
        var P, me;
        const r = Date.now(), o = ++Ft.value;
        pe && pe.abort(), pe = new AbortController();
        const l = pe.signal, k = t.isDark ? "dark" : "light", R = ae.value, E = R.replace(/\s+/g, "");
        if (!R.trim()) {
          D.value && ee(D.value), kt.value = null, Re.value = "", g.value = !1;
          return;
        }
        if (E === Re.value)
          return;
        try {
          const we = yield eo(R, k, { signal: l, timeoutMs: K.value.worker });
          if (we.fullOk) {
            yield Ze(), Ft.value === o && (kt.value = (me = (P = D.value) == null ? void 0 : P.innerHTML) != null ? me : null, Re.value = E, g.value = !1);
            return;
          }
          const ln = tn && r <= tn;
          if (we.prefixOk && we.prefix && pn() && !ln) {
            yield Yt(we.prefix);
            return;
          }
        } catch (we) {
          if ((we == null ? void 0 : we.name) === "AbortError")
            return;
        }
        if (Ft.value !== o || g.value)
          return;
        const V = ot.value[k];
        V && D.value && j(D.value, V);
      });
    }
    function pt() {
      Dt && (Dt = !1, ft = 800, Et = !1, Ue && (Ue.abort(), Ue = null), mt && (globalThis.clearTimeout(mt), mt = null), rt && (Ye(rt), rt = null), tn = Date.now());
    }
    function bt() {
      if (pt(), pe) {
        try {
          pe.abort();
        } catch (r) {
        }
        pe = null;
      }
      if (Ue) {
        try {
          Ue.abort();
        } catch (r) {
        }
        Ue = null;
      }
      Bo(), nt(), yt = 0;
    }
    function an(r = 800) {
      Dt && (mt && globalThis.clearTimeout(mt), mt = globalThis.setTimeout(() => {
        rt = jt(() => z(null, null, function* () {
          if (!Dt)
            return;
          if (q.value || le.value) {
            pt();
            return;
          }
          const o = t.isDark ? "dark" : "light", l = ae.value;
          if (!l.trim()) {
            an(ft);
            return;
          }
          Ue && Ue.abort(), Ue = new AbortController();
          try {
            if ((yield Xt(l, o, { signal: Ue.signal, timeoutMs: K.value.worker })) && (yield Ze(), le.value)) {
              pt();
              return;
            }
          } catch (k) {
          }
          ft = Math.min(Math.floor(ft * 1.5), 4e3), an(ft);
        }), { timeout: 500 });
      }, r));
    }
    function sn() {
      Dt || q.value || le.value || (Dt = !0, tn = 0, Et = !0, an(500));
    }
    U(
      () => ae.value,
      () => {
        le.value = !1, ot.value = {}, dt(), !q.value && d.value && sn(), Fn();
      }
    ), U(() => t.isDark, () => z(null, null, function* () {
      if (!le.value || g.value)
        return;
      const r = t.isDark ? "dark" : "light", o = ot.value[r];
      if (o) {
        D.value && j(D.value, o);
        return;
      }
      const l = {
        zoom: I.value,
        translateX: J.value,
        translateY: Y.value,
        containerHeight: Q.value
      }, k = I.value !== 1 || J.value !== 0 || Y.value !== 0;
      $e.value = !0, k && (I.value = 1, J.value = 0, Y.value = 0, yield he()), yield Ze(), k && (yield he(), I.value = l.zoom, J.value = l.translateX, Y.value = l.translateY, Q.value = l.containerHeight, x.value = l);
    })), U(
      () => q.value,
      (r) => z(null, null, function* () {
        if (r)
          pt(), le.value && (x.value = {
            zoom: I.value,
            translateX: J.value,
            translateY: Y.value,
            containerHeight: Q.value
          });
        else {
          if (g.value)
            return;
          const o = t.isDark ? "dark" : "light";
          if (le.value && ot.value[o]) {
            yield he(), D.value && j(D.value, ot.value[o]), I.value = x.value.zoom, J.value = x.value.translateX, Y.value = x.value.translateY, Q.value = x.value.containerHeight;
            return;
          }
          if (yield he(), !d.value)
            return;
          yield Ut(), sn();
        }
      })
    ), U(
      () => t.loading,
      (r, o) => z(null, null, function* () {
        if (o === !0 && r === !1) {
          const l = ae.value.trim();
          if (!l)
            return bt();
          const k = t.isDark ? "dark" : "light", R = l.replace(/\s+/g, "");
          if (le.value && R === Re.value) {
            yield he(), D.value && !D.value.querySelector("svg") && ot.value[k] && j(D.value, ot.value[k]), bt();
            return;
          }
          try {
            yield Xt(l, k, { timeoutMs: K.value.worker }), yield Ze(), Re.value = R, g.value = !1, bt();
          } catch (E) {
            bt(), Wt(E);
          }
        }
      })
    ), U(
      de,
      (r) => {
        be && be.disconnect(), r && !le.value && !$e.value && (be = new ResizeObserver((o) => {
          o && o.length > 0 && !le.value && !$e.value && Ia(() => {
            const l = o[0].contentRect.width;
            on(l);
          });
        }), be.observe(r));
      },
      { immediate: !0 }
    ), io(() => z(null, null, function* () {
      yield he(), ve.value || (q.value = !d.value), W.value && (dt(), wt.value = ae.value.length);
    })), U(
      () => d.value,
      (r) => {
        ve.value || (q.value = !r);
      }
    ), U(
      () => W.value,
      (r) => {
        r && (le.value || (dt(), wt.value = ae.value.length), !t.loading && !le.value && dt());
      },
      { immediate: !1 }
    ), dr(() => {
      ke && clearTimeout(ke), be && be.disconnect(), pe && (pe.abort(), pe = null), Bo(), pt(), nt();
    }), U(
      () => ne.value,
      (r) => z(null, null, function* () {
        r ? (pt(), pe && pe.abort()) : le.value || (yield he(), dt(), q.value || sn());
      }),
      { immediate: !1 }
    );
    const qt = N(() => t.isDark ? "mermaid-action-btn p-2 text-xs rounded text-gray-400 hover:bg-gray-700 hover:text-gray-200" : "mermaid-action-btn p-2 text-xs rounded text-gray-600 hover:bg-gray-200 hover:text-gray-700");
    return (r, o) => (m(), y("div", {
      class: O(["my-4 rounded-lg border overflow-hidden shadow-sm", [
        t.isDark ? "border-gray-700/30" : "border-gray-200",
        { "is-rendering": t.loading }
      ]])
    }, [
      t.showHeader ? (m(), y("div", {
        key: 0,
        class: O(["mermaid-block-header flex justify-between items-center px-4 py-2.5 border-b", t.isDark ? "bg-gray-800 border-gray-700/30" : "bg-gray-50 border-gray-200"])
      }, [
        r.$slots["header-left"] ? (m(), y("div", Pa, [
          Tt(r.$slots, "header-left", {}, void 0, !0)
        ])) : (m(), y("div", Va, [
          h("img", {
            src: $(Ba),
            class: "w-4 h-4 my-0",
            alt: "Mermaid"
          }, null, 8, Oa),
          h("span", {
            class: O(["text-sm font-medium font-mono truncate", t.isDark ? "text-gray-400" : "text-gray-600"])
          }, "Mermaid", 2)
        ])),
        r.$slots["header-center"] ? (m(), y("div", Ka, [
          Tt(r.$slots, "header-center", {}, void 0, !0)
        ])) : t.showModeToggle && d.value ? (m(), y("div", {
          key: 3,
          class: O(["flex items-center space-x-1 rounded-md p-0.5", t.isDark ? "bg-gray-700" : "bg-gray-100"])
        }, [
          h("button", {
            class: O(["px-2.5 py-1 text-xs rounded transition-colors", [
              q.value ? t.isDark ? "text-gray-400 hover:text-gray-200" : "text-gray-500 hover:text-gray-700" : t.isDark ? "bg-gray-600 text-gray-200 shadow-sm" : "bg-white text-gray-700 shadow-sm"
            ]]),
            onClick: o[0] || (o[0] = () => zt("preview")),
            onMouseenter: o[1] || (o[1] = (l) => ge(l, $(T)("common.preview") || "Preview")),
            onFocus: o[2] || (o[2] = (l) => ge(l, $(T)("common.preview") || "Preview")),
            onMouseleave: te,
            onBlur: te
          }, [
            h("div", Fa, [
              o[21] || (o[21] = h("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24",
                class: "w-3 h-3"
              }, [
                h("g", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2"
                }, [
                  h("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0" }),
                  h("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  })
                ])
              ], -1)),
              h("span", null, se($(T)("common.preview") || "Preview"), 1)
            ])
          ], 34),
          h("button", {
            class: O(["px-2.5 py-1 text-xs rounded transition-colors", [
              q.value ? t.isDark ? "bg-gray-600 text-gray-200 shadow-sm" : "bg-white text-gray-700 shadow-sm" : t.isDark ? "text-gray-400 hover:text-gray-200" : "text-gray-500 hover:text-gray-700"
            ]]),
            onClick: o[3] || (o[3] = () => zt("source")),
            onMouseenter: o[4] || (o[4] = (l) => ge(l, $(T)("common.source") || "Source")),
            onFocus: o[5] || (o[5] = (l) => ge(l, $(T)("common.source") || "Source")),
            onMouseleave: te,
            onBlur: te
          }, [
            h("div", Wa, [
              o[22] || (o[22] = h("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24",
                class: "w-3 h-3"
              }, [
                h("path", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m16 18l6-6l-6-6M8 6l-6 6l6 6"
                })
              ], -1)),
              h("span", null, se($(T)("common.source") || "Source"), 1)
            ])
          ], 34)
        ], 2)) : fe("", !0),
        r.$slots["header-right"] ? (m(), y("div", Xa, [
          Tt(r.$slots, "header-right", {}, void 0, !0)
        ])) : (m(), y("div", Ya, [
          t.showCollapseButton ? (m(), y("button", {
            key: 0,
            class: O(qt.value),
            "aria-pressed": ne.value,
            onClick: o[6] || (o[6] = (l) => ne.value = !ne.value),
            onMouseenter: o[7] || (o[7] = (l) => ge(l, ne.value ? $(T)("common.expand") || "Expand" : $(T)("common.collapse") || "Collapse")),
            onFocus: o[8] || (o[8] = (l) => ge(l, ne.value ? $(T)("common.expand") || "Expand" : $(T)("common.collapse") || "Collapse")),
            onMouseleave: te,
            onBlur: te
          }, [
            (m(), y("svg", {
              style: ut({ rotate: ne.value ? "0deg" : "90deg" }),
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "aria-hidden": "true",
              role: "img",
              width: "1em",
              height: "1em",
              viewBox: "0 0 24 24",
              class: "w-3 h-3"
            }, [...o[23] || (o[23] = [
              h("path", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "m9 18l6-6l-6-6"
              }, null, -1)
            ])], 4))
          ], 42, Ua)) : fe("", !0),
          t.showCopyButton ? (m(), y("button", {
            key: 1,
            class: O(qt.value),
            onClick: qe,
            onMouseenter: o[9] || (o[9] = (l) => Pn(l)),
            onFocus: o[10] || (o[10] = (l) => Pn(l)),
            onMouseleave: te,
            onBlur: te
          }, [
            G.value ? (m(), y("svg", Za, [...o[25] || (o[25] = [
              h("path", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M20 6L9 17l-5-5"
              }, null, -1)
            ])])) : (m(), y("svg", qa, [...o[24] || (o[24] = [
              h("g", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2"
              }, [
                h("rect", {
                  width: "14",
                  height: "14",
                  x: "8",
                  y: "8",
                  rx: "2",
                  ry: "2"
                }),
                h("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
              ], -1)
            ])]))
          ], 34)) : fe("", !0),
          t.showExportButton && d.value ? (m(), y("button", {
            key: 2,
            class: O(`${qt.value} ${nn.value ? "opacity-50 cursor-not-allowed" : ""}`),
            disabled: nn.value,
            onClick: Ne,
            onMouseenter: o[11] || (o[11] = (l) => ge(l, $(T)("common.export") || "Export")),
            onFocus: o[12] || (o[12] = (l) => ge(l, $(T)("common.export") || "Export")),
            onMouseleave: te,
            onBlur: te
          }, [...o[26] || (o[26] = [
            h("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "aria-hidden": "true",
              role: "img",
              width: "1em",
              height: "1em",
              viewBox: "0 0 24 24",
              class: "w-3 h-3"
            }, [
              h("g", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2"
              }, [
                h("path", { d: "M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                h("path", { d: "m7 10l5 5l5-5" })
              ])
            ], -1)
          ])], 42, Ga)) : fe("", !0),
          t.showFullscreenButton && d.value ? (m(), y("button", {
            key: 3,
            class: O(`${qt.value} ${nn.value ? "opacity-50 cursor-not-allowed" : ""}`),
            disabled: nn.value,
            onClick: it,
            onMouseenter: o[13] || (o[13] = (l) => ge(l, vt.value ? $(T)("common.minimize") || "Minimize" : $(T)("common.open") || "Open")),
            onFocus: o[14] || (o[14] = (l) => ge(l, vt.value ? $(T)("common.minimize") || "Minimize" : $(T)("common.open") || "Open")),
            onMouseleave: te,
            onBlur: te
          }, [
            vt.value ? (m(), y("svg", ei, [...o[28] || (o[28] = [
              h("path", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "m14 10l7-7m-1 7h-6V4M3 21l7-7m-6 0h6v6"
              }, null, -1)
            ])])) : (m(), y("svg", Qa, [...o[27] || (o[27] = [
              h("path", {
                fill: "none",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 3h6v6m0-6l-7 7M3 21l7-7m-1 7H3v-6"
              }, null, -1)
            ])]))
          ], 42, Ja)) : fe("", !0)
        ]))
      ], 2)) : fe("", !0),
      Rn(h("div", {
        ref_key: "modeContainerRef",
        ref: Ht
      }, [
        q.value ? (m(), y("div", {
          key: 0,
          class: O(["p-4", t.isDark ? "bg-gray-900" : "bg-gray-50"])
        }, [
          h("pre", {
            class: O(["text-sm font-mono whitespace-pre-wrap", t.isDark ? "text-gray-300" : "text-gray-700"])
          }, se(ae.value), 3)
        ], 2)) : (m(), y("div", ti, [
          t.showZoomControls ? (m(), y("div", ni, [
            h("div", oi, [
              h("button", {
                class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                onClick: i,
                onMouseenter: o[15] || (o[15] = (l) => ge(l, $(T)("common.zoomIn") || "Zoom in")),
                onFocus: o[16] || (o[16] = (l) => ge(l, $(T)("common.zoomIn") || "Zoom in")),
                onMouseleave: te,
                onBlur: te
              }, [...o[29] || (o[29] = [
                h("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "aria-hidden": "true",
                  role: "img",
                  width: "1em",
                  height: "1em",
                  viewBox: "0 0 24 24",
                  class: "w-3 h-3"
                }, [
                  h("g", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2"
                  }, [
                    h("circle", {
                      cx: "11",
                      cy: "11",
                      r: "8"
                    }),
                    h("path", { d: "m21 21l-4.35-4.35M11 8v6m-3-3h6" })
                  ])
                ], -1)
              ])], 34),
              h("button", {
                class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                onClick: u,
                onMouseenter: o[17] || (o[17] = (l) => ge(l, $(T)("common.zoomOut") || "Zoom out")),
                onFocus: o[18] || (o[18] = (l) => ge(l, $(T)("common.zoomOut") || "Zoom out")),
                onMouseleave: te,
                onBlur: te
              }, [...o[30] || (o[30] = [
                h("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "aria-hidden": "true",
                  role: "img",
                  width: "1em",
                  height: "1em",
                  viewBox: "0 0 24 24",
                  class: "w-3 h-3"
                }, [
                  h("g", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2"
                  }, [
                    h("circle", {
                      cx: "11",
                      cy: "11",
                      r: "8"
                    }),
                    h("path", { d: "m21 21l-4.35-4.35M8 11h6" })
                  ])
                ], -1)
              ])], 34),
              h("button", {
                class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                onClick: p,
                onMouseenter: o[19] || (o[19] = (l) => ge(l, $(T)("common.resetZoom") || "Reset zoom")),
                onFocus: o[20] || (o[20] = (l) => ge(l, $(T)("common.resetZoom") || "Reset zoom")),
                onMouseleave: te,
                onBlur: te
              }, se(Math.round(I.value * 100)) + "% ", 35)
            ])
          ])) : fe("", !0),
          h("div", Kt({
            ref_key: "mermaidContainer",
            ref: de,
            class: ["min-h-[360px] relative transition-all duration-100 overflow-hidden block", t.isDark ? "bg-gray-900" : "bg-gray-50"],
            style: { height: Q.value }
          }, bo(B.value, !0), {
            onMousedown: L,
            onMousemove: _,
            onMouseup: X,
            onMouseleave: X,
            onTouchstartPassive: L,
            onTouchmovePassive: _,
            onTouchendPassive: X
          }), [
            h("div", {
              "data-mermaid-wrapper": "",
              class: O(["absolute inset-0 cursor-grab", { "cursor-grabbing": Le.value }]),
              style: ut(wn.value)
            }, [
              h("div", {
                ref_key: "mermaidContent",
                ref: D,
                class: "_mermaid w-full text-center flex items-center justify-center min-h-full"
              }, null, 512)
            ], 6)
          ], 16),
          (m(), ye(Ho, { to: "body" }, [
            ct(zn, {
              name: "mermaid-dialog",
              appear: ""
            }, {
              default: en(() => [
                vt.value ? (m(), y("div", {
                  key: 0,
                  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4",
                  onClick: mr(rn, ["self"])
                }, [
                  h("div", {
                    class: O(["dialog-panel relative w-full h-full max-w-full max-h-full rounded shadow-lg overflow-hidden", t.isDark ? "bg-gray-900" : "bg-white"])
                  }, [
                    h("div", ri, [
                      h("button", {
                        class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                        onClick: i
                      }, [...o[31] || (o[31] = [
                        h("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "aria-hidden": "true",
                          role: "img",
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 24 24",
                          class: "w-3 h-3"
                        }, [
                          h("g", {
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                          }, [
                            h("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            h("path", { d: "m21 21l-4.35-4.35M11 8v6m-3-3h6" })
                          ])
                        ], -1)
                      ])], 2),
                      h("button", {
                        class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                        onClick: u
                      }, [...o[32] || (o[32] = [
                        h("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "aria-hidden": "true",
                          role: "img",
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 24 24",
                          class: "w-3 h-3"
                        }, [
                          h("g", {
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                          }, [
                            h("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            h("path", { d: "m21 21l-4.35-4.35M8 11h6" })
                          ])
                        ], -1)
                      ])], 2),
                      h("button", {
                        class: O(["p-2 text-xs rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                        onClick: p
                      }, se(Math.round(I.value * 100)) + "% ", 3),
                      h("button", {
                        class: O(["inline-flex items-center justify-center p-2 rounded transition-colors", [t.isDark ? "text-gray-400 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-200"]]),
                        onClick: rn
                      }, [...o[33] || (o[33] = [
                        h("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "aria-hidden": "true",
                          role: "img",
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 24 24",
                          class: "w-3 h-3"
                        }, [
                          h("path", {
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M18 6L6 18M6 6l12 12"
                          })
                        ], -1)
                      ])], 2)
                    ]),
                    h("div", Kt({
                      ref_key: "modalContent",
                      ref: We,
                      class: "w-full h-full flex items-center justify-center p-4 overflow-hidden"
                    }, bo(B.value, !0), {
                      onMousedown: L,
                      onMousemove: _,
                      onMouseup: X,
                      onMouseleave: X,
                      onTouchstartPassive: L,
                      onTouchmovePassive: _,
                      onTouchendPassive: X
                    }), null, 16)
                  ], 2)
                ])) : fe("", !0)
              ]),
              _: 1
            })
          ]))
        ]))
      ], 512), [
        [Nn, !ne.value]
      ])
    ], 2));
  }
}), dn = /* @__PURE__ */ Z(li, [["__scopeId", "data-v-3636e700"]]);
dn.install = (e) => {
  e.component(dn.__name, dn);
};
const ci = {
  dir: "auto",
  class: "paragraph-node"
}, ui = /* @__PURE__ */ F({
  __name: "ParagraphNode",
  props: {
    node: {},
    customId: {},
    indexKey: {}
  },
  setup(e) {
    const n = e, t = Bt(n.customId), s = oe({
      inline_code: ze,
      image: Pt,
      link: Ke,
      hardbreak: Jt,
      emphasis: tt,
      strong: Ve,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      html_inline: Ae,
      emoji: je,
      checkbox: _t,
      math_inline: It,
      checkbox_input: _t,
      reference: Pe,
      footnote_anchor: un,
      footnote_reference: De
    }, t), a = Xo();
    return (d, c) => (m(), y("p", ci, [
      (m(!0), y(ue, null, Be(e.node.children, (f, w) => (m(), y(ue, {
        key: `${e.indexKey || "paragraph"}-${w}`
      }, [
        f.type !== "text" ? (m(), ye(Fe(s[f.type]), {
          key: 0,
          node: f,
          "index-key": `${e.indexKey}-${w}`,
          "custom-id": n.customId
        }, null, 8, ["node", "index-key", "custom-id"])) : (m(), y("span", {
          key: 1,
          class: O([[$(a) && f.center ? "text-node-center" : ""], "whitespace-pre-wrap break-words text-node"])
        }, se(f.content), 3))
      ], 64))), 128))
    ]));
  }
}), $n = /* @__PURE__ */ Z(ui, [["__scopeId", "data-v-0117537a"]]);
$n.install = (e) => {
  e.component($n.__name, $n);
};
const di = ["aria-busy", "aria-label", "data-language"], mi = ["textContent"], mn = /* @__PURE__ */ F({
  __name: "PreCodeNode",
  props: {
    node: {}
  },
  setup(e) {
    const n = e, t = N(() => {
      var w, v, b;
      const d = String((v = (w = n.node) == null ? void 0 : w.language) != null ? v : "");
      return String((b = String(d).split(/\s+/g)[0]) != null ? b : "").toLowerCase().replace(/[^\w-]/g, "") || "plaintext";
    }), s = N(() => `language-${t.value}`), a = N(() => {
      const d = t.value;
      return d ? `Code block: ${d}` : "Code block";
    });
    return (d, c) => (m(), y("pre", {
      class: O([s.value]),
      "aria-busy": e.node.loading === !0,
      "aria-label": a.value,
      "data-language": t.value,
      tabindex: "0"
    }, [
      h("code", {
        translate: "no",
        textContent: se(e.node.code)
      }, null, 8, mi)
    ], 10, di));
  }
});
mn.install = (e) => {
  e.component(mn.__name, mn);
};
const fi = { class: "table-node-wrapper" }, hi = ["aria-busy"], vi = { class: "border-[var(--table-border,#cbd5e1)]" }, pi = { class: "border-b" }, gi = {
  key: 0,
  class: "table-node__loading",
  role: "status",
  "aria-live": "polite"
}, wi = /* @__PURE__ */ F({
  __name: "TableNode",
  props: {
    node: {},
    indexKey: {},
    isDark: { type: Boolean },
    typewriter: { type: Boolean },
    customId: {}
  },
  emits: ["copy"],
  setup(e) {
    const n = e, t = N(() => {
      var c, f, w, v;
      return (v = (w = (f = (c = n.node) == null ? void 0 : c.header) == null ? void 0 : f.cells) == null ? void 0 : w.length) != null ? v : 0;
    }), s = N(() => {
      const c = t.value || 1, f = Math.floor(100 / c);
      return Array.from({ length: c }).map(
        (w, v) => v === c - 1 ? `${100 - f * (c - 1)}%` : `${f}%`
      );
    }), a = N(() => {
      var c;
      return (c = n.node.loading) != null ? c : !1;
    }), d = N(() => {
      var c;
      return (c = n.node.rows) != null ? c : [];
    });
    return (c, f) => (m(), y("div", fi, [
      h("table", {
        class: O(["w-full my-8 text-sm table-fixed table-node", { "table-node--loading": a.value }]),
        "aria-busy": a.value
      }, [
        h("colgroup", null, [
          (m(!0), y(ue, null, Be(s.value, (w, v) => (m(), y("col", {
            key: `col-${v}`,
            style: ut({ width: w })
          }, null, 4))), 128))
        ]),
        h("thead", vi, [
          h("tr", pi, [
            (m(!0), y(ue, null, Be(e.node.header.cells, (w, v) => (m(), y("th", {
              key: `header-${v}`,
              dir: "auto",
              class: O(["font-semibold p-[calc(4/7*1em)] overflow-x-auto", [
                w.align === "right" ? "text-right" : w.align === "center" ? "text-center" : "text-left"
              ]])
            }, [
              ct($(lt), {
                nodes: w.children,
                "index-key": `table-th-${n.indexKey}`,
                "custom-id": n.customId,
                typewriter: n.typewriter,
                onCopy: f[0] || (f[0] = (b) => c.$emit("copy", b))
              }, null, 8, ["nodes", "index-key", "custom-id", "typewriter"])
            ], 2))), 128))
          ])
        ]),
        h("tbody", null, [
          (m(!0), y(ue, null, Be(d.value, (w, v) => (m(), y("tr", {
            key: `row-${v}`,
            class: O(["border-[var(--table-border,#cbd5e1)]", [v < d.value.length - 1 ? "border-b" : ""]])
          }, [
            (m(!0), y(ue, null, Be(w.cells, (b, C) => (m(), y("td", {
              key: `cell-${v}-${C}`,
              class: O(["p-[calc(4/7*1em)] overflow-x-auto", [
                b.align === "right" ? "text-right" : b.align === "center" ? "text-center" : "text-left"
              ]]),
              dir: "auto"
            }, [
              ct($(lt), {
                nodes: b.children,
                "index-key": `table-td-${n.indexKey}`,
                "custom-id": n.customId,
                typewriter: n.typewriter,
                onCopy: f[1] || (f[1] = (H) => c.$emit("copy", H))
              }, null, 8, ["nodes", "index-key", "custom-id", "typewriter"])
            ], 2))), 128))
          ], 2))), 128))
        ])
      ], 10, hi),
      ct(zn, { name: "table-node-fade" }, {
        default: en(() => [
          a.value ? (m(), y("div", gi, [
            Tt(c.$slots, "loading", { isLoading: a.value }, () => [
              f[2] || (f[2] = h("span", {
                class: "table-node__spinner animate-spin",
                "aria-hidden": "true"
              }, null, -1)),
              f[3] || (f[3] = h("span", { class: "sr-only" }, "Loading", -1))
            ], !0)
          ])) : fe("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Sn = /* @__PURE__ */ Z(wi, [["__scopeId", "data-v-a874491c"]]);
Sn.install = (e) => {
  e.component(Sn.__name, Sn);
};
const yi = {}, ki = { class: "hr-node" };
function xi(e, n) {
  return m(), y("hr", ki);
}
const En = /* @__PURE__ */ Z(yi, [["render", xi], ["__scopeId", "data-v-639cbad9"]]);
En.install = (e) => {
  e.component(En.__name, En);
};
const bi = {
  key: 1,
  class: "html-block-node__placeholder"
}, Mi = /* @__PURE__ */ F({
  __name: "HtmlBlockNode",
  props: {
    node: {}
  },
  setup(e) {
    const n = e, t = N(() => {
      const v = n.node.attrs;
      if (v) {
        if (Array.isArray(v)) {
          const b = {};
          for (const C of v) {
            if (!C || C.length < 2)
              continue;
            const [H, A] = C;
            H != null && (b[String(H)] = A == null ? "" : String(A));
          }
          return b;
        }
        return v;
      }
    }), s = M(null), a = M(typeof window == "undefined"), d = M(n.node.content), c = fo(), f = M(null), w = !!n.node.loading;
    return typeof window != "undefined" ? (U(
      s,
      (v) => {
        var C, H;
        if ((H = (C = f.value) == null ? void 0 : C.destroy) == null || H.call(C), f.value = null, !w) {
          a.value = !0, d.value = n.node.content;
          return;
        }
        if (!v) {
          a.value = !1;
          return;
        }
        const b = c(v, { rootMargin: "400px" });
        f.value = b, a.value = b.isVisible.value, b.whenVisible.then(() => {
          a.value = !0;
        });
      },
      { immediate: !0 }
    ), U(
      () => n.node.content,
      (v) => {
        (!w || a.value) && (d.value = v);
      }
    )) : a.value = !0, hn(() => {
      var v, b;
      (b = (v = f.value) == null ? void 0 : v.destroy) == null || b.call(v), f.value = null;
    }), (v, b) => (m(), y("div", Kt({
      ref_key: "htmlRef",
      ref: s,
      class: "html-block-node"
    }, t.value), [
      a.value ? fn([d.value], () => (m(), y("div", {
        key: 0,
        innerHTML: d.value
      }, null, 8, ["innerHTML"])), b, 0) : (m(), y("div", bi, [
        Tt(v.$slots, "placeholder", { node: e.node }, () => [
          b[1] || (b[1] = h("span", { class: "html-block-node__placeholder-bar" }, null, -1)),
          b[2] || (b[2] = h("span", { class: "html-block-node__placeholder-bar w-4/5" }, null, -1)),
          b[3] || (b[3] = h("span", { class: "html-block-node__placeholder-bar w-2/3" }, null, -1))
        ], !0)
      ]))
    ], 16));
  }
}), Ci = /* @__PURE__ */ Z(Mi, [["__scopeId", "data-v-ed22b926"]]), Ti = { class: "unknown-node" }, Io = /* @__PURE__ */ F({
  __name: "FallbackComponent",
  props: {
    node: {}
  },
  setup(e) {
    return (n, t) => (m(), y("div", Ti, se(e.node.raw), 1));
  }
}), _i = ["data-node-index", "data-node-type"], Bi = 900, Ii = 640, $i = 200, Si = 1800, Ei = /* @__PURE__ */ F({
  __name: "NodeRenderer",
  props: {
    content: {},
    nodes: {},
    parseOptions: {},
    customMarkdownIt: {},
    customHtmlTags: {},
    viewportPriority: { type: Boolean },
    codeBlockStream: { type: Boolean, default: !0 },
    codeBlockDarkTheme: {},
    codeBlockLightTheme: {},
    codeBlockMonacoOptions: {},
    renderCodeBlocksAsPre: { type: Boolean },
    codeBlockMinWidth: {},
    codeBlockMaxWidth: {},
    codeBlockProps: {},
    themes: {},
    isDark: { type: Boolean },
    customId: {},
    indexKey: {},
    typewriter: { type: Boolean, default: !0 },
    batchRendering: { type: Boolean, default: !0 },
    initialRenderBatchSize: { default: 40 },
    renderBatchSize: { default: 80 },
    renderBatchDelay: { default: 16 },
    renderBatchBudgetMs: { default: 6 },
    renderBatchIdleTimeoutMs: { default: 120 },
    deferNodesUntilVisible: { type: Boolean, default: !0 },
    maxLiveNodes: { default: 320 },
    liveNodeBuffer: { default: 60 }
  },
  emits: ["copy", "handleArtifactClick", "click", "mouseover", "mouseout"],
  setup(e, { emit: n }) {
    var rn, Kn, Fn;
    const t = e, s = n, a = M(), d = M(!1), c = /auto|scroll|overlay/i;
    function f(i) {
      if (typeof window == "undefined")
        return null;
      const u = i != null ? i : a.value;
      if (!u)
        return null;
      const p = u.ownerDocument || document, L = p.scrollingElement || p.documentElement;
      let _ = u;
      for (; _ && !(_ === p.body || _ === L); ) {
        const X = window.getComputedStyle(_), Te = (X.overflowY || "").toLowerCase(), qe = (X.overflow || "").toLowerCase();
        if (c.test(Te) || c.test(qe))
          return _;
        _ = _.parentElement;
      }
      return null;
    }
    const w = t.customId ? `renderer-${t.customId}` : `renderer-${Date.now()}-${Math.random().toString(36).slice(2)}`, v = xo(w), b = N(() => {
      const i = t.customHtmlTags;
      return !i || i.length === 0 ? v : xo(w, { customHtmlTags: i });
    }), C = N(() => {
      const i = b.value;
      return t.customMarkdownIt ? t.customMarkdownIt(i) : i;
    });
    function H(i) {
      const u = String(i != null ? i : "").trim();
      if (!u)
        return "";
      const p = u.match(/^[<\s/]*([A-Z][\w-]*)/i);
      return p ? p[1].toLowerCase() : "";
    }
    const A = N(() => {
      var _, X, Te;
      const i = (_ = t.parseOptions) != null ? _ : {}, u = (X = t.customHtmlTags) != null ? X : [], p = (Te = i.customHtmlTags) != null ? Te : [], L = [...u, ...p].map(H).filter(Boolean);
      return L.length ? Mt(oe({}, i), {
        customHtmlTags: Array.from(new Set(L))
      }) : i;
    }), S = N(() => {
      var i;
      if ((i = t.nodes) != null && i.length)
        return Mo(t.nodes.slice());
      if (t.content) {
        const u = or(t.content, C.value, A.value);
        return Mo(u);
      }
      return [];
    }), ee = N(() => {
      var i;
      return Math.max(1, (i = t.maxLiveNodes) != null ? i : 320);
    }), j = N(() => {
      var i;
      return ((i = t.maxLiveNodes) != null ? i : 0) <= 0 ? !1 : S.value.length > ee.value;
    }), T = N(() => !(t.viewportPriority === !1 || d.value || t.deferNodesUntilVisible === !1 || j.value || S.value.length > Bi)), re = Ar(
      (i) => {
        var u;
        return f((u = i != null ? i : a.value) != null ? u : null);
      },
      T
    ), G = typeof window != "undefined", ne = G && typeof window.requestAnimationFrame == "function" ? window.requestAnimationFrame.bind(window) : null, de = G && typeof window.cancelAnimationFrame == "function" ? window.cancelAnimationFrame.bind(window) : null, D = typeof globalThis != "undefined" && typeof globalThis.process != "undefined" && ((Kn = (rn = globalThis.process) == null ? void 0 : rn.env) == null ? void 0 : Kn.NODE_ENV) === "test", We = G && typeof window.requestIdleCallback == "function", ce = N(() => {
      var u;
      const i = Math.trunc((u = t.renderBatchSize) != null ? u : 80);
      return Number.isFinite(i) ? Math.max(0, i) : 0;
    }), Ee = N(() => {
      var u;
      const i = Math.trunc((u = t.initialRenderBatchSize) != null ? u : ce.value);
      return Number.isFinite(i) ? Math.max(0, i) : ce.value;
    }), gt = N(() => t.batchRendering !== !1 && ce.value > 0 && G && !D), W = M(0), Ht = M({
      key: t.indexKey,
      total: 0
    }), ae = M(Math.max(1, ce.value || 1)), Se = Xn({}), I = /* @__PURE__ */ new Map(), J = /* @__PURE__ */ new Map(), Y = /* @__PURE__ */ new Map(), Le = M(null);
    let Xe = null, q = null;
    const ve = N(() => !1), ie = N(() => {
      var i;
      return gt.value && ((i = t.maxLiveNodes) != null ? i : 0) <= 0;
    }), $t = M({
      batchSize: ce.value,
      initial: Ee.value,
      delay: (Fn = t.renderBatchDelay) != null ? Fn : 16,
      enabled: ie.value
    }), wt = N(() => !!re && (ve.value || j.value)), St = N(() => {
      var i;
      return Math.max(0, (i = t.liveNodeBuffer) != null ? i : 60);
    }), ke = M(0), Ce = Xn({ start: 0, end: 0 }), yt = /* @__PURE__ */ new Map(), jt = N(() => {
      if (!j.value)
        return S.value.length;
      const i = St.value, u = Math.max(Ce.end + i, Ee.value), p = Math.min(S.value.length, u);
      return Math.max(W.value, p);
    });
    function dt(i) {
      var L, _, X;
      const u = f((L = a.value) != null ? L : null);
      if (u)
        return u;
      const p = (X = (_ = a.value) == null ? void 0 : _.ownerDocument) != null ? X : typeof document != "undefined" ? document : null;
      return (p == null ? void 0 : p.scrollingElement) || (p == null ? void 0 : p.documentElement) || null;
    }
    function nt() {
      Xe && (Xe(), Xe = null), Le.value = null;
    }
    function xe() {
      if (!G || !j.value)
        return;
      const i = dt();
      if (!i || Le.value === i)
        return;
      nt();
      const u = () => be();
      i.addEventListener("scroll", u, { passive: !0 }), Le.value = i, Xe = () => {
        i.removeEventListener("scroll", u);
      };
    }
    function Q() {
      var u, p, L;
      if (!q)
        return;
      const i = (L = (p = (u = a.value) == null ? void 0 : u.ownerDocument) == null ? void 0 : p.defaultView) != null ? L : typeof window != "undefined" ? window : null;
      q.viaTimeout ? i ? i.clearTimeout(q.id) : clearTimeout(q.id) : de == null || de(q.id), q = null;
    }
    function be(i = {}) {
      var p, L, _;
      if (!j.value)
        return;
      if (!G) {
        le(!0);
        return;
      }
      if (i.immediate) {
        Q(), le(!0);
        return;
      }
      if (q)
        return;
      const u = () => {
        q = null, le();
      };
      if (ne)
        q = { id: ne(u), viaTimeout: !1 };
      else {
        const X = (_ = (L = (p = a.value) == null ? void 0 : p.ownerDocument) == null ? void 0 : L.defaultView) != null ? _ : typeof window != "undefined" ? window : null;
        q = { id: X ? X.setTimeout(u, 16) : setTimeout(u, 16), viaTimeout: !0 };
      }
    }
    function le(i = !1) {
      var xt, Ze, Yt, Ut, pt, bt, an, sn, qt, yn, kn;
      if (!j.value)
        return;
      const u = Le.value || dt();
      if (!u)
        return;
      const p = u.ownerDocument || ((xt = a.value) == null ? void 0 : xt.ownerDocument) || document, L = (p == null ? void 0 : p.defaultView) || (typeof window != "undefined" ? window : null), _ = u === (p == null ? void 0 : p.documentElement) || u === (p == null ? void 0 : p.body), X = _ ? null : u.getBoundingClientRect(), Te = _ ? 0 : X.top, qe = _ ? (Yt = (Ze = L == null ? void 0 : L.innerHeight) != null ? Ze : u.clientHeight) != null ? Yt : 0 : X.bottom, at = Array.from(Y.entries()).sort((r, o) => r[0] - o[0]);
      let Ne = null, it = null;
      for (const [r, o] of at) {
        if (!o)
          continue;
        const l = o.getBoundingClientRect();
        l.bottom <= Te || l.top >= qe || (Ne == null && (Ne = r), it = r);
      }
      if (Ne == null || it == null) {
        const r = a.value;
        if (!r)
          return;
        const o = _ ? { top: 0 } : u.getBoundingClientRect(), l = r.getBoundingClientRect(), k = _ ? (an = (bt = (Ut = p == null ? void 0 : p.documentElement) == null ? void 0 : Ut.scrollTop) != null ? bt : (pt = p == null ? void 0 : p.body) == null ? void 0 : pt.scrollTop) != null ? an : 0 : u.scrollTop, R = l.top - (_ ? 0 : o.top) + k, E = Math.max(0, k - R), V = _ ? (kn = (yn = (qt = L == null ? void 0 : L.innerHeight) != null ? qt : (sn = p == null ? void 0 : p.documentElement) == null ? void 0 : sn.clientHeight) != null ? yn : u.clientHeight) != null ? kn : 0 : u.clientHeight, P = E + Math.max(0, V) * 0.5, me = Ye(P);
        ke.value = $e(me, 0, Math.max(0, S.value.length - 1));
        return;
      }
      const zt = Math.round((Ne + it) / 2);
      !i && Math.abs(zt - ke.value) <= 1 || (ke.value = $e(zt, 0, Math.max(0, S.value.length - 1)));
    }
    function $e(i, u, p) {
      return Math.min(Math.max(i, u), p);
    }
    function ot() {
      const i = S.value.length;
      if (!j.value || i === 0) {
        Ce.start = 0, Ce.end = i;
        return;
      }
      const u = Math.min(ee.value, i), p = St.value, L = $e(ke.value - p, 0, Math.max(0, i - u));
      Ce.start = L, Ce.end = Math.min(i, L + u);
    }
    const kt = Xn({}), Re = Xn({ total: 0, count: 0 });
    function Ft(i, u) {
      if (!Number.isFinite(u) || u <= 0)
        return;
      const p = kt[i];
      kt[i] = u, p ? Re.total += u - p : (Re.total += u, Re.count++);
    }
    const pe = N(() => Re.count > 0 ? Math.max(12, Re.total / Re.count) : 32);
    function g(i, u) {
      var L;
      if (i >= u)
        return 0;
      let p = 0;
      for (let _ = i; _ < u; _++)
        p += (L = kt[_]) != null ? L : pe.value;
      return p;
    }
    const x = N(() => {
      if (!j.value)
        return S.value.map((L, _) => ({ node: L, index: _ }));
      const i = S.value.length, u = $e(Ce.start, 0, i), p = $e(Ce.end, u, i);
      return S.value.slice(u, p).map((L, _) => ({
        node: L,
        index: u + _
      }));
    }), B = N(() => j.value ? g(0, Math.min(Ce.start, S.value.length)) : 0), K = N(() => {
      if (!j.value)
        return 0;
      const i = S.value.length, u = Math.min(Ce.end, i);
      return g(u, i);
    });
    function Ye(i) {
      var L;
      if (i <= 0)
        return 0;
      let u = i;
      const p = S.value;
      for (let _ = 0; _ < p.length; _++) {
        const X = (L = kt[_]) != null ? L : pe.value;
        if (u <= X)
          return _;
        u -= X;
      }
      return Math.max(0, p.length - 1);
    }
    function mt(i) {
      if (I.size && j.value)
        for (const [u, p] of I)
          u >= i && (p.destroy(), I.delete(u), ve.value && delete Se[u], te(u), Y.delete(u));
    }
    function rt(i, u) {
      ve.value && (Se[i] = u), u && (j.value ? be() : ke.value = $e(i, 0, Math.max(0, S.value.length - 1)));
    }
    function Dt(i) {
      return ie.value && i >= W.value ? !1 : !ve.value || i < Ee.value ? !0 : Se[i] === !0;
    }
    function ft(i) {
      const u = I.get(i);
      u && (u.destroy(), I.delete(i)), te(i);
    }
    function Ue(i, u) {
      if (u ? Y.set(i, u) : Y.delete(i), u || te(i), !wt.value || !re) {
        ft(i), u ? rt(i, !0) : ve.value && delete Se[i];
        return;
      }
      if (!j.value && ve.value && !d.value && I.size >= Ii && (Vn(), !wt.value || !re)) {
        ft(i), u ? rt(i, !0) : ve.value && delete Se[i];
        return;
      }
      if (i < Ee.value && !j.value) {
        ft(i), rt(i, !0);
        return;
      }
      if (!u) {
        ft(i), ve.value && delete Se[i];
        return;
      }
      ft(i);
      const p = re(u, { rootMargin: "400px" });
      p && (I.set(i, p), rt(i, p.isVisible.value), ve.value && Pn(i), p.whenVisible.then(() => {
        te(i), rt(i, !0);
      }).catch(() => {
      }).finally(() => {
        I.get(i) === p && I.delete(i);
        try {
          p.destroy();
        } catch (L) {
        }
      }), j.value && be());
    }
    function tn(i, u) {
      if (!u) {
        yt.delete(i);
        return;
      }
      yt.set(i, u), queueMicrotask(() => {
        Ft(i, u.offsetHeight);
      });
    }
    let Et = null, ht = null, Wt = !1, Lt = null, At = null;
    function ge() {
      G && (Et != null && (de == null || de(Et), Et = null), ht != null && (window.clearTimeout(ht), ht = null), At != null && typeof window.cancelIdleCallback == "function" && (window.cancelIdleCallback(At), At = null), Wt = !1, Lt = null);
    }
    function te(i) {
      if (!G)
        return;
      const u = J.get(i);
      u != null && (window.clearTimeout(u), J.delete(i));
    }
    function Pn(i) {
      if (!G || !ve.value)
        return;
      te(i);
      const u = window.setTimeout(() => {
        J.delete(i), rt(i, !0);
      }, Si);
      J.set(i, u);
    }
    function Vn(i) {
      if (!d.value) {
        d.value = !0;
        for (const u of I.values())
          u.destroy();
        if (I.clear(), G)
          for (const u of J.values())
            window.clearTimeout(u);
        J.clear();
        for (const u of Object.keys(Se))
          delete Se[u];
      }
    }
    function pn(i, u = {}) {
      var Te, qe;
      if (!ie.value)
        return;
      const p = jt.value;
      if (W.value >= p)
        return;
      const L = Math.max(1, i), _ = (at) => {
        var Ze;
        Et = null, ht = null, At = null, Wt = !1;
        const Ne = Lt != null ? Lt : L;
        Lt = null;
        const it = Math.max(2, (Ze = t.renderBatchBudgetMs) != null ? Ze : 6), zt = (Yt) => {
          const Ut = typeof performance != "undefined" ? performance.now() : Date.now();
          W.value = Math.min(p, W.value + Math.max(1, Yt)), mt(W.value);
          const bt = (typeof performance != "undefined" ? performance.now() : Date.now()) - Ut;
          return Qn(bt), bt;
        };
        let xt = Ne;
        for (; zt(xt), !(W.value >= p || !at || (typeof at.timeRemaining == "function" ? at.timeRemaining() : 0) <= it * 0.5); )
          xt = Math.max(1, Math.round(ae.value));
        W.value < p && gn();
      };
      if (!G || u.immediate) {
        _();
        return;
      }
      const X = Math.max(0, (Te = t.renderBatchDelay) != null ? Te : 16);
      if (Lt = Lt != null ? Math.max(Lt, L) : L, !Wt) {
        if (Wt = !0, !D && We && window.requestIdleCallback) {
          const at = Math.max(0, (qe = t.renderBatchIdleTimeoutMs) != null ? qe : 120);
          At = window.requestIdleCallback((Ne) => {
            _(Ne);
          }, { timeout: at });
          return;
        }
        if (!ne || D) {
          ht = window.setTimeout(() => _(), X);
          return;
        }
        Et = ne(() => {
          if (X === 0) {
            _();
            return;
          }
          ht = window.setTimeout(() => _(), X);
        });
      }
    }
    function gn() {
      if (!ie.value)
        return;
      const i = gt.value ? Math.max(1, Math.round(ae.value)) : Math.max(1, ce.value);
      pn(i);
    }
    function Qn(i) {
      var _;
      if (!ie.value)
        return;
      const u = Math.max(2, (_ = t.renderBatchBudgetMs) != null ? _ : 6), p = Math.max(1, ce.value || 1), L = Math.max(1, Math.floor(p / 4));
      i > u * 1.2 ? ae.value = Math.max(L, Math.floor(ae.value * 0.7)) : i < u * 0.5 && ae.value < p && (ae.value = Math.min(p, Math.ceil(ae.value * 1.2)));
    }
    U(
      [
        () => S.value,
        () => S.value.length,
        () => ie.value,
        () => ce.value,
        () => Ee.value,
        () => t.renderBatchDelay,
        () => t.indexKey
      ],
      () => {
        var Ze;
        const u = S.value.length, p = Ht.value, L = t.indexKey, _ = L !== void 0 && L !== p.key, X = u !== p.total, Te = _ || X;
        Ht.value = { key: L, total: u };
        const qe = $t.value, at = (Ze = t.renderBatchDelay) != null ? Ze : 16, Ne = qe.batchSize !== ce.value || qe.initial !== Ee.value || qe.delay !== at || qe.enabled !== ie.value;
        $t.value = {
          batchSize: ce.value,
          initial: Ee.value,
          delay: at,
          enabled: ie.value
        }, (Te || Ne || !ie.value) && ge(), (Te || Ne) && (ae.value = Math.max(1, ce.value || 1)), Te && j.value && be({ immediate: !0 });
        const it = jt.value;
        if (!u) {
          W.value = 0, mt(0);
          return;
        }
        if (!ie.value) {
          W.value = it, mt(W.value);
          return;
        }
        _ || p.total === 0 || Ne ? W.value = Math.min(it, Ee.value) : W.value = Math.min(W.value, it);
        const xt = Math.max(1, Ee.value || ce.value || u);
        W.value < it ? pn(xt, { immediate: !G }) : mt(W.value);
      },
      { immediate: !0 }
    ), U(
      () => j.value,
      (i) => {
        if (!i) {
          nt(), Q();
          return;
        }
        xe(), be({ immediate: !0 });
      },
      { immediate: !0 }
    ), U(
      () => a.value,
      () => {
        j.value && (xe(), be({ immediate: !0 }));
      }
    ), U(
      () => S.value.length,
      () => {
        j.value && be({ immediate: !0 });
      }
    ), U(
      () => ve.value,
      (i) => {
        if (!i) {
          for (const u of I.values())
            u.destroy();
          I.clear();
          for (const u of Array.from(J.keys()))
            te(u);
          for (const u of Object.keys(Se))
            delete Se[u];
          for (const [u, p] of Y)
            p && rt(u, !0);
          return;
        }
        for (const [u, p] of Y)
          Ue(u, p);
      },
      { immediate: !1 }
    ), U(
      [() => t.viewportPriority, () => S.value.length],
      ([i, u]) => {
        if (i === !1) {
          d.value = !1;
          return;
        }
        d.value && u <= $i && (d.value = !1);
      }
    ), U(
      () => W.value,
      () => {
        j.value && be({ immediate: !0 });
      }
    ), U(
      [ke, ee, St, () => S.value.length, j],
      () => {
        ot();
      },
      { immediate: !0 }
    ), U(
      () => jt.value,
      (i, u) => {
        ie.value && (typeof u == "number" && i <= u || i > W.value && gn());
      }
    ), hn(() => {
      ge();
      for (const i of I.values())
        i.destroy();
      I.clear();
      for (const i of Array.from(J.keys()))
        te(i);
      nt(), Q();
    });
    const Xt = vn(() => z(null, null, function* () {
      try {
        return (yield import("./index-CpUcwcBM.js")).default;
      } catch (i) {
        return console.warn(
          '[markstream-vue] Optional peer dependencies for CodeBlockNode are missing. Falling back to inline-code rendering (no Monaco). To enable full code block features, please install "stream-monaco".',
          i
        ), mn;
      }
    })), eo = N(() => t.renderCodeBlocksAsPre ? mn : Xt), nn = {
      text: Ie,
      paragraph: $n,
      heading: po,
      code_block: Xt,
      list: In,
      blockquote: Mn,
      table: Sn,
      definition_list: Cn,
      footnote: _n,
      footnote_reference: De,
      footnote_anchor: un,
      admonition: Ln,
      hardbreak: Jt,
      link: Ke,
      image: Pt,
      thematic_break: En,
      math_inline: It,
      math_block: qr,
      strong: Ve,
      emphasis: tt,
      strikethrough: Oe,
      highlight: et,
      insert: Qe,
      subscript: Je,
      superscript: Ge,
      emoji: je,
      checkbox: _t,
      checkbox_input: _t,
      inline_code: ze,
      html_inline: Ae,
      reference: Pe,
      html_block: Ci
      // 可以添加更多节点类型
      // 例如:custom_node: CustomNode,
    };
    function on(i) {
      var L;
      if (!i)
        return Io;
      const u = Bt(t.customId), p = u[String(i.type)];
      if (i.type === "code_block") {
        if (String((L = i.language) != null ? L : "").trim().toLowerCase() === "mermaid")
          return u.mermaid || dn;
        if (p)
          return p;
        const X = u.code_block;
        return X || eo.value;
      }
      return p || nn[String(i.type)] || Io;
    }
    function vt(i) {
      var u;
      return (i == null ? void 0 : i.type) === "code_block" && String((u = i.language) != null ? u : "").trim().toLowerCase() === "mermaid" ? {} : i.type === "code_block" ? oe({
        // streaming behavior control for CodeBlockNode
        stream: t.codeBlockStream,
        darkTheme: t.codeBlockDarkTheme,
        lightTheme: t.codeBlockLightTheme,
        monacoOptions: t.codeBlockMonacoOptions,
        themes: t.themes,
        minWidth: t.codeBlockMinWidth,
        maxWidth: t.codeBlockMaxWidth
      }, t.codeBlockProps || {}) : {
        // Forward `typewriter` flag to non-code node components so they can
        // opt in/out of enter transitions or other typewriter-like behaviour.
        typewriter: t.typewriter
      };
    }
    function wn(i) {
      s("click", i);
    }
    function On(i) {
      var p;
      (p = i.target) != null && p.closest("[data-node-index]") && s("mouseover", i);
    }
    function to(i) {
      var p;
      (p = i.target) != null && p.closest("[data-node-index]") && s("mouseout", i);
    }
    return (i, u) => (m(), y("div", {
      ref_key: "containerRef",
      ref: a,
      class: O(["markstream-vue markdown-renderer", [{ dark: t.isDark }]]),
      onClick: wn,
      onMouseover: On,
      onMouseout: to
    }, [
      j.value ? (m(), y("div", {
        key: 0,
        class: "node-spacer",
        style: ut({ height: `${B.value}px` }),
        "aria-hidden": "true"
      }, null, 4)) : fe("", !0),
      (m(!0), y(ue, null, Be(x.value, (p) => {
        var L;
        return m(), y("div", {
          key: p.index,
          ref_for: !0,
          ref: (_) => Ue(p.index, _),
          class: "node-slot",
          "data-node-index": p.index,
          "data-node-type": p.node.type
        }, [
          Dt(p.index) ? (m(), y("div", {
            key: 0,
            ref_for: !0,
            ref: (_) => tn(p.index, _),
            class: "node-content"
          }, [
            p.node.type !== "code_block" && t.typewriter !== !1 ? (m(), ye(zn, {
              key: 0,
              name: "typewriter",
              appear: ""
            }, {
              default: en(() => [
                (m(), ye(Fe(on(p.node)), Kt({
                  node: p.node,
                  loading: p.node.loading,
                  "index-key": `${e.indexKey || "markdown-renderer"}-${p.index}`
                }, { ref_for: !0 }, vt(p.node), {
                  "custom-id": t.customId,
                  "is-dark": t.isDark,
                  onCopy: u[0] || (u[0] = (_) => s("copy", _)),
                  onHandleArtifactClick: u[1] || (u[1] = (_) => s("handleArtifactClick", _))
                }), null, 16, ["node", "loading", "index-key", "custom-id", "is-dark"]))
              ]),
              _: 2
            }, 1024)) : (m(), ye(Fe(on(p.node)), Kt({
              key: 1,
              node: p.node,
              loading: p.node.loading,
              "index-key": `${e.indexKey || "markdown-renderer"}-${p.index}`
            }, { ref_for: !0 }, vt(p.node), {
              "custom-id": t.customId,
              "is-dark": t.isDark,
              onCopy: u[2] || (u[2] = (_) => s("copy", _)),
              onHandleArtifactClick: u[3] || (u[3] = (_) => s("handleArtifactClick", _))
            }), null, 16, ["node", "loading", "index-key", "custom-id", "is-dark"]))
          ], 512)) : (m(), y("div", {
            key: 1,
            class: "node-placeholder",
            style: ut({ height: `${(L = kt[p.index]) != null ? L : pe.value}px` })
          }, null, 4))
        ], 8, _i);
      }), 128)),
      j.value ? (m(), y("div", {
        key: 1,
        class: "node-spacer",
        style: ut({ height: `${K.value}px` }),
        "aria-hidden": "true"
      }, null, 4)) : fe("", !0)
    ], 34));
  }
}), lt = /* @__PURE__ */ Z(Ei, [["__scopeId", "data-v-ec150609"]]);
lt.install = (e) => {
  var t, s;
  const n = (s = (t = lt.__name) != null ? t : lt.name) != null ? s : "NodeRenderer";
  e.component(n, lt);
};
const Li = {
  key: 0,
  class: "admonition-icon"
}, Ri = { class: "admonition-title" }, Ni = ["aria-expanded", "aria-controls", "title"], Hi = { key: 0 }, ji = { key: 1 }, Di = ["id"], Ai = /* @__PURE__ */ F({
  __name: "AdmonitionNode",
  props: {
    node: {},
    indexKey: {},
    isDark: { type: Boolean },
    typewriter: { type: Boolean },
    customId: {}
  },
  emits: ["copy"],
  setup(e, { emit: n }) {
    var v;
    const t = e, s = n, a = {
      note: "ℹ️",
      info: "ℹ️",
      tip: "💡",
      warning: "⚠️",
      danger: "❗",
      // 'error' is a common alias for 'danger' in some markdown flavors
      error: "⛔",
      caution: "⚠️"
    }, d = N(() => {
      if (t.node.title && t.node.title.trim().length)
        return t.node.title;
      const b = t.node.kind || "note";
      return b.charAt(0).toUpperCase() + b.slice(1);
    }), c = M(t.node.collapsible ? !((v = t.node.open) == null || v) : !1);
    function f() {
      t.node.collapsible && (c.value = !c.value);
    }
    const w = `admonition-${Math.random().toString(36).slice(2, 9)}`;
    return (b, C) => (m(), y("div", {
      class: O(["admonition", [`admonition-${t.node.kind}`, t.isDark ? "is-dark" : ""]])
    }, [
      h("div", {
        id: w,
        class: "admonition-header"
      }, [
        a[t.node.kind] ? (m(), y("span", Li, se(a[t.node.kind]), 1)) : fe("", !0),
        h("span", Ri, se(d.value), 1),
        t.node.collapsible ? (m(), y("button", {
          key: 1,
          class: "admonition-toggle",
          "aria-expanded": !c.value,
          "aria-controls": `${w}-content`,
          title: c.value ? "Expand" : "Collapse",
          onClick: f
        }, [
          c.value ? (m(), y("span", Hi, "▶")) : (m(), y("span", ji, "▼"))
        ], 8, Ni)) : fe("", !0)
      ]),
      Rn(h("div", {
        id: `${w}-content`,
        class: "admonition-content",
        "aria-labelledby": w
      }, [
        fn([t.node.children], () => ct($(lt), {
          "index-key": `admonition-${e.indexKey}`,
          nodes: t.node.children,
          "custom-id": t.customId,
          typewriter: t.typewriter,
          onCopy: C[0] || (C[0] = (H) => s("copy", H))
        }, null, 8, ["index-key", "nodes", "custom-id", "typewriter"]), C, 1)
      ], 8, Di), [
        [Nn, !c.value]
      ])
    ], 2));
  }
}), Ln = /* @__PURE__ */ Z(Ai, [["__scopeId", "data-v-5e95c2b7"]]);
Ln.install = (e) => {
  e.component(Ln.__name, Ln);
};
let $o = !1;
function zi(e) {
  return z(this, null, function* () {
    if (!$o)
      return $o = !0, e.preloadMonacoWorkers();
  });
}
let xn = null, So = !1;
function zl() {
  return z(this, null, function* () {
    if (xn)
      return xn;
    if (So)
      return null;
    try {
      return xn = yield import("stream-monaco"), yield zi(xn), xn;
    } catch (e) {
      return So = !0, null;
    }
  });
}
const Pi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16"><!-- Icon from VSCode Icons by Roberto Huertas - https://github.com/vscode-icons/vscode-icons/blob/master/LICENSE --><path fill="#0f23c3" d="M24.554 20.075c.209.27 1.356.961 1.37 1.246a7 7 0 0 0-1.4-.324a17 17 0 0 1-1.412-.48a9.2 9.2 0 0 1-2.375-1.3A3.15 3.15 0 0 1 19.3 16.75a1.72 1.72 0 0 1 1.767-1.822a3.6 3.6 0 0 1 1.593.321c.146.066 1.31.606 1.256.809a5.5 5.5 0 0 0-1.41-.112c-.649.244-.4.828-.168 1.311a8 8 0 0 0 1.078 1.554c.164.194.884 1.271 1.138 1.264"/><path fill="#1a1978" d="M24.141 16.276c.128-.59.819-1.384 1.344-.773a4.2 4.2 0 0 1 .578 1.918c.12.656.2 1.327.261 1.982c.038.379.34 1.794.123 2.075a23 23 0 0 1-2.922-2.838a3.76 3.76 0 0 1-.925-1.7c-.1-1.073.879-.73 1.541-.664"/><path fill="#0f23c3" d="M26.3 17.781c.141-.732-.406-2.592-1.067-2.949a.06.06 0 0 0 .044-.007c-.156-.444-1.359 1.116-1.228 1.174c-.316-.138.774-1.984.988-2.16c.7-.578 1.372-.086 1.845.543a6.04 6.04 0 0 1 .733 4.434a4.5 4.5 0 0 1-.421 1.312c-.1.22-.45 1.1-.682 1.174a14.8 14.8 0 0 0-.212-3.521"/><path fill="#d2d2d2" d="M3.687 8.4c.179-.188-.041-1.527.324-1.548c.262-.015.553 1.741.627 1.968a9.2 9.2 0 0 0 1.127 2.329a7.53 7.53 0 0 0 4.016 2.978a4.55 4.55 0 0 0 2.366.2c.931-.208 1.82-.577 2.757-.765c1.35-.27 3.342-.352 4.438.647c.7.641.376.76.043 1.421a2.44 2.44 0 0 0 .178 2.562c.235.342 1.033.827.675 1.094c-.567.424-1.277-.452-1.636-.776c-1.4-1.264-2.711-1.313-4.492-1.074a9 9 0 0 1-4.883-.708A9.47 9.47 0 0 1 3.687 8.4M19.941 30a3.6 3.6 0 0 1-2.325-.817c.469-.092 1.021.025 1.508-.044a9.7 9.7 0 0 0 1.754-.43a10.5 10.5 0 0 0 3.022-1.554a6.55 6.55 0 0 0 2.757-5.214c.149-.088.316 1.034.319 1.091a5.8 5.8 0 0 1-.19 1.727a6.9 6.9 0 0 1-1.423 2.774A7.3 7.3 0 0 1 19.941 30"/><path fill="#d2d2d2" d="M18.962 19.109a5.8 5.8 0 0 1-2.05.859a13.4 13.4 0 0 1-2.224.549a8.86 8.86 0 0 1-4.435-.51a9.94 9.94 0 0 1-3.849-2.4c-.352-.367-2.104-2.417-1.548-3.05c.248-.282.875.846 1 .992a5 5 0 0 0 1.357 1.11a10.9 10.9 0 0 0 4.035 1.456a6.7 6.7 0 0 0 2.34-.094a13 13 0 0 1 1.694-.485a4 4 0 0 1 2.113.457c.344.17 1.523.743 1.567 1.116m9.351-4.031a19.3 19.3 0 0 1-.453 3.774c-.176-.242.016-1.47 0-1.792a6 6 0 0 0-.384-2.087a4.9 4.9 0 0 0-1.376-1.661a15 15 0 0 1-1.27-1.536c-1.837-2.382-3.245-5.211-2.9-8.3c.034-.308.069-1.448.411-1.445c.152 0 .266 1.561.29 1.718a12.5 12.5 0 0 0 1.224 4.116c.67 1.222 1.947 2.023 2.825 3.1a6.58 6.58 0 0 1 1.633 4.113M15.7 26.935a10.85 10.85 0 0 0 6.436-.687a6.94 6.94 0 0 0 4.278-4.418c.319.2-.048 1.529-.128 1.781a5.7 5.7 0 0 1-1.01 1.813a8.9 8.9 0 0 1-3.257 2.514c-1.703.772-5.662 1.652-6.319-1.003"/><path fill="#d2d2d2" d="M19.151 19.376c.367 2.107-2.957 3.124-4.478 3.213c-1.859.11-4.929-.292-6.06-2.031c-.673-1.035.781-.09 1.188.058a8.7 8.7 0 0 0 3.06.5a11.6 11.6 0 0 0 3.305-.5a14 14 0 0 0 1.533-.576c.301-.132 1.124-.691 1.452-.664m4.991 4.084c.4-.945-1.883-1.578-2.445-1.858a4.9 4.9 0 0 1-1.315-.867c-.181-.181-.872-.92-.807-1.219a5 5 0 0 1 1.087-.175a6 6 0 0 1 .855.588a10 10 0 0 0 .964.5a16 16 0 0 0 2.119.771c.308.09 1.549.208 1.727.428c-.04.296-1.97 2.021-2.185 1.832"/><path fill="#d2d2d2" d="M26.1 22.172c.265.43-1.08 1.831-1.363 2.105a9.3 9.3 0 0 1-2.566 1.728a7.8 7.8 0 0 1-2.56.753c-.679.058-1.966-.124-2.141-.979a7 7 0 0 1 1.177-.086c.462-.059.921-.149 1.376-.246a13 13 0 0 0 2.184-.645a11.5 11.5 0 0 0 2.084-1.11a11 11 0 0 0 1.078-.822c.105-.089.617-.702.731-.698m-7.342-10.207c-.1-1.308 2.612-1.3 3.271-1.092a5.98 5.98 0 0 1 2.982 2.475c-1.082.8-2.449.094-3.3-.654a4.3 4.3 0 0 0-1.481-1.029c-.809-.265-.818.094-1.472.3"/><path fill="#d2d2d2" d="M25.783 13.341c-.444-.029-.316.071-.647-.212c-.358-.307-.614-.795-.945-1.141c-.534-.558-1.242-.895-1.723-1.485a7.27 7.27 0 0 1-1.624-4.848c.018-1.489.407.187.551.675a12.3 12.3 0 0 0 1.126 2.708a46 46 0 0 0 3.4 4.321c-.039.002-.097-.021-.138-.018m-5.715 1.415c.033-.625-.911-.792-1.211-1.42c-.164-.343-.211-.569.029-.7c.082-.045.383.012.5-.02c.271-.076.335-.273.581-.4a1.193 1.193 0 0 1 1.633 1.021a1.82 1.82 0 0 1-1.532 1.519"/><path fill="#d2d2d2" d="M20.5 14.745a1.93 1.93 0 0 0 1.323-1.7c.524.139.928.658 1.521.771a2.6 2.6 0 0 0 1.029-.017c.207-.045.54-.274.721-.259c-.033.163-.464.546-.565.717a4.2 4.2 0 0 0-.388.9c-.229.741-.061.739-.709.311a4.3 4.3 0 0 0-1.957-.72c-.266-.026-.881.019-.975-.003m-.595 5.989a2.01 2.01 0 0 1-1.4 1.712c-.205.091-2.018.733-2.032.348c-.007-.2 1.624-.954 1.809-1.11a3.4 3.4 0 0 0 .867-1.071c.055-.112.232-.925.271-.943c.224-.106.488.93.485 1.064m-8.532-8.202a10.6 10.6 0 0 1 3.71-.914a10.3 10.3 0 0 1 1.865.024c.366.039 1.469.054 1.74.343a.255.255 0 0 1-.273.173c-.037.077.251.371.3.425c-.034.034-1.445-.4-1.572-.424a10.6 10.6 0 0 0-2.282-.134a16 16 0 0 0-1.841.194a6.2 6.2 0 0 1-1.647.313m11.139-1.801a1.89 1.89 0 0 1-1.517-.6c-.247-.349-.737-1.692-.385-2.021c.209-.2.384.662.484.846a11 11 0 0 0 1.418 1.775m5.276 8.469a19 19 0 0 1-.749 3.313c-.173-.077-.275-.778-.562-.95a4.1 4.1 0 0 0 .76-1.154c.152-.302.303-1.046.551-1.209m-7.807-7.357c-.132.268-.932 1.1-1.118.481c-.107-.356.876-.841 1.118-.481m-.747.45c.228.006.012-.248.012-.266c-.001-.043-.368.266-.012.266"/></svg>', Vi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#c6d0f5" stroke-linecap="round" stroke-linejoin="round" d="M14.4561802 11.3673353C13.0276218 14.1261537 11.8858593 15.5 10.8437759 15.5 10.3588459 15.5 9.88231005 15.3491298 9.41749082 15.0543006 8.74000639 14.6241577 7.8668418 14.6059458 7.17068967 15.0074382 6.60881451 15.3319356 6.07177167 15.5 5.56305868 15.5 4.02887542 15.5 1.5 10.9491129 1.5 8.45090396 1.5 5.78581061 2.95006811 3.551507 5.15647301 3.551507 6.19383481 3.551507 7.09007204 4.20001691 7.84308619 4.497206 8.16210316 4.62512517 8.52255587 4.61592787 8.83410596 4.47192 9.44477141 4.18872223 10.2497236 3.551507 11.2503615 3.551507 12.4715175 3.551507 13.5338865 4.33779342 14.4184071 5.47479877 14.5532906 5.64778615 14.5172013 5.89341518 14.3377895 6.02349446 13.3500923 6.736546 12.8746057 7.53893969 12.8746057 8.45090396 12.8746057 9.36404821 13.3502672 10.1652619 14.3377895 10.8793249 14.4946576 10.992887 14.5445377 11.1984946 14.4561802 11.3673353ZM8.5 3C8.5 3 8.3468635 1.3936039 10 1" />
</svg>
`, Oi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <rect width="8" height="13.001" x="4" y="1.499" fill="none" stroke="#c6d0f5" stroke-linecap="round" stroke-linejoin="round" rx="2.286" ry="2.286" />
  <path fill="none" stroke="#c6d0f5" stroke-linecap="round" stroke-linejoin="round" d="M 4,4.500025 H 1.5 M 4,7.9999993 H 1.5 M 4,11.499973 H 1.5 m 13,-6.999948 H 12 m 2.5,3.4999743 H 12 m 2.5,3.4999737 H 12" />
</svg>
`, Ki = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="m 4.0559072,12.951629 c 2.7459832,2.734744 7.1981158,2.734744 9.9441188,0 l -1.789955,-1.782586 c -1.75742,1.750224 -4.6067879,1.750224 -6.3642294,0 -1.7574416,-1.7502236 -1.7574416,-4.587893 0,-6.338097 1.7574415,-1.750224 4.6068094,-1.750224 6.3642294,0 l 0.894977,-0.8912929 0.894978,-0.891293 c -2.746003,-2.73472867 -7.1981359,-2.73472867 -9.944119,0 -2.7459858,2.7347089 -2.7459858,7.1685599 2e-7,9.9032689 z" clip-rule="evenodd" />
</svg>
`, Fi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#a6d189" d="M14.17 10.03A6.5 6.5 0 011.81 6.02" />
    <path stroke="#8caaee" d="M1.87 5.85A6.5 6.5 0 0114.22 9.9" />
    <path stroke="#a6d189" d="M6.36 4.9a3.5 3.5 0 103.41 6.12" />
    <path stroke="#8caaee" d="M9.77 11.02a3.5 3.5 0 00-3.03-6.29" />
    <path stroke="#c6d0f5" d="M8 7.5s-1.66 2.48-1.5 3.65" />
    <path stroke="#c6d0f5" d="M1.81 6.02C2.47 5 3.83 4.49 5 4.46c4.06 0 3 5.56 5.03 6.86 1.21.52 3.5-.21 4.15-1.32" />
  </g>
</svg>
`, Wi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="M6.74 2.24c.32-1.32 2.2-1.32 2.52 0a1.3 1.3 0 001.93.8c1.15-.7 2.48.62 1.77 1.77a1.3 1.3 0 00.8 1.93c1.32.32 1.32 2.2 0 2.52a1.3 1.3 0 00-.8 1.93c.7 1.15-.62 2.48-1.77 1.77a1.3 1.3 0 00-1.93.8c-.32 1.32-2.2 1.32-2.52 0a1.3 1.3 0 00-1.93-.8c-1.15.7-2.48-.62-1.77-1.77a1.3 1.3 0 00-.8-1.93c-1.32-.32-1.32-2.2 0-2.52a1.3 1.3 0 00.8-1.93c-.7-1.15.62-2.48 1.77-1.77a1.3 1.3 0 001.93-.8M10 6.5a2.5 2.5 0 100 3" />
</svg>
`, Xi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="m 2.5559121,12.951629 c 2.7459832,2.734744 7.1981158,2.734744 9.9441189,0 l -1.789955,-1.782586 c -1.7574201,1.750224 -4.606788,1.750224 -6.3642295,0 -1.7574416,-1.7502236 -1.7574416,-4.587893 0,-6.338097 1.7574415,-1.750224 4.6068094,-1.750224 6.3642295,0 l 0.894977,-0.8912929 0.894978,-0.891293 c -2.7460031,-2.73472867 -7.198136,-2.73472867 -9.9441191,0 -2.74598585,2.7347089 -2.74598585,7.1685599 2e-7,9.9032689 z" clip-rule="evenodd" />
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="M7.5 6v4M5.513524 7.9999996H9.51304M13.486476 5.9999996v4M11.5 7.9999992h3.999516" />
</svg>
`, Yi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#c6d0f5" stroke-linecap="round" stroke-linejoin="round" d="m 15.4712,10.050637 -5.433601,5.433968 c -0.015,0.01505 -0.04554,0.01505 -0.09055,0.01505 L 2.536327,13.517264 c -0.015,0 -0.04501,-0.01505 -0.06055,-0.06072 L 0.50026325,6.0396501 a 0.21432208,0.21495127 0 0 1 0.015,-0.090817 L 5.9483283,0.5154023 c 0.015,-0.0150465 0.04501,-0.0150465 0.09055,-0.0150465 l 7.4101857,1.997972 c 0.015,0 0.04501,0.015046 0.06055,0.060724 l 1.977121,7.4158186 c 0.03001,0.03063 0.01608,0.060724 -0.01554,0.07577 M 8.2121063,4.1480782 0.93801425,6.1154197 q -0.0225,0 0,0.04514 L 6.2655263,11.50371 c 0.015,0.01505 0.015,0 0.04501,0 l 1.962119,-7.2803988 c -0.03054,-0.075233 -0.06055,-0.075233 -0.06055,-0.075233" />
</svg>
`, Ui = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" d="m 6.665625,1.0107144 c 0.54375,0.090628 0.9125,0.6062693 0.821875,1.1500367 L 7.18125,3.9983098 h 2.971875 L 10.5125,1.8326156 c 0.09063,-0.5437673 0.60625,-0.9125291 1.15,-0.8219012 0.54375,0.090628 0.9125,0.6062693 0.821875,1.1500367 L 12.18125,3.9983098 H 14 c 0.553125,0 1,0.4468892 1,1.0000319 0,0.5531426 -0.446875,1.0000319 -1,1.0000319 H 11.846875 L 11.18125,9.9985013 H 13 c 0.553125,0 1,0.4468897 1,1.0000317 0,0.553143 -0.446875,1.000032 -1,1.000032 H 10.846875 L 10.4875,14.164259 c -0.09063,0.543768 -0.60625,0.912529 -1.15,0.821902 -0.54375,-0.09063 -0.9125,-0.60627 -0.821875,-1.150037 l 0.30625,-1.834434 h -2.975 L 5.4875,14.167384 c -0.090625,0.543768 -0.60625,0.91253 -1.15,0.821902 C 3.79375,14.898658 3.425,14.383016 3.515625,13.839249 L 3.81875,11.998565 H 2 c -0.553125,0 -1,-0.446889 -1,-1.000032 C 1,10.445391 1.446875,9.9985013 2,9.9985013 H 4.153125 L 4.81875,5.9983736 H 3 c -0.553125,0 -1,-0.4468893 -1,-1.0000319 C 2,4.445199 2.446875,3.9983098 3,3.9983098 H 5.153125 L 5.5125,1.8326156 C 5.603125,1.2888483 6.11875,0.9200865 6.6625,1.0107144 Z M 6.846875,5.9983736 6.18125,9.9985013 H 9.153125 L 9.81875,5.9983736 Z" />
</svg>
`, qi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round">
    <path d="m4 1.5h8c1.38 0 2.5 1.12 2.5 2.5v8c0 1.38-1.12 2.5-2.5 2.5h-8c-1.38 0-2.5-1.12-2.5-2.5v-8c0-1.38 1.12-2.5 2.5-2.5z" />
    <path stroke-width=".814" d="m 10.240861,11.529149 c 0,0.58011 0.437448,1.039154 0.96002,1.035371 l 0.451635,-0.0032 c 0.522572,-0.0036 0.949379,-0.451477 0.949379,-1.032848 0,-0.581372 -0.426807,-1.065638 -0.949379,-1.065638 l -0.451635,3.4e-5 c -0.522572,3.9e-5 -0.949379,-0.4855273 -0.949379,-1.0656374 0,-0.5801104 0.426807,-1.0378931 0.949379,-1.0378931 l 0.451635,2.825e-4 c 0.522572,3.267e-4 0.951743,0.4577827 0.951743,1.0378931 M 6.8003972,11.529149 c 0,0.58011 0.4374474,1.039154 0.9600196,1.035371 l 0.46464,-0.0032 c 0.5225722,-0.0035 0.9363738,-0.451477 0.9363738,-1.031587 0,-0.580111 -0.4090724,-1.065638 -0.9316446,-1.065638 l -0.4693692,3.4e-5 c -0.5225722,3.8e-5 -0.949379,-0.4855272 -0.949379,-1.0656373 0,-0.5801104 0.4268068,-1.0378931 0.949379,-1.0378931 h 0.4516348 c 0.5225722,0 0.9635665,0.4577827 0.9635665,1.0378931 M 3.4072246,11.529149 c 0,0.58011 0.4374474,1.051765 0.9600196,1.051765 H 4.818879 c 0.5225722,0 0.949379,-0.456521 0.949379,-1.037893 m 0.01129,-2.1312747 c 0,-0.5801103 -0.4374474,-1.037893 -0.9600196,-1.037893 L 4.3678939,8.3741358 C 3.8453217,8.3744624 3.4078743,8.8420074 3.4078743,9.4233788 v 2.1186642" />
  </g>
</svg>
`, Zi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#85c1dc" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 14.5h4.5v-3h3V7L9.17 1.64c-.28-.29-.8-.47-1.17-.29L3.5 3.5 1.35 8c-.18.37 0 .88.3 1.17z" />
    <path d="M3.5 11V3.5H11m-7.5 0 8 8" />
  </g>
</svg>
`, Gi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16"><!-- Icon from VSCode Icons by Roberto Huertas - https://github.com/vscode-icons/vscode-icons/blob/master/LICENSE --><defs><linearGradient id="SVGMV3iTbAN" x1="185.455" x2="181.955" y1="1601.641" y2="1630.224" gradientTransform="translate(-62.523 -666.646)scale(.427)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient><linearGradient id="SVGniw2Mvsa" x1="176.136" x2="172.636" y1="1600.5" y2="1629.083" href="#SVGMV3iTbAN"/></defs><path fill="#b03931" d="m3.978 15.462l-.009-6.953a.59.59 0 0 1 .531-.562h.076l6.074-.009a15.7 15.7 0 0 1 6.067.95a8.9 8.9 0 0 1 2.244 1.359a4.47 4.47 0 0 1 2.946-1.083a4.11 4.11 0 0 1 4.276 3.92A4.11 4.11 0 0 1 21.907 17c-.089 0-.177-.008-.265-.012a7 7 0 0 1-.232.953a85 85 0 0 1 8.59 2.6V2H2v13.4q.992.02 1.978.062m22.8-7.944a1.32 1.32 0 0 1 1.374 1.259a1.379 1.379 0 0 1-2.747 0a1.32 1.32 0 0 1 1.375-1.26Z"/><path fill="#b03931" d="M17.861 15.787a4.11 4.11 0 0 0-1.748-3.458a5.8 5.8 0 0 0-1.508-.822a7.4 7.4 0 0 0-1.629-.438a22 22 0 0 0-2.588-.1H7.769l.006 4.737a89 89 0 0 1 9.91 1.408a5 5 0 0 0 .176-1.327m3.132 3.192a7.9 7.9 0 0 1-2.128 2.582a9.7 9.7 0 0 1-3.256 1.71a11.6 11.6 0 0 1-1.971.472h-.015a32 32 0 0 1-3.326.111l-5.625.022a.616.616 0 0 1-.686-.681l-.01-7.734Q2.992 15.42 2 15.4V30h28v-9.456a85 85 0 0 0-8.59-2.6a7 7 0 0 1-.417 1.035"/><path fill="url(#SVGMV3iTbAN)" d="M20.993 18.979a7.9 7.9 0 0 1-2.128 2.582a9.7 9.7 0 0 1-3.256 1.71a11.6 11.6 0 0 1-1.971.472h-.015a32 32 0 0 1-3.326.111l-5.625.022a.616.616 0 0 1-.686-.681l-.01-7.734Q2.992 15.42 2 15.4V30h28v-9.456a85 85 0 0 0-8.59-2.6a7 7 0 0 1-.417 1.035" opacity=".3"/><path fill="#b03931" d="M10.477 20.835a16 16 0 0 0 2.877-.2a7.6 7.6 0 0 0 1.628-.5a5.6 5.6 0 0 0 1.187-.748a4.46 4.46 0 0 0 1.518-2.271a89 89 0 0 0-9.91-1.408l.006 5.133Z"/><path fill="url(#SVGniw2Mvsa)" d="M10.477 20.835a16 16 0 0 0 2.877-.2a7.6 7.6 0 0 0 1.628-.5a5.6 5.6 0 0 0 1.187-.748a4.46 4.46 0 0 0 1.518-2.271a89 89 0 0 0-9.91-1.408l.006 5.133Z" opacity=".3"/><path fill="#fff" d="M20.383 11.746a7 7 0 0 1 1.36 4.148a6.6 6.6 0 0 1-.1 1.1c.088 0 .176.012.265.012a4.11 4.11 0 0 0 4.276-3.92a4.11 4.11 0 0 0-4.276-3.92a4.47 4.47 0 0 0-2.946 1.083a8 8 0 0 1 1.421 1.497"/><ellipse cx="26.78" cy="8.777" fill="#fff" rx="1.374" ry="1.259"/><path fill="#fff" d="m4.673 23.877l5.625-.022a32 32 0 0 0 3.326-.111h.015a11.5 11.5 0 0 0 1.971-.472a9.7 9.7 0 0 0 3.256-1.71a7.9 7.9 0 0 0 2.128-2.582a7 7 0 0 0 .417-1.034a7 7 0 0 0 .332-2.051a7 7 0 0 0-1.36-4.148a8 8 0 0 0-1.421-1.5a8.9 8.9 0 0 0-2.244-1.359a15.7 15.7 0 0 0-6.067-.95l-6.074.009h-.076a.59.59 0 0 0-.532.562l.009 6.952l.01 7.734a.616.616 0 0 0 .685.682m3.1-12.908h2.619a22 22 0 0 1 2.588.1a7.4 7.4 0 0 1 1.629.438a5.8 5.8 0 0 1 1.508.822a4.12 4.12 0 0 1 1.748 3.458a5 5 0 0 1-.175 1.327a4.46 4.46 0 0 1-1.518 2.271a5.6 5.6 0 0 1-1.187.748a7.7 7.7 0 0 1-1.628.5a16 16 0 0 1-2.877.2H7.786L7.78 15.7Z"/></svg>', Ji = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="M.5 8.5H11l.75-.5a5.35 5.35 0 010-3.5c1 .6 1 1.88 1.74 2 .77-.09 1.23.01 2 .52 0 0-.97 1.77-2.5 1.98-1.93 3.65-4.5 5.5-6.98 5.5C0 14.5.5 8.5.5 8.5m1 0v-2m0 0h8m-6 2v-4m0 0h4m-2-2h2m-2 6v-6m2 6v-6m2 6v-2" />
</svg>
`, Qi = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="M8.03 14.5C5 14.5 3.5 12.49 3.5 10.01c0-2.82 2.25-7.02 4.62-8.48a.24.24 0 01.24 0c.08.04.12.12.11.2-.13 1.25.22 2.5.98 3.54.3.43.63.8 1.02 1.27.54.66.94 1.03 1.52 2.08l.01.02c.33.56.5 1.2.5 1.84 0 2.03-1.69 4.02-4.47 4.02" />
</svg>
`, es = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#e78284" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6.5 5.5c0-1.25 1-2 2-2s2 .75 2 2z" />
    <path d="M13.5 13c.47-.57 1.12-1.24 1.5-2l-2.25-1.25c-.74 1.36-1.76 2.75-3.25 2.75-2.1 0-3-2.3-3-5h8c.05-1.61-.31-3.45-1-4.5M3 13c-1.08-1.3-1.5-3-1.5-5S2.1 4.24 3 3" />
  </g>
</svg>
`, ts = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="M7.5 14.5v-1l-1-1v-3h2l1 2h1v-6h-1l-1 2h-2v-4h5l1 3h1v-5h-11v1l1 1v9l-1 1.25v.75z" />
</svg>
`, ns = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#85c1dc" stroke-linecap="round" stroke-linejoin="round" d="m15.48 8.06-4.85.48m4.85-.48a4.98 4.98 0 01-4.54 5.42 5 5 0 112.95-8.66l-1.7 1.84a2.5 2.5 0 00-4.18 2.06c.05.57.3 1.1.69 1.51.25.27 1 .83 1.78.82.8-.02 1.58-.25 2.07-.81 0 0 .8-.96.68-1.88M2.5 8.5l-2 .01m1.5 2h1.5m-2-3.99 2-.02" />
</svg>
`, os = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#85c1dc" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11.68 5.38c.4.19.54.68 1.53 3.25 1 2.57-.92 4.07-.92 4.07s-6.73 2.47-6.73 1.63c-.18-.92-1.92-2.08-1.92-2.08s-.52-.63.06-.75c5.89-1.27 6.96-.61 7.3-2" />
    <path d="M7.38 10.63C2.62 10.88 2.48 8.08 2.5 8 3.6 4.6 9.24.91 10.8 1.58 14.07 3.04 9.2 8.96 7 8.5c-4.02-.83 1.5-4 1.5-4" />
  </g>
</svg>
`, rs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="M12.5 4.5h3m-1.5 3h1.5m-10 6 2.5-5-2.5-5H8l5.6 10h-2.53l-1.52-2.92L8 13.5zm-5 0 2.5-5-2.5-5H3l2.5 5-2.5 5z" />
</svg>
`, as = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#ef9f76" d="M1.5 1.5h13L13 13l-5 2-5-2z" />
    <path stroke="#c6d0f5" d="M11 4.5H5l.25 3h5.5l-.25 3-2.5 1-2.5-1-.08-1" />
  </g>
</svg>
`, is = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#c6d0f5" d="M10.73 8.41c.57 3 1.59 5.83 2.77 7.09-6.63-3.45-9.76-1.75-10.5 0-.66-3.4-.54-5.74.09-7.78" />
    <path stroke="#e78284" d="M8.5 7c.63.34 1.82 1.07 2.24 1.41-.54-2.9-.64-5.96-.74-7.91-2.13.58-5.73 1.98-6.9 7.22.52-.69 1.72-1.05 2.4-1.22" />
    <path stroke="#e78284" d="M5.5 7A1.5 1.5 0 007 8.5 1.5 1.5 0 008.5 7 1.5 1.5 0 007 5.5 1.5 1.5 0 005.5 7" />
  </g>
</svg>
`, ss = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#99d1db" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 10.8c4.14 0 7.5-1.25 7.5-2.8S12.14 5.2 8 5.2.5 6.45.5 8s3.36 2.8 7.5 2.8" />
    <path d="M5.52 9.4c2.07 3.5 4.86 5.72 6.23 4.95 1.37-.78.8-4.24-1.27-7.75C8.41 3.1 5.62.88 4.25 1.65c-1.37.78-.8 4.24 1.27 7.75" />
    <path d="M5.52 6.6c-2.07 3.5-2.64 6.97-1.27 7.75 1.37.77 4.16-1.45 6.23-4.95s2.64-6.97 1.27-7.75C10.38.88 7.59 3.1 5.52 6.6" />
    <path d="M8.5 8a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5" />
  </g>
</svg>
`, ls = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#e5c890" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4.5 11c0 .828427.6715729 1.5 1.5 1.5.8284271 0 1.5-.671573 1.5-1.5V7.5M12.5 8.75C12.5 8.05964406 11.9627417 7.5 11.3 7.5L10.7 7.5C10.0372583 7.5 9.5 8.05964406 9.5 8.75 9.5 9.44035594 10.0372583 10 10.7 10L11.3 10C11.9627417 10 12.5 10.5596441 12.5 11.25 12.5 11.9403559 11.9627417 12.5 11.3 12.5L10.7 12.5C10.0372583 12.5 9.5 11.9403559 9.5 11.25" />
    <path d="m 4,1.5 h 8 c 1.385,0 2.5,1.115 2.5,2.5 v 8 c 0,1.385 -1.115,2.5 -2.5,2.5 H 4 C 2.615,14.5 1.5,13.385 1.5,12 V 4 C 1.5,2.615 2.615,1.5 4,1.5 Z" />
  </g>
</svg>
`, cs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e5c890" stroke-linecap="round" stroke-linejoin="round" d="M4.5 2.5H4c-.75 0-1.5.75-1.5 1.5v2c0 1.1-1 2-1.83 2 .83 0 1.83.9 1.83 2v2c0 .75.75 1.5 1.5 1.5h.5m7-11h.5c.75 0 1.5.75 1.5 1.5v2c0 1.1 1 2 1.83 2-.83 0-1.83.9-1.83 2v2c0 .74-.75 1.5-1.5 1.5h-.5m-6.5-3a.5.5 0 100-1 .5.5 0 000 1m3 0a.5.5 0 100-1 .5.5 0 000 1m3 0a.5.5 0 100-1 .5.5 0 000 1" />
</svg>
`, us = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#a6d189" d="M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0" />
    <path stroke="#e78284" d="M6.5 11a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0" />
    <path stroke="#ca9ee6" d="M14.5 11a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0" />
  </g>
</svg>
`, ds = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#ca9ee6" d="M2.5 13.5h11L8 8" />
    <path stroke="#ef9f76" d="M8.03 2.5h5.47l-8 8" />
    <path stroke="#e78284" d="M2.5 13.5V8" />
    <path stroke="#85c1dc" d="M8 2.5H2.5V8l3-2.5" />
  </g>
</svg>
`, ms = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#e78284" stroke-linecap="round" stroke-linejoin="round">
    <path d="M.5 5.06v6.07C.5 12.41.82 13 2.27 13h5.6c1.04 0 1.63-.51 1.63-1.62 0-.85-.2-1.88-1.5-1.88h-.36C6.4 9.5 6 8.77 6 7.75 6 6.81 6.8 6 7.49 6h2.68" />
    <path d="M3.5 10.5V4.99C3.5 3.89 3.62 3 5 3h9c.97 0 1.5.99 1.5 1.63.12 1.55-.98 1.62-2.1 2.16-.58.26-1.4.52-1.4.98V11" />
  </g>
</svg>
`, fs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#c6d0f5" d="M10.5 7A1.5 1.5 0 019 8.5 1.5 1.5 0 017.5 7 1.5 1.5 0 019 5.5 1.5 1.5 0 0110.5 7" />
    <path stroke="#8caaee" d="M7 2.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13m7-2a1.5 1.5 0 100 3 1.5 1.5 0 000-3" />
  </g>
</svg>
`, hs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#85c1dc" stroke-linecap="round" stroke-linejoin="round" d="m9.25 8.25 2.25 2.25 2.25-2.25M3.5 11V5.5l2.04 3 1.96-3V11m4-.5V5M1.65 2.5h12.7c.59 0 1.15.49 1.15 1v9c0 .51-.56 1-1.15 1H1.65c-.59 0-1.15-.49-1.15-1V3.58c0-.5.56-1.08 1.15-1.08" />
</svg>
`, vs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#85c1dc" d="M4 11 .5 8.5 5 7q.78-1.77 1.89-1.89c.74-.07 1.94-1.28 3.61-3.61M5 7l1.5 1.5" />
    <path stroke="#ef9f76" d="m15.5 12.5-5-11C8.5 6.83 6.33 10 4 11c1.67-.33 2.67.83 3 3.5 3.5-1.5 3.5-3.5 5-4s1.5 1.5 3.5 2" />
  </g>
</svg>
`, ps = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="M1.5 2.5c0 6 2.25 5.75 4 7 .83.67 1.17 2 1 4h3c-.17-2 .17-3.33 1-4 1.75-1.25 4-1 4-7C12 2.5 10 3 8 7 6 3 4 2.5 1.5 2.5" />
</svg>
`, gs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e5c890" stroke-linecap="round" stroke-linejoin="round" d="M1 7 .5 4.5l1.01.67c.28-.27.47-.48 1.18-.85l.56-1.82L4.5 3.84c.77-.18 1.53-.36 2.4-.33L8 1.5l1.1 2.01c.87-.03 1.63.15 2.4.33l1.25-1.34.56 1.82c.7.37.9.58 1.18.85l1.01-.67L15 7m-1.5 1C13 6.5 11 5.5 8 5.5S3 6.5 2.5 8m11.5.75L13.5 8l-1 1.5-1.5.5-3-1.5L5 10l-1.5-.5-1-1.5-.5.75L1 7l1.25 3.75C3 12.75 6 13.5 8 13.5s5-.75 5.75-2.75L15 7z" />
</svg>
`, ws = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16"><!-- Icon from VSCode Icons by Roberto Huertas - https://github.com/vscode-icons/vscode-icons/blob/master/LICENSE --><path fill="#c2c2c2" d="M11.29 15.976a8.9 8.9 0 0 0 1.039 4.557a4.82 4.82 0 0 0 5.579 2.13a3.79 3.79 0 0 0 2.734-3.181c.095-.535.1-.54.1-.54c1.537.222 4.014.582 5.55.8l-.1.389A9.96 9.96 0 0 1 23.8 24.9a8.35 8.35 0 0 1-4.747 2.378a12.93 12.93 0 0 1-7.322-.725a8.98 8.98 0 0 1-5.106-5.524A14.35 14.35 0 0 1 6.642 10.9a9.32 9.32 0 0 1 7.929-6.24a11.8 11.8 0 0 1 5.9.491a8.47 8.47 0 0 1 5.456 6.1c.083.311.1.369.1.369c-1.709.311-3.821.705-5.518 1.075c-.323-1.695-1.122-3.029-2.831-3.445a4.656 4.656 0 0 0-5.853 3.158a9 9 0 0 0-.341 1.273a11 11 0 0 0-.194 2.295"/><path fill="#c2c2c2" d="M2.033 30V2h5.934v2.227H4.723v23.546h3.244V30zm27.934-.001h-5.934v-2.228h3.244V4.226h-3.244V1.999h5.934z"/></svg>', ys = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16"><!-- Icon from VSCode Icons by Roberto Huertas - https://github.com/vscode-icons/vscode-icons/blob/master/LICENSE --><path fill="#c2c2c2" d="M19.5 24.833a11.24 11.24 0 0 1-5.13 1.009a8.37 8.37 0 0 1-6.492-2.576A9.75 9.75 0 0 1 5.512 16.4a10.4 10.4 0 0 1 2.659-7.406a9.02 9.02 0 0 1 6.9-2.841a12.2 12.2 0 0 1 4.43.7v4.129a7.5 7.5 0 0 0-4.108-1.142a5.28 5.28 0 0 0-4.075 1.685A6.48 6.48 0 0 0 9.766 16.1a6.37 6.37 0 0 0 1.464 4.4a5.02 5.02 0 0 0 3.941 1.639a8.03 8.03 0 0 0 4.329-1.223Z"/><path fill="#c2c2c2" d="M16.572 15.081V13.24h1.841v1.841h1.84v1.84h-1.84v1.841h-1.841v-1.841h-1.839V15.08zm6.44 0V13.24h1.841v1.841h1.84v1.84h-1.84v1.841h-1.841v-1.841h-1.839V15.08zM2.035 30V2.001h5.933v2.227H4.725v23.545h3.243V30z"/><path fill="#c2c2c2" d="M29.965 29.999h-5.933v-2.228h3.243V4.227h-3.243V2h5.933z"/></svg>', ks = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1.5 8V3c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5H9" />
    <path d="m1.5 8 1.14-2.3q.09-.21.36-.24a.8.8 0 01.44.13c.18.12.23.53.28.64.06.1.64 1.23.85 1.23.2 0 .71-1.47.71-1.47s.37-.49.72-.49.55.32.67.49c.12.16.24 1.76.46 2.01s1.32.87 1.67.73c.34-.13.53-.4.63-.73.1-.34-.14-.75 0-1a1.1 1.1 0 011.02-.55c.56.03 2.05.56 2.05 1.05q0 .75-1.5.75c-.48 1.33.28 2.22-3 2.25l1 4" />
    <path d="m4.5 14.5 1.5-4 1 4zm-2 0 1.5-4-1.5-.5-1 1.54V14l1 .49Z" />
  </g>
</svg>
`, xs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="M12.5 14.5v-3.34c-1-.66-1-1.35-1-2.66m-3 1 .02 2.53.98 2.47m-4-5v5m9 0V9.23s.17-1.73-1-1.73c0-1.5-.5-6-2.5-6S8.75 4.25 8.75 4.25A3.67 3.67 0 006.5 7.12v-3.5c0-.63-.85-1.32-1.5-1.32-.92 0-1.33.59-1.5 1.2H2.25c-.42.11-.75.59-.75 1 0 .5.28 1 .75 1h1.22l.02 3c.01.75.51 1 1.51 1h4.5" />
</svg>
`, bs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round" d="M0.5,12.5 L0.5,13.24 C0.5,14 1.27360724,14.5 2,14.5 C2.9375516,14.5 3.5,14 3.5,13.2445661 L3.5,6.00089968 C3.5,4.28551107 4.99401107,2.52263547 7.14960413,2.5 C9.49387886,2.5 11,4.0579782 11,5.5 C11.1657296,8.48962302 9.57820404,9.63684469 7.49621582,10.5 L7.49621582,14.5 L15.4979764,14.5 L15.4979764,9 C15.5394484,8.36478228 14.9387379,7.15595371 14.1308258,6.5 C13.1942239,5.80827275 12.0584852,5.50253264 11,5.5 M11.5,14.5 L11.5,11.5 M6,6.5 C6.27614237,6.5 6.5,6.27614237 6.5,6 C6.5,5.72385763 6.27614237,5.5 6,5.5 C5.72385763,5.5 5.5,5.72385763 5.5,6 C5.5,6.27614237 5.72385763,6.5 6,6.5 Z" />
</svg>
`, Ms = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round" d="M4.5 13.5c-.33.33-.5.67-.5 1s.17.67.5 1c.17-.67.5-1 1-1s.83.33 1 1c.33-.33.5-.83.5-1.5h2c0 .67.17 1.17.5 1.5.17-.67.5-1 1-1s.83.33 1 1c.33-.33.5-.67.5-1s-.17-.67-.5-1l1-1 1.25 1.25c0-2.75 1-2.75 1-5.75a7.1 7.1 0 00-2-5.25A3.64 3.64 0 0113 .5c-1.17 0-2 .42-2.5 1.25A3.08 3.08 0 008 .5c-1 0-1.83.42-2.5 1.25C5 .92 4.17.5 3 .5c.5.83.58 1.58.25 2.25a7.1 7.1 0 00-2 5.25c0 3 1 3 1 5.75L3.5 12.5zm6-5a2 2 0 100-4 2 2 0 000 4m-5 0a2 2 0 100-4 2 2 0 000 4M7 8l1 2.5L9 8m1.5-1.5" />
</svg>
`, Cs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#8caaee" d="M8.5 5.5h-3m6 0V3c0-.8-.7-1.5-1.5-1.5H7c-.8 0-1.5.7-1.5 1.5v2.5H3c-.8 0-1.5.7-1.5 1.5v2c0 .8.7 1.5 1.48 1.5" />
    <path stroke="#e5c890" d="M10.5 10.5h-3m-3 0V13c0 .8.7 1.5 1.5 1.5h3c.8 0 1.5-.7 1.5-1.5v-2.5H13c.8 0 1.5-.7 1.5-1.5V7c0-.8-.7-1.5-1.48-1.5H11.5c0 1.5 0 2-1 2h-2" />
    <path stroke="#8caaee" d="M2.98 10.5H4.5c0-1.5 0-2 1-2h2M7.5 3.5v0" />
    <path stroke="#e5c890" d="m 8.5,12.5 v 0" />
  </g>
</svg>
`, Ts = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="#838ba7" d="M13.5 9.5c.63-.7 1-1.54 1-2.43 0-2.52-2.91-4.57-6.5-4.57S1.5 4.55 1.5 7.07c0 1.9 1.65 3.53 4 4.22" />
    <path stroke="#8caaee" d="M10.5 9.5c.4 0 .86.34 1 .7l1 3.3m-5 0v-8h3.05c.95 0 1.95 1 1.95 2s-1 2-1.95 2H7.5Z" />
  </g>
</svg>
`, _s = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e78284" stroke-linecap="round" stroke-linejoin="round" d="M1.5 9.06v2.5c.02.86.36 1.61.9 2.15 1.76 1.76 5.71.65 8.84-2.47 3.12-3.13 4.23-7.08 2.47-8.84a3.1 3.1 0 00-2.15-.9h-2.5M14.5 4l-.25 10.25L4 14.5m4.39-6.11c2.34-2.35 3.29-5.2 2.12-6.37S6.49 1.8 4.14 4.14C1.8 6.5.85 9.34 2.02 10.51s4.02.22 6.37-2.12M5.5 14.5l.25-3.75L11 11l-.25-5.25 3.75-.25" />
</svg>
`, Bs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round">
    <path d="M15.5 9.5Q8 13.505.5 9.5l1-1-1-2 2-.5V4.5h2l.5-2 1.5 1 1.5-2 1.5 2 1.5-1 .5 2h2V6l2 .5-1 2z" />
    <path d="M6.5 7.5a1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1m5 0a1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1M4 11.02c-.67.37-1.5.98-1.5 2.23s1.22 1.22 2 1.25v-2M12 11c.67.37 1.5 1 1.5 2.25s-1.22 1.22-2 1.25v-2" />
  </g>
</svg>
`, Is = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#f4b8e4" stroke-linecap="round" stroke-linejoin="round" d="M6.75 6.38c1.85 1.07 3.35.74 4.83-.2 1.5-.95 2.7-2.78 1.3-4.15-.7-.68-3.25-.8-5.62.19-2.36.99-4.59 3.02-4.74 4.11-.31 2.19 3.15 2.88 3.64 4.23s.28 1.98-.2 2.83c-.5.85-1.96 1.62-2.8.68-.83-.95 1.67-2.75 2.98-3.25 1.3-.5 3.1-.4 3.69.25.58.64-.07 1.79-.03 1.79" />
</svg>
`, $s = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e78284" stroke-linecap="round" stroke-linejoin="round" d="m2.5 2.48 11-.98v3.04l-11 1zm0 5 11-.98v3.04l-11 1zm0 5 11-.98v3.04l-11 1z" />
</svg>
`, Ss = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2 15.5c-.7 0-1.5-.8-1.5-1.5V5c0-.7.8-1.5 1.5-1.5h9c.7 0 1.5.8 1.5 1.5v9c0 .7-.8 1.5-1.5 1.5z" />
    <path d="m1.2 3.8 3.04-2.5S5.17.5 5.7.5h8.4c.66 0 1.4.73 1.4 1.4v7.73a2.7 2.7 0 01-.7 1.75l-2.68 3.51M3 8.5l3 2-3 2m4 0h2" />
  </g>
</svg>
`, Es = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="m3 11.5 2.5 4 2.5-4 2.5 4 2.5-4-2.5-4-2.5 4m2.5 4h-5m7.5-4H3m10-7-2.5-4-2.5 4-2.5-4-2.5 4 2.5 4 2.5-4M5.5.5h5M3 4.5h10" />
</svg>
`, Ls = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e5c890" stroke-linecap="round" stroke-linejoin="round" d="M8 6.5c3.59 0 6.5-1.4 6.5-2.68S11.59 1.5 8 1.5 1.5 2.54 1.5 3.82 4.41 6.5 8 6.5M14.5 8c0 .83-1.24 1.79-3.25 2.2s-4.49.41-6.5 0S1.5 8.83 1.5 8m13 4.18c0 .83-1.24 1.6-3.25 2-2.01.42-4.49.42-6.5 0-2.01-.4-3.25-1.17-3.25-2m0-8.3v8.3m13-8.3v8.3" />
</svg>
`, Rs = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><!-- Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE --><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m10 9l-3 3l3 3m4 0l3-3l-3-3"/><rect width="18" height="18" x="3" y="3" rx="2"/></g></svg>', Ns = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round" d="m4.54 10 6.92-4m-6.92 4a1.5 1.5 0 10-2.6 1.5 1.5 1.5 0 002.6-1.5M8 4v8m0-8a1.5 1.5 0 100-3 1.5 1.5 0 000 3M4.54 6l6.92 4M4.54 6a1.5 1.5 0 10-2.6-1.5A1.5 1.5 0 004.54 6M8 12a1.5 1.5 0 100 3 1.5 1.5 0 000-3m3.46-2a1.5 1.5 0 102.6 1.5 1.5 1.5 0 00-2.6-1.5m0-4a1.5 1.5 0 102.6-1.5 1.5 1.5 0 00-2.6 1.5" />
</svg>
`, Hs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round" d="M14.34 10.2c.34-1.08 1.1-5.07-4.45-8.62a.48.48 0 00-.6.07.44.44 0 00-.02.6c.03.02 2.07 2.5 1.34 5.34-1.26-.86-6.24-4.81-6.24-4.81L7.25 7.5 1.9 4.05S5.68 8.7 8 10.45c-1.12.4-3.56.82-6.78-1.18a.48.48 0 00-.58.06.44.44 0 00-.08.56c.11.18 2.7 4.36 8.14 4.36 1.5 0 2.37-.42 3.08-.77.43-.2.77-.37 1.14-.37.93 0 1.54.92 1.54.93.1.14.27.22.44.21a.46.46 0 00.4-.28c.67-1.55-.49-3.2-.96-3.78h0Z" />
</svg>
`, js = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ca9ee6" stroke-linecap="round" stroke-linejoin="round" d="m1.5 6 8 4.25 4-2.25m-12-2V1.5l8 4.25 4-2.25V8m-4-2.25v8.75M5.53 3.82 5.5 12.5l4 2" />
</svg>
`, Ds = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#c6d0f5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M13.5 6.5v6a2 2 0 01-2 2h-7a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h4.01" />
    <path d="m8.5 1.5 5 5h-4a1 1 0 01-1-1zm-3 10h5m-5-3h5m-5-3h1" />
  </g>
</svg>
`, As = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 11.3c4.14 0 7.5-1.28 7.5-2.86S12.14 5.58 8 5.58.5 6.86.5 8.44s3.36 2.87 7.5 2.87Z" />
    <path d="M5.52 9.87c2.07 3.6 4.86 5.86 6.23 5.07 1.37-.8.8-4.34-1.27-7.93S5.62 1.16 4.25 1.95s-.8 4.34 1.27 7.92" />
    <path d="M5.52 7.01c-2.07 3.59-2.64 7.14-1.27 7.93s4.16-1.48 6.23-5.07c2.07-3.58 2.64-7.13 1.27-7.92-1.37-.8-4.16 1.47-6.23 5.06" />
    <path d="M8.5 8.44a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5" />
  </g>
</svg>
`, zs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#8caaee" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 1.5h8A2.5 2.5 0 0114.5 4v8a2.5 2.5 0 01-2.5 2.5H4A2.5 2.5 0 011.5 12V4A2.5 2.5 0 014 1.5" />
    <path d="M12.5 8.75c0-.69-.54-1.25-1.2-1.25h-.6c-.66 0-1.2.56-1.2 1.25S10.04 10 10.7 10h.6c.66 0 1.2.56 1.2 1.25s-.54 1.25-1.2 1.25h-.6c-.66 0-1.2-.56-1.2-1.25m-3-3.75v5M5 7.5h3" />
  </g>
</svg>
`, Ps = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16"><!-- Icon from VSCode Icons by Roberto Huertas - https://github.com/vscode-icons/vscode-icons/blob/master/LICENSE --><path fill="#00519a" d="M6.67 7.836L9 18.915l2.336-11.079H16l-4.664 16.328H6.672L2 7.836Zm11.661 0h7.6a4.08 4.08 0 0 1 2.9 1.749a3.8 3.8 0 0 1 .571 2.04a4 4 0 0 1-.571 2.034a4.1 4.1 0 0 1-2.341 1.763a4.1 4.1 0 0 1 2.929 1.756a3.8 3.8 0 0 1 .58 2.1a4.66 4.66 0 0 1-.579 2.546a5.05 5.05 0 0 1-3.5 2.338h-7.589ZM23 14.252h1.166a1.754 1.754 0 0 0 0-3.5H23Zm0 7h1.39a2.047 2.047 0 0 0 0-4.089H23Z"/></svg>', Vs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <g fill="none" stroke="#a6d189" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1 1.5h5.44L8 4.56 9.56 1.5H15l-6.99 13z" />
    <path d="M12.05 1.73 8 9.28 3.95 1.73" />
  </g>
</svg>
`, Os = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#ef9f76" stroke-linecap="round" stroke-linejoin="round" d="M4.5 4.5 1 8 4.5 11.5M11.5 4.5 15 8 11.5 11.5M9.5 2 6.5 14" />
</svg>
`, Ks = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="none" stroke="#e78284" stroke-linecap="round" stroke-linejoin="round" d="M2.5 1.5h3l3 4 3-4h3l-9 13h-3L7 8z" />
</svg>
`;
let ao = null;
function Fs(e) {
  ao = e != null ? e : null;
}
const Ws = {
  "": "",
  javascript: "javascript",
  js: "javascript",
  mjs: "javascript",
  cjs: "javascript",
  typescript: "typescript",
  ts: "typescript",
  jsx: "jsx",
  tsx: "tsx",
  golang: "go",
  py: "python",
  rb: "ruby",
  sh: "shell",
  bash: "shell",
  zsh: "shell",
  shellscript: "shell",
  bat: "shell",
  batch: "shell",
  ps1: "powershell",
  plaintext: "plain",
  text: "plain",
  "c++": "cpp",
  "c#": "csharp",
  "objective-c": "objectivec",
  "objective-c++": "objectivecpp",
  yml: "yaml",
  md: "markdown",
  rs: "rust",
  kt: "kotlin"
};
function Xs(e) {
  if (!e)
    return "";
  const n = e.trim();
  if (!n)
    return "";
  const [t] = n.split(/\s+/), [s] = t.split(":");
  return s.toLowerCase();
}
function qo(e) {
  var t;
  const n = Xs(e);
  return (t = Ws[n]) != null ? t : n;
}
function Pl(e) {
  const n = qo(e);
  if (!n)
    return "plaintext";
  switch (n) {
    case "plain":
      return "plaintext";
    case "jsx":
      return "javascript";
    case "tsx":
      return "typescript";
    default:
      return n;
  }
}
function Ys(e) {
  if (ao) {
    const t = ao(e);
    if (t != null && t !== "")
      return t;
  }
  switch (qo(e)) {
    case "javascript":
    case "js":
      return ls;
    case "typescript":
    case "ts":
      return zs;
    case "jsx":
      return ss;
    case "tsx":
      return As;
    case "html":
      return as;
    case "css":
      return qi;
    case "scss":
      return Is;
    case "json":
      return cs;
    case "python":
    case "py":
      return Cs;
    case "ruby":
    case "rb":
      return _s;
    case "go":
    case "golang":
      return ns;
    case "r":
      return Ts;
    case "java":
      return is;
    case "kotlin":
    case "kt":
      return ds;
    case "c":
      return Ki;
    case "cpp":
    case "c++":
      return Xi;
    case "cs":
    case "csharp":
      return Ui;
    case "php":
      return bs;
    case "scala":
      return $s;
    case "shell":
    case "sh":
    case "bash":
    case "zsh":
    case "powershell":
    case "ps1":
    case "bat":
    case "batch":
    case "shellscript":
      return Ss;
    case "sql":
      return Ls;
    case "yaml":
    case "yml":
      return Ks;
    case "markdown":
    case "md":
      return hs;
    case "xml":
      return Os;
    case "rust":
    case "rs":
      return Bs;
    case "swift":
      return Hs;
    case "perl":
      return xs;
    case "lua":
      return fs;
    case "haskell":
      return rs;
    case "erlang":
      return es;
    case "clojure":
      return Fi;
    case "vue":
      return Vs;
    case "svg":
      return Ns;
    case "mermaid":
      return ps;
    case "dart":
      return Zi;
    case "assembly":
      return Oi;
    case "dockerfile":
      return Ji;
    case "fortran":
      return ts;
    case "lisp":
      return ms;
    case "ocaml":
      return ks;
    case "prolog":
      return Ms;
    case "groovy":
      return os;
    case "matlab":
      return vs;
    case "cobol":
      return Wi;
    case "ada":
      return Pi;
    case "julia":
      return us;
    case "elixir":
      return Qi;
    case "vb.net":
      return Ps;
    case "nim":
      return gs;
    case "crystal":
      return Yi;
    case "d":
      return Gi;
    case "applescript":
      return Vi;
    case "solidity":
      return Es;
    case "objectivec":
      return ws;
    case "objectivecpp":
      return ys;
    case "terraform":
      return js;
    case "plain":
    case "text":
    case "":
      return Ds;
    default:
      return Rs;
  }
}
const Us = {
  js: "JavaScript",
  javascript: "JavaScript",
  ts: "TypeScript",
  jsx: "JSX",
  tsx: "TSX",
  html: "HTML",
  css: "CSS",
  scss: "SCSS",
  json: "JSON",
  py: "Python",
  python: "Python",
  rb: "Ruby",
  go: "Go",
  java: "Java",
  c: "C",
  cpp: "C++",
  cs: "C#",
  php: "PHP",
  sh: "Shell",
  bash: "Bash",
  sql: "SQL",
  yaml: "YAML",
  md: "Markdown",
  "": "Plain Text",
  plain: "Plain Text"
}, qs = {
  key: 0,
  class: "code-block-header flex justify-between items-center px-4 py-2.5 border-b border-gray-400/5",
  style: { color: "var(--vscode-editor-foreground)", "background-color": "var(--vscode-editor-background)" }
}, Zs = { class: "flex items-center space-x-2" }, Gs = ["innerHTML"], Js = { class: "text-sm font-medium font-mono" }, Qs = { class: "flex items-center space-x-2" }, el = ["aria-pressed"], tl = ["disabled"], nl = ["disabled"], ol = ["disabled"], rl = ["aria-label"], al = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  class: "w-3 h-3"
}, il = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  class: "w-3 h-3"
}, sl = ["aria-pressed"], ll = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "0.75rem",
  height: "0.75rem",
  viewBox: "0 0 24 24"
}, cl = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  width: "0.75rem",
  height: "0.75rem",
  viewBox: "0 0 24 24"
}, ul = ["aria-label"], dl = ["innerHTML"], ml = { class: "code-loading-placeholder" }, Eo = 10, Lo = 36, Ro = 1, fl = /* @__PURE__ */ F({
  __name: "MarkdownCodeBlockNode",
  props: {
    node: {},
    loading: { type: Boolean, default: !0 },
    stream: { type: Boolean, default: !0 },
    darkTheme: { default: "vitesse-dark" },
    lightTheme: { default: "vitesse-light" },
    isDark: { type: Boolean, default: !1 },
    isShowPreview: { type: Boolean, default: !0 },
    enableFontSizeControl: { type: Boolean, default: !0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    themes: {},
    showHeader: { type: Boolean, default: !0 },
    showCopyButton: { type: Boolean, default: !0 },
    showExpandButton: { type: Boolean, default: !0 },
    showPreviewButton: { type: Boolean, default: !0 },
    showFontSizeButtons: { type: Boolean, default: !0 }
  },
  emits: ["previewCode", "copy"],
  setup(e, { emit: n }) {
    var pe;
    const t = e, s = n, { t: a } = mo(), d = M(String((pe = t.node.language) != null ? pe : "")), c = M(!1), f = M(!1), w = M(!1), v = M(null), b = M(null), C = M(""), H = M(!1);
    let A;
    const S = M(!0), ee = M(0), j = M(14), T = M(j.value), re = N(() => {
      const g = j.value, x = T.value;
      return typeof g == "number" && Number.isFinite(g) && g > 0 && typeof x == "number" && Number.isFinite(x) && x > 0;
    }), G = N(() => {
      const g = d.value.trim().toLowerCase();
      return Us[g] || g.charAt(0).toUpperCase() + g.slice(1);
    }), ne = N(
      () => d.value.trim().toLowerCase() === "mermaid"
    ), de = N(() => {
      const g = d.value.trim().toLowerCase();
      return Ys(g.split(":")[0]);
    }), D = N(() => {
      const g = d.value.trim().toLowerCase();
      return t.isShowPreview && (g === "html" || g === "svg");
    }), We = N(() => {
      const g = {}, x = (Ye) => {
        if (Ye != null)
          return typeof Ye == "number" ? `${Ye}px` : String(Ye);
      }, B = x(t.minWidth), K = x(t.maxWidth);
      return B && (g.minWidth = B), K && (g.maxWidth = K), g;
    }), ce = N(() => ({
      fontSize: `${T.value}px`
    }));
    function Ee() {
      return t.isDark ? t.darkTheme : t.lightTheme;
    }
    function gt(g) {
      return g.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    function W(g) {
      if (A == null || A.disconnect(), A = void 0, !g) {
        C.value = "", H.value = !1;
        return;
      }
      C.value = `<pre class="shiki shiki-fallback"><code>${gt(g)}</code></pre>`, H.value = !1;
    }
    function Ht() {
      C.value = "", H.value = !0;
    }
    function ae() {
      var x;
      const g = b.value;
      return g ? g.childNodes.length > 0 ? !0 : !!((x = g.textContent) != null && x.trim().length) : !1;
    }
    function Se() {
      return z(this, null, function* () {
        if (yield he(), ae()) {
          Ht();
          return;
        }
        const g = b.value;
        g && (A == null || A.disconnect(), A = new MutationObserver(() => {
          ae() && (Ht(), A == null || A.disconnect(), A = void 0);
        }), A.observe(g, { childList: !0, subtree: !0 }));
      });
    }
    let I, J, Y, Le = () => {
    }, Xe;
    const q = /* @__PURE__ */ new Set(), ve = /* @__PURE__ */ new Set(), ie = typeof import.meta != "undefined" && !1;
    function $t(g, x = !1) {
      var Ye;
      const [B] = String(g != null ? g : "").split(":"), K = (Ye = B == null ? void 0 : B.trim().toLowerCase()) != null ? Ye : "";
      return K ? !Xe || Xe.has(K) ? K : (x && ie && !q.has(K) && (q.add(K), console.warn(`[MarkdownCodeBlockNode] Language "${K}" not preloaded in stream-markdown; falling back to plaintext.`)), "plaintext") : "plaintext";
    }
    function wt(g, x) {
      return z(this, null, function* () {
        if (!I)
          return;
        const B = $t(x, !!(g && g.length));
        try {
          yield I.updateCode(g, B);
        } catch (K) {
          B !== "plaintext" ? (ie && !ve.has(B) && (ve.add(B), console.warn(`[MarkdownCodeBlockNode] Failed to render language "${B}", retrying as plaintext.`, K)), yield I.updateCode(g, "plaintext")) : ie && console.warn("[MarkdownCodeBlockNode] Failed to render code block even as plaintext.", K);
        }
      });
    }
    function St() {
      return z(this, null, function* () {
        if (!J)
          try {
            const g = yield import("stream-markdown");
            J = g.createShikiStreamRenderer, Y = g.registerHighlight, Le = g.disposeHighlighter;
            const x = Array.isArray(g.defaultLanguages) ? g.defaultLanguages : void 0;
            Xe = x ? new Set(x.map((B) => B.toLowerCase())) : void 0, Y == null || Y({ themes: t.themes });
          } catch (g) {
            console.warn("[MarkdownCodeBlockNode] stream-markdown not available:", g);
          }
      });
    }
    function ke() {
      return z(this, null, function* () {
        if (ne.value) {
          Le(), I == null || I.dispose(), I = void 0, H.value = !1;
          return;
        }
        if (yield St(), !v.value || !b.value) {
          W(t.node.code);
          return;
        }
        if (Y == null || Y({ themes: t.themes }), !I && J && (I = J(b.value, {
          theme: Ee()
        }), H.value = !0), !I) {
          W(t.node.code);
          return;
        }
        if (t.stream === !1 && t.loading) {
          W(t.node.code);
          return;
        }
        W(t.node.code), yield wt(t.node.code, d.value), yield Se();
      });
    }
    ke(), io(() => {
      ke();
    }), U(() => t.themes, () => z(null, null, function* () {
      Y && Y({ themes: t.themes });
    })), U(() => t.loading, (g) => {
      g || ke();
    }), U(() => [t.node.code, t.node.language], (B) => z(null, [B], function* ([g, x]) {
      if (x !== d.value && (d.value = x.trim()), !v.value || !b.value) {
        W(g);
        return;
      }
      if (ne.value) {
        Le(), I == null || I.dispose();
        return;
      }
      I || (W(g), yield ke()), !(!I || !g) && (t.stream === !1 && t.loading || (W(g), yield wt(g, x), yield Se()));
    }));
    const Ce = U(
      () => [t.darkTheme, t.lightTheme],
      () => z(null, null, function* () {
        if (!(!v.value || !b.value)) {
          if (ne.value)
            return Le(), I == null || I.dispose(), Ce();
          I || (yield ke()), I == null || I.setTheme(Ee());
        }
      })
    );
    U(() => t.node.code, () => z(null, null, function* () {
      if (f.value || !S.value)
        return;
      yield he();
      const g = v.value;
      g && g.scrollHeight > g.clientHeight && (g.scrollTop = g.scrollHeight);
    }));
    function yt(g, x = 50) {
      return g.scrollHeight - g.scrollTop - g.clientHeight <= x;
    }
    function jt() {
      const g = v.value;
      if (!g || f.value)
        return;
      const x = g.scrollTop;
      x < ee.value ? S.value = !1 : yt(g) && (S.value = !0), ee.value = x;
    }
    function dt() {
      return z(this, null, function* () {
        try {
          typeof navigator != "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText == "function" && (yield navigator.clipboard.writeText(t.node.code)), c.value = !0, s("copy", t.node.code), setTimeout(() => {
            c.value = !1;
          }, 1e3);
        } catch (g) {
          console.error("Copy failed:", g);
        }
      });
    }
    function nt(g) {
      const x = g;
      return !x || x.disabled;
    }
    function xe(g, x, B = "top") {
      if (nt(g.currentTarget))
        return;
      const K = g, Ye = (K == null ? void 0 : K.clientX) != null && (K == null ? void 0 : K.clientY) != null ? { x: K.clientX, y: K.clientY } : void 0;
      Dn(g.currentTarget, x, B, !1, Ye, t.isDark);
    }
    function Q() {
      uo();
    }
    function be(g) {
      if (nt(g.currentTarget))
        return;
      const x = c.value ? a("common.copied") || "Copied" : a("common.copy") || "Copy", B = g, K = (B == null ? void 0 : B.clientX) != null && (B == null ? void 0 : B.clientY) != null ? { x: B.clientX, y: B.clientY } : void 0;
      Dn(g.currentTarget, x, "top", !1, K, t.isDark);
    }
    function le() {
      f.value = !f.value;
      const g = v.value;
      g && (f.value ? (g.style.maxHeight = "none", g.style.overflow = "visible") : (g.style.maxHeight = "500px", g.style.overflow = "auto", S.value = !0, he(() => {
        g.scrollHeight > g.clientHeight && (g.scrollTop = g.scrollHeight);
      })));
    }
    function $e() {
      w.value = !w.value;
    }
    function ot() {
      const g = Math.min(Lo, T.value + Ro);
      T.value = g;
    }
    function kt() {
      const g = Math.max(Eo, T.value - Ro);
      T.value = g;
    }
    function Re() {
      T.value = j.value;
    }
    function Ft() {
      if (!D.value)
        return;
      const g = (d.value || t.node.language).toLowerCase(), x = g === "html" ? "text/html" : "image/svg+xml", B = g === "html" ? "HTML Preview" : "SVG Preview";
      s("previewCode", {
        type: x,
        content: t.node.code,
        title: B
      });
    }
    return (g, x) => ne.value ? (m(), ye($(dn), {
      key: 0,
      node: e.node,
      "is-dark": t.isDark,
      loading: t.loading
    }, null, 8, ["node", "is-dark", "loading"])) : (m(), y("div", {
      key: 1,
      style: ut(We.value),
      class: O(["code-block-container my-4 rounded-lg border overflow-hidden shadow-sm", [t.isDark ? "border-gray-700/30 bg-gray-900" : "border-gray-200 bg-white", t.isDark ? "is-dark" : ""]])
    }, [
      t.showHeader ? (m(), y("div", qs, [
        Tt(g.$slots, "header-left", {}, () => [
          h("div", Zs, [
            h("span", {
              class: "icon-slot h-4 w-4 flex-shrink-0",
              innerHTML: de.value
            }, null, 8, Gs),
            h("span", Js, se(G.value), 1)
          ])
        ], !0),
        Tt(g.$slots, "header-right", {}, () => [
          h("div", Qs, [
            h("button", {
              type: "button",
              class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
              "aria-pressed": w.value,
              onClick: $e,
              onMouseenter: x[0] || (x[0] = (B) => xe(B, w.value ? $(a)("common.expand") || "Expand" : $(a)("common.collapse") || "Collapse")),
              onFocus: x[1] || (x[1] = (B) => xe(B, w.value ? $(a)("common.expand") || "Expand" : $(a)("common.collapse") || "Collapse")),
              onMouseleave: Q,
              onBlur: Q
            }, [
              (m(), y("svg", {
                style: ut({ rotate: w.value ? "0deg" : "90deg" }),
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24",
                class: "w-3 h-3"
              }, [...x[17] || (x[17] = [
                h("path", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m9 18l6-6l-6-6"
                }, null, -1)
              ])], 4))
            ], 40, el),
            t.showFontSizeButtons && t.enableFontSizeControl ? (m(), y(ue, { key: 0 }, [
              h("button", {
                type: "button",
                class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
                disabled: Number.isFinite(T.value) ? T.value <= Eo : !1,
                onClick: x[2] || (x[2] = (B) => kt()),
                onMouseenter: x[3] || (x[3] = (B) => xe(B, $(a)("common.decrease") || "Decrease")),
                onFocus: x[4] || (x[4] = (B) => xe(B, $(a)("common.decrease") || "Decrease")),
                onMouseleave: Q,
                onBlur: Q
              }, [...x[18] || (x[18] = [
                h("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "aria-hidden": "true",
                  role: "img",
                  width: "1em",
                  height: "1em",
                  viewBox: "0 0 24 24",
                  class: "w-3 h-3"
                }, [
                  h("path", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M5 12h14"
                  })
                ], -1)
              ])], 40, tl),
              h("button", {
                type: "button",
                class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
                disabled: !re.value || T.value === j.value,
                onClick: x[5] || (x[5] = (B) => Re()),
                onMouseenter: x[6] || (x[6] = (B) => xe(B, $(a)("common.reset") || "Reset")),
                onFocus: x[7] || (x[7] = (B) => xe(B, $(a)("common.reset") || "Reset")),
                onMouseleave: Q,
                onBlur: Q
              }, [...x[19] || (x[19] = [
                h("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "aria-hidden": "true",
                  role: "img",
                  width: "1em",
                  height: "1em",
                  viewBox: "0 0 24 24",
                  class: "w-3 h-3"
                }, [
                  h("g", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2"
                  }, [
                    h("path", { d: "M3 12a9 9 0 1 0 9-9a9.75 9.75 0 0 0-6.74 2.74L3 8" }),
                    h("path", { d: "M3 3v5h5" })
                  ])
                ], -1)
              ])], 40, nl),
              h("button", {
                type: "button",
                class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
                disabled: Number.isFinite(T.value) ? T.value >= Lo : !1,
                onClick: x[8] || (x[8] = (B) => ot()),
                onMouseenter: x[9] || (x[9] = (B) => xe(B, $(a)("common.increase") || "Increase")),
                onFocus: x[10] || (x[10] = (B) => xe(B, $(a)("common.increase") || "Increase")),
                onMouseleave: Q,
                onBlur: Q
              }, [...x[20] || (x[20] = [
                h("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "aria-hidden": "true",
                  role: "img",
                  width: "1em",
                  height: "1em",
                  viewBox: "0 0 24 24",
                  class: "w-3 h-3"
                }, [
                  h("path", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M5 12h14m-7-7v14"
                  })
                ], -1)
              ])], 40, ol)
            ], 64)) : fe("", !0),
            t.showCopyButton ? (m(), y("button", {
              key: 1,
              type: "button",
              class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
              "aria-label": c.value ? $(a)("common.copied") || "Copied" : $(a)("common.copy") || "Copy",
              onClick: dt,
              onMouseenter: x[11] || (x[11] = (B) => be(B)),
              onFocus: x[12] || (x[12] = (B) => be(B)),
              onMouseleave: Q,
              onBlur: Q
            }, [
              c.value ? (m(), y("svg", il, [...x[22] || (x[22] = [
                h("path", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M20 6L9 17l-5-5"
                }, null, -1)
              ])])) : (m(), y("svg", al, [...x[21] || (x[21] = [
                h("g", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2"
                }, [
                  h("rect", {
                    width: "14",
                    height: "14",
                    x: "8",
                    y: "8",
                    rx: "2",
                    ry: "2"
                  }),
                  h("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
                ], -1)
              ])]))
            ], 40, rl)) : fe("", !0),
            t.showExpandButton ? (m(), y("button", {
              key: 2,
              type: "button",
              class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
              "aria-pressed": f.value,
              onClick: le,
              onMouseenter: x[13] || (x[13] = (B) => xe(B, f.value ? $(a)("common.collapse") || "Collapse" : $(a)("common.expand") || "Expand")),
              onFocus: x[14] || (x[14] = (B) => xe(B, f.value ? $(a)("common.collapse") || "Collapse" : $(a)("common.expand") || "Expand")),
              onMouseleave: Q,
              onBlur: Q
            }, [
              f.value ? (m(), y("svg", ll, [...x[23] || (x[23] = [
                h("path", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 3h6v6m0-6l-7 7M3 21l7-7m-1 7H3v-6"
                }, null, -1)
              ])])) : (m(), y("svg", cl, [...x[24] || (x[24] = [
                h("path", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m14 10l7-7m-1 7h-6V4M3 21l7-7m-6 0h6v6"
                }, null, -1)
              ])]))
            ], 40, sl)) : fe("", !0),
            D.value && t.showPreviewButton ? (m(), y("button", {
              key: 3,
              type: "button",
              class: "code-action-btn p-2 text-xs rounded-md transition-colors hover:bg-[var(--vscode-editor-selectionBackground)]",
              "aria-label": $(a)("common.preview") || "Preview",
              onClick: Ft,
              onMouseenter: x[15] || (x[15] = (B) => xe(B, $(a)("common.preview") || "Preview")),
              onFocus: x[16] || (x[16] = (B) => xe(B, $(a)("common.preview") || "Preview")),
              onMouseleave: Q,
              onBlur: Q
            }, [...x[25] || (x[25] = [
              h("svg", {
                "data-v-3d59cc65": "",
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24",
                class: "w-3 h-3"
              }, [
                h("g", {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2"
                }, [
                  h("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0" }),
                  h("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  })
                ])
              ], -1)
            ])], 40, ul)) : fe("", !0)
          ])
        ], !0)
      ])) : fe("", !0),
      Rn(h("div", {
        ref_key: "codeBlockContent",
        ref: v,
        class: "code-block-content",
        style: ut(ce.value),
        onScroll: jt
      }, [
        h("div", {
          ref_key: "rendererTarget",
          ref: b,
          class: "code-block-render"
        }, null, 512),
        H.value ? fe("", !0) : (m(), y("div", {
          key: 0,
          class: "code-fallback-plain",
          innerHTML: C.value
        }, null, 8, dl))
      ], 36), [
        [Nn, !w.value && (e.stream ? !0 : !e.loading)]
      ]),
      Rn(h("div", ml, [
        Tt(g.$slots, "loading", {
          loading: e.loading,
          stream: e.stream
        }, () => [
          x[26] || (x[26] = h("div", { class: "loading-skeleton" }, [
            h("div", { class: "skeleton-line" }),
            h("div", { class: "skeleton-line" }),
            h("div", { class: "skeleton-line short" })
          ], -1))
        ], !0)
      ], 512), [
        [Nn, !e.stream && e.loading]
      ])
    ], 6));
  }
}), Zn = /* @__PURE__ */ Z(fl, [["__scopeId", "data-v-34bf55f7"]]);
Zn.install = (e) => {
  e.component(Zn.__name, Zn);
};
let st = null, Ot = null, No = !1;
const He = /* @__PURE__ */ new Map(), Rt = /* @__PURE__ */ new Map(), Zo = 200;
let Qt = 5;
const Zt = /* @__PURE__ */ new Set();
function An() {
  if (He.size < Qt && Zt.size) {
    const e = Array.from(Zt);
    Zt.clear();
    for (const n of e)
      try {
        n();
      } catch (t) {
      }
  }
}
let Ct = null;
function Vl(e) {
  st = e, Ot = null, st.onmessage = (n) => {
    const { id: t, html: s, error: a } = n.data, d = He.get(t);
    if (d)
      if (He.delete(t), clearTimeout(d.timeoutId), An(), a)
        d.reject(new Error(a));
      else {
        const { content: c, displayMode: f } = n.data;
        if (c) {
          const w = `${f ? "d" : "i"}:${c}`;
          if (Rt.set(w, s), Rt.size > Zo) {
            const v = Rt.keys().next().value;
            Rt.delete(v);
          }
        }
        d.resolve(s);
      }
  }, st.onerror = (n) => {
    console.error("[katexWorkerClient] Worker error:", n);
    for (const [t, s] of He.entries())
      clearTimeout(s.timeoutId), s.reject(new Error(`Worker error: ${n.message}`));
    He.clear(), An();
  };
}
function Ol() {
  var e;
  st && ((e = st.terminate) == null || e.call(st)), st = null, Ot = null;
}
function hl() {
  return st || (Ot = new Error("[katexWorkerClient] No worker instance set. Please inject a Worker via setKaTeXWorker()."), Ot.name = "WorkerInitError", Ot.code = "WORKER_INIT_ERROR", null);
}
function Kl(e) {
  No = !!e, st && st.postMessage({ type: "init", debug: No });
}
function vl(e, n = !0, t = 2e3, s) {
  return z(this, null, function* () {
    const a = performance.now();
    if (!Wo()) {
      const w = new Error("KaTeX rendering disabled");
      return w.name = "KaTeXDisabled", w.code = "KATEX_DISABLED", Promise.reject(w);
    }
    if (Ot)
      return Promise.reject(Ot);
    const d = `${n ? "d" : "i"}:${e}`, c = Rt.get(d);
    if (c)
      return Ct && Ct.recordRender({
        type: "cache-hit",
        duration: performance.now() - a,
        formulaLength: e.length,
        timestamp: Date.now(),
        success: !0
      }), Promise.resolve(c);
    const f = hl();
    if (!f)
      return Promise.reject(Ot);
    if (He.size >= Qt) {
      const w = new Error("Worker busy");
      return w.name = "WorkerBusy", w.code = "WORKER_BUSY", w.busy = !0, w.inFlight = He.size, w.max = Qt, Ct && Ct.recordRender({
        type: "worker",
        duration: performance.now() - a,
        formulaLength: e.length,
        timestamp: Date.now(),
        success: !1,
        error: "busy"
      }), Promise.reject(w);
    }
    return new Promise((w, v) => {
      if (s != null && s.aborted) {
        const T = new Error("Aborted");
        T.name = "AbortError", v(T);
        return;
      }
      const b = Math.random().toString(36).slice(2), C = globalThis.setTimeout(() => {
        He.delete(b);
        const T = new Error("Worker render timed out");
        T.name = "WorkerTimeout", T.code = "WORKER_TIMEOUT", Ct && Ct.recordRender({
          type: "worker",
          duration: performance.now() - a,
          formulaLength: e.length,
          timestamp: Date.now(),
          success: !1,
          error: "timeout"
        }), v(T), An();
      }, t), H = () => {
        globalThis.clearTimeout(C), He.has(b) && He.delete(b);
        const T = new Error("Aborted");
        T.name = "AbortError", v(T), An();
      };
      s && s.addEventListener("abort", H, { once: !0 });
      const A = w, S = v, ee = (T) => {
        Ct && Ct.recordRender({
          type: "worker",
          duration: performance.now() - a,
          formulaLength: e.length,
          timestamp: Date.now(),
          success: !0
        }), A(T);
      }, j = (T) => {
        Ct && Ct.recordRender({
          type: "worker",
          duration: performance.now() - a,
          formulaLength: e.length,
          timestamp: Date.now(),
          success: !1,
          error: (T == null ? void 0 : T.message) || String(T)
        }), S(T);
      };
      He.set(b, { resolve: ee, reject: j, timeoutId: C }), f.postMessage({ id: b, content: e, displayMode: n });
    });
  });
}
function Fl(e, n = !0, t) {
  const s = `${n ? "d" : "i"}:${e}`;
  if (Rt.set(s, t), Rt.size > Zo) {
    const a = Rt.keys().next().value;
    Rt.delete(a);
  }
}
function Wl() {
  return { inFlight: He.size, max: Qt };
}
function Xl(e) {
  Number.isFinite(e) && e > 0 && (Qt = Math.floor(e));
}
const pl = "WORKER_BUSY";
function Yl() {
  return He.size >= Qt;
}
function gl(e = 2e3, n) {
  return He.size < Qt ? Promise.resolve() : new Promise((t, s) => {
    let a = !1, d;
    const c = () => {
      a || (a = !0, d && globalThis.clearTimeout(d), Zt.delete(c), t());
    };
    if (Zt.add(c), d = globalThis.setTimeout(() => {
      if (a)
        return;
      a = !0, Zt.delete(c);
      const f = new Error("Wait for worker slot timed out");
      f.name = "WorkerBusyTimeout", f.code = "WORKER_BUSY_TIMEOUT", s(f);
    }, e), queueMicrotask(() => An()), n) {
      const f = () => {
        if (a)
          return;
        a = !0, d && globalThis.clearTimeout(d), Zt.delete(c);
        const w = new Error("Aborted");
        w.name = "AbortError", s(w);
      };
      n.aborted ? f() : n.addEventListener("abort", f, { once: !0 });
    }
  });
}
const Nt = {
  timeout: 2e3,
  waitTimeout: 1500,
  backoffMs: 30,
  maxRetries: 1
};
function Ul(e) {
  e.timeout != null && (Nt.timeout = Math.max(0, Math.floor(e.timeout))), e.waitTimeout != null && (Nt.waitTimeout = Math.max(0, Math.floor(e.waitTimeout))), e.backoffMs != null && (Nt.backoffMs = Math.max(0, Math.floor(e.backoffMs))), e.maxRetries != null && (Nt.maxRetries = Math.max(0, Math.floor(e.maxRetries)));
}
function ql() {
  return oe({}, Nt);
}
function Zl(s) {
  return z(this, arguments, function* (e, n = !0, t = {}) {
    var b, C, H, A;
    if (!Wo()) {
      const S = new Error("KaTeX rendering disabled");
      throw S.name = "KaTeXDisabled", S.code = "KATEX_DISABLED", S;
    }
    const a = (b = t.timeout) != null ? b : Nt.timeout, d = (C = t.waitTimeout) != null ? C : Nt.waitTimeout, c = (H = t.backoffMs) != null ? H : Nt.backoffMs, f = (A = t.maxRetries) != null ? A : Nt.maxRetries, w = t.signal;
    let v = 0;
    for (; ; ) {
      if (w != null && w.aborted) {
        const S = new Error("Aborted");
        throw S.name = "AbortError", S;
      }
      try {
        return yield vl(e, n, a, w);
      } catch (S) {
        if ((S == null ? void 0 : S.code) !== pl || v >= f)
          throw S;
        if (v++, yield gl(d, w).catch(() => {
        }), w != null && w.aborted) {
          const ee = new Error("Aborted");
          throw ee.name = "AbortError", ee;
        }
        c > 0 && (yield new Promise((ee) => globalThis.setTimeout(ee, c * v)));
      }
    }
  });
}
const wl = vn(() => import("./index-CpUcwcBM.js")), yl = vn(() => import("./index-Bg9riGZT.js")), kl = vn(() => import("./index-B90_xyRN.js")), xl = {
  AdmonitionNode: Ln,
  BlockquoteNode: Mn,
  CheckboxNode: _t,
  CodeBlockNode: wl,
  DefinitionListNode: Cn,
  EmojiNode: je,
  FootnoteNode: _n,
  FootnoteReferenceNode: De,
  FootnoteAnchorNode: un,
  HardBreakNode: Jt,
  HeadingNode: po,
  HtmlInlineNode: Ae,
  HighlightNode: et,
  ImageNode: Pt,
  InlineCodeNode: ze,
  PreCodeNode: mn,
  InsertNode: Qe,
  LinkNode: Ke,
  ListItemNode: Bn,
  ListNode: In,
  MathBlockNode: yl,
  MathInlineNode: kl,
  MermaidBlockNode: dn,
  ParagraphNode: $n,
  StrikethroughNode: Oe,
  StrongNode: Ve,
  SubscriptNode: Je,
  SuperscriptNode: Ge,
  TableNode: Sn,
  TextNode: Ie,
  ThematicBreakNode: En,
  ReferenceNode: Pe,
  MarkdownCodeBlockNode: Zn
}, Gl = {
  install(e, n) {
    Object.entries(xl).forEach(([t, s]) => {
      e.component(t, s);
    }), n != null && n.getLanguageIcon && Fs(n.getLanguageIcon), n != null && n.mathOptions && rr(n.mathOptions);
  }
};
export {
  Fo as $,
  Ln as A,
  Mn as B,
  _t as C,
  Cn as D,
  je as E,
  un as F,
  ze as G,
  Jt as H,
  Pt as I,
  Qe as J,
  Wo as K,
  Sa as L,
  Ke as M,
  Bn as N,
  In as O,
  Zn as P,
  lt as Q,
  yl as R,
  kl as S,
  dn as T,
  $n as U,
  Pe as V,
  pl as W,
  Bl as X,
  _l as Y,
  $l as Z,
  Z as _,
  fo as a,
  Yo as a0,
  Oe as a1,
  Ve as a2,
  Je as a3,
  Ge as a4,
  Sn as a5,
  Ie as a6,
  En as a7,
  Gl as a8,
  Fs as a9,
  Vl as aa,
  Ol as ab,
  Kl as ac,
  vl as ad,
  Wl as ae,
  Xl as af,
  Yl as ag,
  gl as ah,
  Ul as ai,
  ql as aj,
  Nl as ak,
  Hl as al,
  jl as am,
  Ha as an,
  ja as ao,
  Dl as ap,
  Al as aq,
  Aa as ar,
  za as as,
  Bo as at,
  Ys as b,
  mn as c,
  Dn as d,
  Zl as e,
  vo as f,
  zl as g,
  uo as h,
  Fl as i,
  Il as j,
  wl as k,
  Us as l,
  El as m,
  qo as n,
  Rl as o,
  Sl as p,
  Ll as q,
  Pl as r,
  Ia as s,
  _n as t,
  mo as u,
  De as v,
  Bt as w,
  po as x,
  et as y,
  Ae as z
};
